/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable max-len */
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, LOCALE_ID, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { WallboardsService } from './wallboards.service';
import {
    WallboardGridster, WallboardSlideGridster, WallboardModule, ModuleType, SlideModuleTypes, WallboardModuleDetailsGridster, ModuleListWrapperObj, RacingSetupTransferObj, GuageSettingsTransferObj,
    ThermometerSettingsTransferObj, TextSettingsTransferObj, ImageSettingsTransferObj, TopSettingsTransferObj, KpiSettingsTransferObj, SummarySettingsTransferObj, VideoSettingsTransferObj, LeaderboardSetupObj,
    SpotlightSetupObj, CurrentAgentStatesSettingTransferObj, WallboardGameSetupObj, ChallengesSetupObj, MarketplaceSetupObj, CounterSettingsTransferObj, LoginListObj, MetricEventObj, WallboardTextTruncateRenderer,
    ProductCategory, WallboardSlideSettings, IntervalChartSettingsTransferObj,
    ModulesUsingSlideout
} from './wallboards.model';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { GridOptions, RowNode, GridApi } from 'ag-grid-community';
import { formatDate } from '@angular/common';
import { IWindowService } from 'angular';
import { UserProfileDTO } from '../admin/user/user-admin.model';
import { Group } from 'src/AngularJS/Models/group.model';
import { NavigationService } from '../navigation/navigation.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { CompactType, DisplayGrid, GridsterComponent, GridsterConfig, GridsterItemComponent, GridsterItemComponentInterface, GridType } from 'angular-gridster2';
import { DomSanitizer } from '@angular/platform-browser';
import OverlayScrollbars from 'overlayscrollbars';
import { YouTubeInfoService } from '../reusables/services/youtube-info.service';
import { MetricSelectorComponent } from '../reusables/metric-selector/metric-selector.component';
import { MetricSelectorService } from '../reusables/metric-selector/metric-selector.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOW, ModuleManagerDateRangeInfo } from '../../shared/models/module-manager/module-manager-settings.models';
import SlideoutSettingsManager from '../../shared/models/slideout-settings-manager';
import { BaseGroupType } from '../reusables/models/group-type.model';
import { AttributeType } from '../../shared/models/attribute-selector.models';
import { isChallengeAllowedOnWallboard } from '../gamification/command-center/models/challenge.model';
import { EditorOptions } from 'tinymce';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
    selector: 'wallboards',
    templateUrl: './wallboards.component.html',
    styleUrls: ['./wallboards.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('visibility', [
            state('shown', style({
                display: 'flex',
                right: '0px',
            })),
            state('hidden', style({
                display: 'none',
                right: '-392px',
            })),
            transition('shown <=> hidden', animate('1s ease')),
        ]),
    ],
})
export class WallboardsComponent implements OnInit {
    @ViewChild('gridCanvas', { read: GridsterComponent }) gridster: GridsterComponent;
    @ViewChild('gridCanvas', { read: ElementRef }) gridsterElement: ElementRef<HTMLElement>;

    // do not use directly - use from config service.isCxOne instead
    @Input()
    set isCxone(value: string) {
        this.cvConfigurationService.isCxOne = value === "true";
    }

    public isDataLoading = false;
    public isDataSaving = false;
    public areControlsLoading = false;
    public controlsLoadId = 0;
    public areModuleStatesLoading = false;
    public moduleSettingsLoadId = 0;
    public isVideoInfoLoading = false;
    public areGamesLoading = false;
    public areChallengesLoading = false;
    public areProductsLoading = false;

    private readonly LOCALIZATION_SECTION = `Wallboard_Management`;
    private readonly LOCALIZATION_MESSAGES = `Wallboard_Management_Messages`;
    private readonly LOCALIZATION_DISPLAY = `Wallboard_Display`;
    private readonly LOCALIZATION_MARKETPLACE = `MarketPlace_Management`;

    public wallboards: WallboardGridster[] = [];
    public folders: string[] = [];
    public slideModules: WallboardModule[] = [];
    public domain = "";
    public showAssignOption = false;
    public assignDialogOpen = false;
    public assignedWallboard: WallboardGridster = null;
    public assignedGroups = { wallboardID: 0, emp: [] };

    public cvAngularDateFormat: string = window[`CVAngularDateFormat`];
    public cvAngularDateTimeFormat: string = window[`CVAngularDateTimeFormat`];
    public formatDate = formatDate;
    public localization: Map<string, string>;
    public localizationMessages: Map<string, string>;
    public localizationDisplay: Map<string, string>;
    public localizationMarketplace: Map<string, string>;
    public gridOptions: GridOptions = null;
    public gridApi: GridApi = null;
    public filterValue = "";

    public detailsView = false;
    public editedWallboardOriginal: WallboardGridster = null;
    public editedWallboard: WallboardGridster = null;
    public selectedSlideIndex = -1;
    public selectedSlideType: ModuleType | number = -1;
    public selectedModuleIndex = -1;
    public selectedModuleType: ModuleType | number = ModuleType.Custom;
    public slideToAdd: WallboardSlideGridster = null;
    public tab = 0;
    public desiredTab = 0;

    public uploadedBackgroundIds: number[] = null;
    public presetBackgroundIds = [-91, -67, -68, -69, -70, -71, -72, -73, -74, -75, -76, -77, -78, -79, -80, -81, -82, -83, -84, -85, -86, -87, -88, -89, -90];
    public racingThemes = [`Random`, `Horse Derby`, `Motocross`, `Rocket Race`, `Swim Meet`, `ATV Racing`, `Boat Racing`, `Drag Racing`, `Formula One Racing`, `Jet Racing`, `Truck Racing`, `Raptor Racing`,
        `Snail Racing`, `Snowmobile Racing`, `Street Racing`, `Tortoise And Hare Racing`, `UFO Racing`, `Train Racing`, `Christmas Tree Racing`, `Cupid Racing`, `Easter Bunny Racing`, `Elderly Racing`, `Fish Racing`,
        `Robot Racing`, `Sleigh Ride Racing`, `St Patricks Day Racing`, `Super Racing`, `Turkey Racing`, `Zombie Racing`, `St Patricks Day Racing 2`, `Thanksgiving Racing 1`, `Thanksgiving Racing 2`, `Easter Racing 2`,
        `Valentine Racing 1`, `Candy Land Racing`, `Christmas Carol Racing`, `Halloween Racing 1`, `Jungle Racing 1`, `Jungle Racing 2`, `Mask Racing`, `Plant Racing`];
    public transitionIds = [0, 4, 5, 6, 8, 9, 10, 11];
    public fullImgWidthAuto = false;
    public centerBoxWidth = 0;
    public centerBoxHeight = 0;
    public summaryPreviewItems: number[];

    scrollOptions: OverlayScrollbars.PartialOptions = {
        scrollbars: {
            autoHide: "leave",
            autoHideDelay: 100,
            visibility: "auto"
        },
    };

    tinyTextConfig: Partial<EditorOptions> = {
        width: 800, height: 250, menubar: false, statusbar: false, invalid_elements: 'script',
        plugins: ['lists'],
        fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt 42pt 50pt 55pt 60pt',
        toolbar: 'fontselect | fontsizeselect | undo redo | bold italic underline forecolor | numlist bullist | alignleft aligncenter alignright alignjustify',
        font_formats: 'Lato=lato,verdana;Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;' +
            'Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;' +
            'Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;' +
            'Webdings=webdings;Wingdings=wingdings,zapf dingbats',
        base_url: '../dist/angular/tinymce', suffix: '.min',
        paste_data_images: false,
        automatic_uploads: false,
        images_upload_handler: function() {
            return Promise.resolve('');
        },
        paste_preprocess: function (plugin, args) {
            if (args.content) {
                args.content = TextSettingsTransferObj.getTextValueWithoutImage(args.content);
            }
        }
    };

    public racingSetupObj: RacingSetupTransferObj = null;
    public imageSetupObj: ImageSettingsTransferObj = null; // Is used for both slides and custom modules
    public summarySetupObj: SummarySettingsTransferObj = null; // Is used for both slides and custom modules
    public intervalChartSetupObj: IntervalChartSettingsTransferObj = null;
    public videoSetupObj: VideoSettingsTransferObj = null;
    get videoId(): string {
        if (!this.videoSetupObj?.VideoURL)
            return "";
        else if (this.videoSetupObj?.VideoURL.length == 11)
            return this.videoSetupObj.VideoURL;
        else {
            const match = this.videoSetupObj.VideoURL.match('[\\?&]v=([^&#]*)');
            return !match ? "" : match[1];
        }
    }
    public leaderboardSetupObj: LeaderboardSetupObj = null;
    public spotlightSetupObj: SpotlightSetupObj = null;
    public currentAgentStatesSetupObj: CurrentAgentStatesSettingTransferObj = null;
    public wallboardGameSetupObj: WallboardGameSetupObj = null;
    public challengesSetupObj: ChallengesSetupObj = null;
    public marketplaceSetupObj: MarketplaceSetupObj = null;
    public gaugeSetupObj: GuageSettingsTransferObj = null;
    public thermometerSetupObj: ThermometerSettingsTransferObj = null;
    public textSetupObj: TextSettingsTransferObj = null;
    public topSetupObj: TopSettingsTransferObj = null;
    public counterSetupObj: CounterSettingsTransferObj = null;
    public kpiSetupObj: KpiSettingsTransferObj = null;

    public newSlideModalOpen = false;
    public wallboardCopyName = "";
    public slideSettingsModalOpen = false;
    public slideSettingsModalSection = 1;
    public intervalMin = `00`;
    public intervalSec = `00`;
    public selectedMetricInfo: MetricEventObj[] = [];

    public loginList: LoginListObj[] = [];
    public loginListCreatorId = -1;
    public videoInfo;
    public player;
    public spotlightLoadedLoginId = -1;
    public spotlightLoadedProfile: UserProfileDTO;
    public spotlightSearch = "";
    public spotlightCroppedImage: string;
    public spotlightCropReset = true;
    public spotlightOriginalImageId: number;
    public spotlightBadges: any[] = null; //Image[]
    public gameFolders = [];
    public gamesList;
    public selectedGame = [];
    public gameSearch = "";
    public chartPreview: any;
    public activeChallenges = []; //CurrentChallengeWSObj[]
    public activeChallengesFiltered = []; //CurrentChallengeWSObj[]
    public marketplaceSearch = "";
    public marketplaceFilterSale = false;
    public marketplaceFilterFeatured = false;
    public marketplaceFilterBestSeller = false;
    public marketplaceCategories: ProductCategory[] = [];
    public marketplaceFilterCategory: ProductCategory = null;
    public marketplaceFilterSubCategory = "";
    public marketplaceTitle = `Marketplace`;
    public marketplaceView = 1;
    public marketplaceProducts: any[] = null; //PointStoreProduct[]
    public selectedProducts = [];
    public gridOptionsMarketplace: GridOptions = null;
    public gridApiMarketplace: GridApi = null;

    public gridsterOptions: GridsterConfig;
    public loadedModuleStates: ModuleListWrapperObj[] = [];
    public pendingModuleDeleteIndex = -1;
    public initialCustomSettings = false;
    public draggingModuleType: ModuleType = ModuleType.Custom;
    public dragEnterCount = 0;
    public placeholderModule: WallboardModuleDetailsGridster = null;
    public placeholderComponent: GridsterItemComponentInterface = null;

    public confirmationDialogOpen = 0;
    public confirmDeleteWallboard: WallboardGridster;
    public confirmDeactivateBackground = 0;

    public settingsModalOpen = false;

    public uploadBackgroundModalOpen = false;
    public uploadedBackground: string;

    public errorDialogOpen = false;
    public errorDialogKey = "";
    public errorDialogBody = "";

    public transitionPreview = false;
    public transitionType = -1;
    public transitionEvent;

    public lowerBoundFormatted = "";
    public alertFormatted = "";
    public valueFormatted = "";
    public racingStartFormatted = "";
    public racingFinishFormatted = "";

    public hasGamificationPackage;
    //Games not yet implemented: Top Team (8), Raffle (9) and Bracket tournament (10), remove once implemented
    public notImplementedGames = [8, 9, 10] 

    //For Settings Slideout
    public availableDateRanges: ModuleManagerDateRangeInfo[]; //needed for date range picker
    public dateRangeLoaded = false;
    public slideoutSettingsLoaded = false;
    public originalSlideSettings: WallboardSlideSettings = null;
    public slideSettings: WallboardSlideSettings = null;
    public slideoutSettingsOpen = false;
    // Module keys whose unsaved edits have already been reverted to their saved baseline this page session
    // (see revertUnsavedEditsOnFirstOpen). Lives only for the current page load.
    private slidesRevertedSinceLoad = new Set<string>();

    get SelectedModuleSetupObj(): GuageSettingsTransferObj | ThermometerSettingsTransferObj | TextSettingsTransferObj | TopSettingsTransferObj | ImageSettingsTransferObj | SummarySettingsTransferObj
        | IntervalChartSettingsTransferObj | CounterSettingsTransferObj | CurrentAgentStatesSettingTransferObj | KpiSettingsTransferObj | any {
        // It's not "great" practice to have "| any" in the return types, but these transfer objects can have very different properties, and that can make working with it difficult otherwise
        if (!this.slideSettingsModalOpen)
            return null;

        switch (this.selectedModuleType) {
            case ModuleType.Gauge:
                return this.gaugeSetupObj;
            case ModuleType.Thermometer:
                return this.thermometerSetupObj;
            case ModuleType.SummaryModule:
                return this.summarySetupObj;
            case ModuleType.IntervalChart:
                return this.intervalChartSetupObj;
            //case ModuleType.Achievement:
                //return this.achSetupObj;
            case ModuleType.Text:
                return this.textSetupObj;
            case ModuleType.ImageModule:
                return this.imageSetupObj;
            case ModuleType.Top:
                return this.topSetupObj;
            case ModuleType.AgentCounter:
                return this.counterSetupObj;
            case ModuleType.Kpi:
                return this.kpiSetupObj;
            default:
                return null;
        }
    }

    get SettingsModuleType(): ModuleType {
        return this.selectedModuleType != ModuleType.Custom ? this.selectedModuleType : this.selectedSlideType;
    }

    constructor(
        @Inject(LOCALE_ID) public locale: string,
        private cvLocalizationFactory: CVLocalizationService,
        @Inject('$window') private $window: IWindowService,
        public wallboardsService: WallboardsService,
        private agGridHelperService: AgGridHelperService,
        private navigationService: NavigationService,
        private youTubeInfoService: YouTubeInfoService,
        private sanitizer: DomSanitizer,
        private zone: NgZone,
        private metricSelectorService: MetricSelectorService,
        private cdr: ChangeDetectorRef,
        public cvConfigurationService: CvConfigurationService,
    ) { }

    ngOnInit() { // Bound values ("@Input()" above) are only valid in and after this function.
        let main = this.cvLocalizationFactory.GetSection(this.LOCALIZATION_SECTION).then(response => {
            this.localization = response;
        });
        let messages = this.cvLocalizationFactory.GetSection(this.LOCALIZATION_MESSAGES).then(response => {
            this.localizationMessages = response;
        });
        let display = this.cvLocalizationFactory.GetSection(this.LOCALIZATION_DISPLAY).then(response => {
            this.localizationDisplay = response;
        });
        let marketplace = this.cvLocalizationFactory.GetSection(this.LOCALIZATION_MARKETPLACE).then(response => {
            this.localizationMarketplace = response;
        });

        Promise.all([main, messages, display, marketplace]).then(_ => {
            this.setupAgGridAndGridster();
            this.loadWallboards();
            this.getGamificationPackageStatus(this.navigationService.companyId);
        });
    }

    isModuleWithSlideout(moduleType: ModuleType) {
        const modulesUsingSlideout: ModuleType[] = [...ModulesUsingSlideout];
        if (this.cvConfigurationService.isCxOne) {
            modulesUsingSlideout.splice(0, 1); // remove ModuleType.CurrentAgentStates
        }
        return modulesUsingSlideout.includes(moduleType);
    }

    getHeaderName(localizationKey: string): string {
        const header = this.localization.get(localizationKey);
        return this.cvConfigurationService.isCxOne ? header.toUpperCase() : header;
      }

    /**
     * Sets up AG Grid and Gridster objects.
     * */
    private setupAgGridAndGridster(): void {
        this.gridOptions = this.agGridHelperService.createGridOptions({
            columnDefs: [
                {
                    field: `FirstSlideType`,
                    colId: `PreviewImage`,
                    headerName: "",
                    cellRenderer: params => {
                        if (params.data.FirstSlideType == 2 && params.data.FirstSlideBackgroundID == -124)
                            return `<img alt="Image Not Available" style="height:48px" src="${this.getWallboardPreviewImageSrc(params.data)}" /><div class="d-flex justify-content-center position-absolute font-size-10 text-truncate" style="bottom:8px; width:84px">${this.localization.get("Random_Racing")}</div>`;

                        return `<img alt="Image Not Available" style="height:48px" src="${this.getWallboardPreviewImageSrc(params.data)}" />`;
                    },
                    cellClass: `d-flex align-items-center`,
                    menuTabs: [],
                    maxWidth: 110,
                },
                {
                    field: `WallboardName`,
                    colId: `WallboardName`,
                    headerName: this.getHeaderName('Name'),
                    onCellClicked: event => this.editWallboard(event.data),
                    cellRenderer: WallboardTextTruncateRenderer,
                    cellRendererParams:{isCxone:this.cvConfigurationService.isCxOne},
                    cellClass: `d-flex align-items-center color-cerulean clickable`,
                    sort: `asc`,
                    menuTabs: [],
                },
                {
                    field: `WallboardGroup`,
                    colId: `Folder`,
                    headerName: this.getHeaderName(`Add_Wallboard_Folder`),
                    cellRenderer: WallboardTextTruncateRenderer,
                    cellRendererParams:{isCxone:this.cvConfigurationService.isCxOne},
                    cellClass: `d-flex align-items-center`,
                    menuTabs: [`filterMenuTab`],
                },
                {
                    field: "CreatedDate",
                    colId: "CreatedDate",
                    headerName: this.getHeaderName("Date_Created"),
                    valueGetter: params => params.data[params.colDef.field] != null ? formatDate(params.data[params.colDef.field], this.cvAngularDateTimeFormat, this.locale) : null,
                    comparator: (dateA, dateB, nodeA: RowNode, nodeB: RowNode, reverse: boolean) => {
                        if (!nodeA.data.CreatedDate && !nodeB.data.CreatedDate)
                            return 0;
                        else if (!nodeA.data.CreatedDate && nodeB.data.CreatedDate)
                            return -1;
                        else if (nodeA.data.CreatedDate && !nodeB.data.CreatedDate)
                            return 1;
                        return new Date(nodeA.data.CreatedDate).compareTo(new Date(nodeB.data.CreatedDate));
                    },
                    cellRenderer: WallboardTextTruncateRenderer,
                    cellRendererParams:{isCxone:this.cvConfigurationService.isCxOne},
                    cellClass: `d-flex align-items-center`,
                    menuTabs: [],
                },
                {
                    field: "LastViewed",
                    colId: "LastViewed",
                    headerName: this.getHeaderName("Last_Viewed"),
                    valueGetter: params => params.data[params.colDef.field] != null ? formatDate(params.data[params.colDef.field], this.cvAngularDateTimeFormat, this.locale) : null,
                    comparator: (dateA, dateB, nodeA: RowNode, nodeB: RowNode, reverse: boolean) => {
                        if (!nodeA.data.LastViewed && !nodeB.data.LastViewed)
                            return 0;
                        else if (!nodeA.data.LastViewed && nodeB.data.LastViewed)
                            return -1;
                        else if (nodeA.data.LastViewed && !nodeB.data.LastViewed)
                            return 1;
                        return new Date(nodeA.data.LastViewed).compareTo(new Date(nodeB.data.LastViewed));
                    },
                    cellRenderer: params => {
                        const eGui = document.createElement(`div`);
                        eGui.className = `d-flex justify-content-between align-items-center w-100`;

                        const value = !params.value ? '' : params.value;

                        let str = `<div class="text-truncate"  style="${this.cvConfigurationService.isCxOne ? 'font-family: SOL Sans, sans-serif; font-size: 12px;' : ''}" title="${value}">${value}</div><div class="wallboardLandingIcons" style="display:none">`;
                        if (this.showAssignOption) {
                            str += `<div class="hoverContainer position-relative"><button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" id="wallboardAssign"><svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/admin-user.svg#admin-user"></use></svg></button>` +
                                `<div class="displayHover font-size-12 d-none px-1 border border-secondary position-absolute" style="top:-20px; right:16px; background-color:#FDFCF5; pointer-events:none; z-index:1; line-height:21px">${this.localization.get("Assign_Group")}</div></div>`;
                        }
                        str += `<div class="hoverContainer position-relative"><button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" id="wallboardEdit"><svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg></button>` +
                            `<div class="displayHover font-size-12 d-none px-1 border border-secondary position-absolute" style="top:-20px; right:16px; background-color:#FDFCF5; pointer-events:none; z-index:1; line-height:21px">${this.localization.get("Edit")}</div></div>` +
                            `<div class="hoverContainer position-relative"><button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" id="wallboardCopy"><svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/copy.svg#copy"></use></svg></button>` +
                            `<div class="displayHover font-size-12 d-none px-1 border border-secondary position-absolute" style="top:-20px; right:16px; background-color:#FDFCF5; pointer-events:none; z-index:1; line-height:21px">${this.localization.get("Copy_Button")}</div></div>` +
                            `<div class="hoverContainer position-relative"><button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" id="wallboardPlay"><svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/play.svg#play"></use></svg></button>` +
                            `<div class="displayHover font-size-12 d-none px-1 border border-secondary position-absolute" style="top:-20px; right:16px; background-color:#FDFCF5; pointer-events:none; z-index:1; line-height:21px">${this.localization.get("Play")}</div></div>` +
                            `<div class="hoverContainer position-relative"><button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" id="wallboardDelete"><svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg></button>` +
                            `<div class="displayHover font-size-12 d-none px-1 border border-secondary position-absolute" style="top:-20px; right:16px; background-color:#FDFCF5; pointer-events:none; z-index:1; line-height:21px">${this.localization.get("Delete")}</div></div>` +
                            `</div>`;
                        eGui.innerHTML = str;

                        if (this.showAssignOption)
                            $(eGui).find("#wallboardAssign")[0].addEventListener("click", (e: MouseEvent) => params.context?.assignWallboard(params.data));
                        $(eGui).find("#wallboardEdit")[0].addEventListener("click", (e: MouseEvent) => params.context?.editWallboard(params.data));
                        $(eGui).find("#wallboardCopy")[0].addEventListener("click", (e: MouseEvent) => params.context?.openCopyWallboardModal(params.data));
                        $(eGui).find("#wallboardPlay")[0].addEventListener("click", (e: MouseEvent) => params.context?.playWallboard(params.data));
                        $(eGui).find("#wallboardDelete")[0].addEventListener("click", (e: MouseEvent) => params.context?.promptDeleteWallboard(params.data));

                        return eGui;
                    },
                    cellClass: `d-flex align-items-center`,
                    menuTabs: [],
                }
            ],
            onGridReady: params => {
                this.gridApi = params.api;
                if (this.isDataLoading)
                    params.api.showLoadingOverlay();
                else if (this.wallboards)
                    params.api.setGridOption('rowData', this.wallboards);

                params.api.sizeColumnsToFit();
            },
            getRowId: ({ data: rowData }) => rowData.WallboardID,
            isExternalFilterPresent: () => this.filterValue.length > 0,
            doesExternalFilterPass: node => this.agGridHelperService.doesExternalFilterPass(node, this.filterValue),
            onGridSizeChanged: gridEvent => {
                if (gridEvent.clientWidth > 0)
                    gridEvent.api.sizeColumnsToFit();
            },
            onFilterChanged: () => {
                if (!this.isDataLoading) {
                    if (this.gridApi?.getDisplayedRowCount() === 0) {
                        this.gridApi?.showNoRowsOverlay();
                    }
                    else
                        this.gridApi?.hideOverlay();
                }
            },
            onColumnVisible: event => event.api.sizeColumnsToFit(),
            suppressRowClickSelection: true,
            suppressCellFocus: true,
            suppressMovableColumns: true,
            overlayNoRowsTemplate: `<span class="px-5 color-valyrianSteel font-size-24">${this.localization.get("No_Results_Found")}</span>`,
            loadingOverlayComponent: 'customLoadingOverlay',
            rowHeight: 72,
            rowClass: `font-size-14`,
            context: {
                assignWallboard: this.assignWallboard.bind(this),
                editWallboard: this.editWallboard.bind(this),
                openCopyWallboardModal: this.openCopyWallboardModal.bind(this),
                playWallboard: this.playWallboard.bind(this),
                promptDeleteWallboard: this.promptDeleteWallboard.bind(this)
            },
            components: {
                customLoadingOverlay: this.agGridHelperService.loadingOverlay,
            },
        });

        this.gridsterOptions = {
            gridType: GridType.Fit,
            minCols: 40,
            maxCols: 40,
            minRows: 40,
            maxRows: 40,
            compactType: CompactType.None,
            itemChangeCallback: (gridsterItem: WallboardModuleDetailsGridster) => {
                if (gridsterItem.placeholder || gridsterItem.WallboardModuleDetailsID == 0)
                    return;

                setTimeout(() => {
                    gridsterItem.PositionLeft = gridsterItem.x;
                    gridsterItem.PositionTop = gridsterItem.y;
                    gridsterItem.Height = gridsterItem.rows;
                    gridsterItem.Width = gridsterItem.cols;

                    this.wallboardsService.updateModulePosition(gridsterItem).then(voidObj => {
                        const index = this.slideToAdd.WallboardModuleDetails.indexOf(gridsterItem);
                        this.editedWallboard.Slides[this.selectedSlideIndex].WallboardModuleDetails[index] = angular.copy(gridsterItem);
                        this.editedWallboardOriginal.Slides[this.selectedSlideIndex].WallboardModuleDetails[index] = angular.copy(gridsterItem);
                    }).catch(error => {
                        console.log(error);
                    });
                });
            },
            displayGrid: DisplayGrid.None,
            margin: 8,
            outerMargin: true,
            pushItems: false,
            pushDirections: {
                north: true,
                east: true,
                south: true,
                west: true,
            },
            disableScrollHorizontal: true,
            disableScrollVertical: true,
            useTransformPositioning: true,
            swap: true,
            resizable: {
                enabled: true,
                handles: {
                    s: true,
                    e: true,
                    n: true,
                    w: true,
                    se: true,
                    ne: true,
                    sw: true,
                    nw: true,
                },
            },
            draggable: {
                enabled: true,
                ignoreContentClass: `module-header-icon`,
            },
            mobileBreakpoint: 1,
        };
    }

    /**
     * Loads all wallboards for the current company
     * */
    private async loadWallboards(): Promise<void> {
        if (this.isDataLoading)
            return;

        try {
            this.isDataLoading = true;
            this.gridApi?.showLoadingOverlay();
            const returnObj = await this.wallboardsService.loadWallboards();

            this.wallboards = returnObj.Wallboards as WallboardGridster[];
            this.folders = returnObj.Folders;
            this.slideModules = returnObj.Wallboard_Modules;

            // Hiding Interval Chart
            const chartIndex = this.slideModules.findIndex(slide => slide.WallboardModuleID == ModuleType.IntervalChart);
            if (chartIndex > -1)
                this.slideModules.splice(chartIndex, 1);

            this.domain = returnObj.Domain;

            //Adjusting domain for CxOne that includes extra info at the front of url
            if (this.cvConfigurationService.isCxOne && returnObj.Domain.includes("dashboard")) {
                this.domain = returnObj.Domain.substring(returnObj.Domain.indexOf("dashboard"));
            } else {
                this.domain = returnObj.Domain;
            }
            
            this.showAssignOption = returnObj.IsBpo;

            this.gridApi?.setGridOption('rowData', this.wallboards);
            this.gridApi?.sizeColumnsToFit();
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.isDataLoading = false;
            this.gridApi?.hideOverlay();
        }
    }

    /**
     * Returns the src value of the applicable wallboard preview image.
     * @param wallboard Wallboard to get preview image of
     */
    public getWallboardPreviewImageSrc(wallboard: WallboardGridster): string {
        switch (wallboard.FirstSlideType) {
            case ModuleType.Custom:
            case ModuleType.CurrentAgentStates:
            case ModuleType.ResponsiveCurrentAgentStates:
                return `../Admin/ImageResizer.aspx?imgid=-109&w=328&h=185`;
            case ModuleType.Leaderboard:
                return `../Admin/ImageResizer.aspx?imgid=-53&w=328&h=185`;
            case ModuleType.Racing:
                return `../Admin/ImageResizer.aspx?imgid=${wallboard.FirstSlideBackgroundID}&w=328&h=185`;
            case ModuleType.Scorecard:
                return `../Admin/ImageResizer.aspx?imgid=-55&w=328&h=185`;
            case ModuleType.Summary:
                return `../Admin/ImageResizer.aspx?imgid=-92&w=328&h=185`;
            case ModuleType.IntervalChart:
                return `../Admin/ImageResizer.aspx?imgid=-146&w=328&h=185`;
            case ModuleType.Image:
                return `../Admin/ImageResizer.aspx?imgid=-52&w=328&h=185`;
            case ModuleType.Video:
                return `../Admin/ImageResizer.aspx?imgid=-58&w=328&h=185`;
            case ModuleType.Spotlight:
                return `../Admin/ImageResizer.aspx?imgid=-56&w=328&h=185`;
            case ModuleType.Games:
                return `../Admin/ImageResizer.aspx?imgid=-123&w=328&h=185`;
            case ModuleType.Challenges:
                return `../Admin/ImageResizer.aspx?imgid=-137&w=328&h=185`;
            case ModuleType.Marketplace:
                return `../Admin/ImageResizer.aspx?imgid=-145&w=328&h=185`;
            default: // No First Slide
                return `../Admin/ImageResizer.aspx?imgid=-51&w=328&h=185`;
        }
    }

    /**
     * Opens new wallboard modal.
     * */
    public openNewWallboardModal(): void {
        this.editedWallboardOriginal = {
            WallboardID: 0,
            WallboardName: "",
            WallboardDescription: "",
            AllowInterruptions: true,
            ShowInMenu: true,
            RequireLogin: true,
            RecipientLogins: [],
            RecipientGroups: {},
        } as WallboardGridster;

        this.editedWallboard = angular.copy(this.editedWallboardOriginal);

        this.settingsModalOpen = true;
    }

    /**
     * Saves new wallboard.
     * */
    public async saveWallboard(): Promise<void> {
        if (this.isDataSaving)
            return;

        if (!this.editedWallboard.WallboardName) {
            this.openErrorDialog(`Error_Name_Required`);
            return;
        }

        if (!this.editedWallboard.WallboardGroup) {
            this.openErrorDialog(`Error_Folder_Required`);
            return;
        }

        try {
            this.isDataSaving = true;
            const returnedWallboard = await this.wallboardsService.saveWallboard(this.editedWallboard) as WallboardGridster;

            if (this.editedWallboardOriginal.Slides)
                returnedWallboard.Slides = this.editedWallboardOriginal.Slides;

            const isAdd = this.editedWallboard.WallboardID == 0;

            this.editedWallboardOriginal.WallboardID = returnedWallboard.WallboardID;
            this.editedWallboardOriginal.CompanyID = returnedWallboard.CompanyID;
            this.editedWallboardOriginal.WallboardName = returnedWallboard.WallboardName;
            this.editedWallboardOriginal.WallboardDescription = returnedWallboard.WallboardDescription;
            this.editedWallboardOriginal.CreatorLoginID = returnedWallboard.CreatorLoginID;
            this.editedWallboardOriginal.CookieKey = returnedWallboard.CookieKey;
            this.editedWallboardOriginal.AllowCookies = returnedWallboard.AllowCookies;
            this.editedWallboardOriginal.AllowInterruptions = returnedWallboard.AllowInterruptions;
            this.editedWallboardOriginal.ShowInMenu = returnedWallboard.ShowInMenu;
            this.editedWallboardOriginal.Active = returnedWallboard.Active;
            this.editedWallboardOriginal.EnableUrl = this.editedWallboard.EnableUrl;
            this.editedWallboardOriginal.RequireLogin = this.editedWallboard.RequireLogin;
            this.editedWallboardOriginal.WallboardGroup = returnedWallboard.WallboardGroup;
            this.editedWallboardOriginal.PublicAccessKey = returnedWallboard.PublicAccessKey;
            this.editedWallboardOriginal.CreatedDate = returnedWallboard.CreatedDate;
            this.editedWallboardOriginal.LastViewed = returnedWallboard.LastViewed;
            this.editedWallboardOriginal.FirstSlideType = returnedWallboard.FirstSlideType;
            this.editedWallboardOriginal.FirstSlideBackgroundID = returnedWallboard.FirstSlideBackgroundID;
            this.editedWallboardOriginal.FirstSlideKey = returnedWallboard.FirstSlideKey;
            this.editedWallboardOriginal.RecipientLogins = returnedWallboard.RecipientLogins;
            this.editedWallboardOriginal.RecipientGroups = returnedWallboard.RecipientGroups;
            this.editedWallboardOriginal.WallboardAssignments = returnedWallboard.WallboardAssignments;
            this.editedWallboardOriginal.CreatorGamificationAccess = returnedWallboard.CreatorGamificationAccess;
            this.editedWallboardOriginal.Slides = returnedWallboard.Slides;
            this.editedWallboardOriginal.AllowPublic = this.editedWallboard.AllowPublic;

            this.editedWallboard = angular.copy(this.editedWallboardOriginal);

            if (!this.uploadedBackgroundIds) {
                try {
                    this.isDataLoading = true;
                    this.uploadedBackgroundIds = await this.wallboardsService.loadBackgroundList();
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataLoading = false;
                }
            }

            if (!this.editedWallboardOriginal.Slides) {
                try {
                    this.editedWallboardOriginal.Slides = await this.wallboardsService.loadWallboardSlides(this.editedWallboard.WallboardID) as WallboardSlideGridster[];
                    this.editedWallboard.Slides = angular.copy(this.editedWallboardOriginal.Slides);

                    this.selectedSlideIndex = this.editedWallboardOriginal.Slides.length == 0 ? -1 : 0;
                }
                catch (error) {
                    console.log(error);
                }
            }

            // If the WallboardID > 0 then we are editing a Wallboard and shouldn't push to the list
            if (isAdd)
                this.wallboards.push(this.editedWallboardOriginal);

            this.gridApi?.setGridOption('rowData', this.wallboards);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.settingsModalOpen = false;
            this.tab = -1;
            this.detailsView = true;
            this.isDataSaving = false;
        }
    }

    /**
     * Prepares modal for the copy wallboard procedure.
     * @param wallboard Wallboard to potentially copy
     */
    public openCopyWallboardModal(wallboard: WallboardGridster): void {
        this.editedWallboardOriginal = {
            WallboardID: wallboard.WallboardID,
            WallboardName: "",
            WallboardDescription: wallboard.WallboardDescription,
            AllowInterruptions: wallboard.AllowInterruptions,
            ShowInMenu: wallboard.ShowInMenu,
            WallboardGroup: wallboard.WallboardGroup,
            isCopy: true,
            AllowCookies: wallboard.AllowCookies,
            CookieKey: "",
            CreatorLoginID: wallboard.CreatorLoginID,
            FirstSlideBackgroundID: wallboard.FirstSlideBackgroundID,
            FirstSlideKey: wallboard.FirstSlideKey,
            FirstSlideType: wallboard.FirstSlideType,
            PublicAccessKey: wallboard.PublicAccessKey,
            RequireLogin: wallboard.RequireLogin,
            RecipientLogins: [],
            RecipientGroups: {},
        } as WallboardGridster;
        this.wallboardCopyName = wallboard.WallboardName;

        this.editedWallboard = angular.copy(this.editedWallboardOriginal);

        this.settingsModalOpen = true;
    }

    /**
     * Saves editedWallboard in the database, which should be a copy of an existing wallboard.
     * */
    public async copyWallboard(): Promise<void> {
        if (this.isDataSaving)
            return;

        if (!this.editedWallboard.WallboardName) {
            this.openErrorDialog(`Error_Name_Required`);
            return;
        }

        if (!this.editedWallboard.WallboardGroup) {
            this.openErrorDialog(`Error_Folder_Required`);
            return;
        }

        for (const wallboard of this.wallboards) {
            if (wallboard.WallboardName.toLowerCase() == this.editedWallboard.WallboardName.toLowerCase()) {
                this.openErrorDialog(`Error_Wallboard_Exists`);
                return;
            }
        }

        let newCopy;
        try {
            this.isDataSaving = true;
            newCopy = await this.wallboardsService.copyWallboard(this.editedWallboard, this.editedWallboard.CreatorLoginID);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.settingsModalOpen = false;
            this.isDataSaving = false;
        }

        this.editWallboard(newCopy); // As part of this process, this.editedWallboardOriginal and this.editedWallboard are compiled properly based on newCopy

        this.wallboards.push(this.editedWallboard);
        this.gridApi.setGridOption('rowData', this.wallboards);
    }

    /**
     * Writes the display URL of the current wallboard to the clipboard.
     */
    public writeWallboardUrlToClipboard(): void {
        navigator.clipboard.writeText(`https://${this.domain}/Admin/WallboardView.aspx?id=${this.editedWallboard.CookieKey}`);
    }

    /**
     * Opens the assign tool for altering the specified wallboard's assigned groups.
     * @param wallboard Wallboard to assign groups to
     */
    public assignWallboard(wallboard: WallboardGridster): void {
        // Set the selected wallboards list to the assigned group
        if (wallboard.WallboardAssignments)
            this.assignedGroups = { wallboardID: wallboard.WallboardID, emp: wallboard.WallboardAssignments };
        else
            this.assignedGroups = { wallboardID: wallboard.WallboardID, emp: [] };

        this.assignedWallboard = wallboard;
        this.assignDialogOpen = true;
    }

    /**
     * Called when the "Assign" button in the assign tool is clicked.
     * @param eventData Array of the groups that were assigned.
     */
    public async updateAssignments(eventData?: Group[]): Promise<void> {
        try {
            this.isDataSaving = true;
            await this.wallboardsService.updateWallboardAssignments(this.assignedWallboard.WallboardID, eventData);
            this.assignedWallboard.WallboardAssignments = eventData;
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.isDataSaving = false;
        }
    }

    /**
     * Opens the specified wallboard for editing.
     * @param wallboard Wallboard to open details view for
     */
    public async editWallboard(wallboard: WallboardGridster): Promise<void> {
        this.editedWallboardOriginal = wallboard;
        this.editedWallboardOriginal.AllowPublic = this.editedWallboardOriginal.PublicAccessKey != "" && this.editedWallboardOriginal.PublicAccessKey != null;

        this.editedWallboard = angular.copy(this.editedWallboardOriginal);

        if (!this.uploadedBackgroundIds) {
            try {
                this.isDataLoading = true;
                this.uploadedBackgroundIds = await this.wallboardsService.loadBackgroundList();
            }
            catch (error) {
                console.log(error);
            }
            finally {
                this.isDataLoading = false;
            }
        }

        if (!this.editedWallboard.Slides) {
            try {
                this.isDataLoading = true;
                const slides = await this.wallboardsService.loadWallboardSlides(this.editedWallboardOriginal.WallboardID) as WallboardSlideGridster[];

                // Ensures that modules have Gridster values; important for custom slides
                for (const slide of slides) {
                    for (let i = 0; i < slide.WallboardModuleDetails.length; i++) {
                        const oldDetail = slide.WallboardModuleDetails[i];

                        const newDetail = {
                            WallboardModuleDetailsID: oldDetail.WallboardModuleDetailsID,
                            CompanyID: oldDetail.CompanyID,
                            WallboardID: oldDetail.WallboardID,
                            WallboardSlideID: oldDetail.WallboardSlideID,
                            PositionTop: Math.min(oldDetail.PositionTop, 32),
                            PositionLeft: Math.min(oldDetail.PositionLeft, 32),
                            Height: Math.max(oldDetail.Height, 8),
                            Width: Math.max(oldDetail.Width, 8),
                            WallboardModuleID: oldDetail.WallboardModuleID,
                            WallboardModuleKey: oldDetail.WallboardModuleKey,
                            Active: oldDetail.Active,

                            x: oldDetail.PositionLeft,
                            y: oldDetail.PositionTop,
                            rows: Math.max(oldDetail.Height, 8),
                            cols: Math.max(oldDetail.Width, 8),
                            minItemRows: 8,
                            minItemCols: 8,
                            placeholder: false,

                            State: null
                        };

                        // Starting/minimum module sizes
                        switch (oldDetail.WallboardModuleID) {
                            case ModuleType.Gauge:
                            case ModuleType.ImageModule:
                                newDetail.minItemRows = 15;
                                newDetail.minItemCols = 10;
                                break;
                            case ModuleType.Thermometer:
                                newDetail.minItemRows = 30;
                                newDetail.minItemCols = 10;
                                break;
                            case ModuleType.SummaryModule:
                            case ModuleType.Achievement:
                                newDetail.minItemRows = 15;
                                newDetail.minItemCols = 30;
                                break;
                            case ModuleType.Text:
                                newDetail.minItemRows = 10;
                                newDetail.minItemCols = 10;
                                break;
                            case ModuleType.Top:
                                newDetail.minItemRows = 15;
                                newDetail.minItemCols = 20;
                                break;
                            case ModuleType.AgentCounter:
                                newDetail.minItemRows = 15;
                                newDetail.minItemCols = 15;
                                break;
                            // KPI is the smallest at 8x8, which is the default set above
                            default:
                                break;
                        }

                        // This section ensures that the module size and position values are renderable
                        newDetail.Height = Math.min(Math.max(newDetail.minItemRows, oldDetail.Height), 40);
                        newDetail.rows = newDetail.Height;

                        newDetail.PositionTop = Math.max(Math.min(40 - newDetail.Height, oldDetail.PositionTop), 0);
                        newDetail.y = newDetail.PositionTop;

                        newDetail.Width = Math.min(Math.max(newDetail.minItemCols, oldDetail.Width), 40);
                        newDetail.cols = newDetail.Width;

                        newDetail.PositionLeft = Math.max(Math.min(40 - newDetail.Width, oldDetail.PositionLeft), 0);
                        newDetail.x = newDetail.PositionLeft;

                        slide.WallboardModuleDetails[i] = newDetail;
                    }
                }

                this.editedWallboardOriginal.Slides = slides;
                this.editedWallboard.Slides = angular.copy(this.editedWallboardOriginal.Slides);
            }
            catch (error) {
                console.log(error);
            }
            finally {
                this.isDataLoading = false;
            }
        }

        this.selectedSlideIndex = -1;
        if (this.editedWallboard.Slides && this.editedWallboard.Slides.length > 0)
            this.selectSlide(0);
        else
            this.handleTabSwitch();
        this.detailsView = true;
        this.resizeCenterBox();
    }

    /**
     * Updates critical values related to the main box size.
     * */
    public resizeCenterBox(): void {
        setTimeout(() => {
            const mainSectionBoxParentWidth = $($('#mainSectionBox').parent()).width();
            this.centerBoxWidth = mainSectionBoxParentWidth - 34 - ((mainSectionBoxParentWidth - 34) % 40);
            this.centerBoxHeight = this.centerBoxWidth * 0.60;
        });
    }

    /**
     * Opens the specified wallboard in a new tab for viewing.
     * @param wallboard Wallboard to play
     */
    public playWallboard(wallboard: WallboardGridster): void {
        window.open(`WallboardView.aspx?wid=${wallboard.WallboardID}`, `_blank`);
    }

    /**
     * Opens the confirmation dialog to delete the specified wallboard.
     * @param wallboard Wallboard to potentially delete
     */
    public promptDeleteWallboard(wallboard: WallboardGridster): void {
        this.confirmationDialogOpen = 1;
        this.confirmDeleteWallboard = wallboard;
    }

    /**
     * Deletes the wallboard stored in this.confirmDeleteWallboard
     * */
    public async deleteWallboard(): Promise<void> {
        try {
            this.isDataSaving = true;
            await this.wallboardsService.deleteWallboard(this.confirmDeleteWallboard);

            this.wallboards.splice(this.wallboards.indexOf(this.confirmDeleteWallboard), 1); // Remove from the list

            this.gridApi?.setGridOption('rowData', this.wallboards);
            this.gridApi?.sizeColumnsToFit();
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.confirmationDialogOpen = 0;
            this.isDataSaving = false;
        }
    }

    /**
     * Goes back to landing page from details view, resetting certain values along the way.
     * */
    public returnToWallboardHome(): void {
        this.detailsView = false;
        this.selectedSlideIndex = -1;
        this.selectedSlideType = -1;
        this.slideToAdd = null;
    }

    /**
     * Method called when a slide is dragged-and-dropped.
     * @param event Drag-and-drop event
     */
    public async dropSlide(event: CdkDragDrop<WallboardSlideGridster[]>): Promise<void> {
        const editedSlides = this.editedWallboard.Slides;
        const originalSlides = this.editedWallboardOriginal.Slides;

        if (event.previousIndex == event.currentIndex)
            return;

        editedSlides.splice(event.currentIndex, 0, editedSlides.splice(event.previousIndex, 1)[0]);
        originalSlides.splice(event.currentIndex, 0, this.editedWallboardOriginal.Slides.splice(event.previousIndex, 1)[0]);

        if (editedSlides[0].WallboardModuleDetails.length > 0 && SlideModuleTypes.includes(editedSlides[0].WallboardModuleDetails[0].WallboardModuleID))
            this.editedWallboard.FirstSlideType = editedSlides[0].WallboardModuleDetails[0].WallboardModuleID;
        else
            this.editedWallboard.FirstSlideType = 0;

        if (originalSlides[0].WallboardModuleDetails.length > 0 && SlideModuleTypes.includes(originalSlides[0].WallboardModuleDetails[0].WallboardModuleID))
            this.editedWallboardOriginal.FirstSlideType = originalSlides[0].WallboardModuleDetails[0].WallboardModuleID;
        else
            this.editedWallboardOriginal.FirstSlideType = 0;

        // If the new first slide is a racing then send the info for its theme to the landing
        if (this.editedWallboard.FirstSlideType == ModuleType.Racing) {
            this.wallboardsService.loadRacingBackgroundId(this.editedWallboard.Slides[0].WallboardModuleDetails[0].WallboardModuleKey, this.editedWallboard.CreatorLoginID).then(racingBackgroundId => {
                this.editedWallboard.FirstSlideBackgroundID = racingBackgroundId;
                this.editedWallboardOriginal.FirstSlideBackgroundID = racingBackgroundId;
            }).catch(error => {
                console.log(error);
            });
        }

        // Update the SlideOrder property for each slide the new position is remembered
        for (let i = 0; i < editedSlides.length; i++) {
            editedSlides[i].SlideOrder = i;
            originalSlides[i].SlideOrder = i;

            // Adjust the index of the selected slide so the proper loaded slide is still highlighted
            if (this.slideToAdd.WallboardSlideID == editedSlides[i].WallboardSlideID) {
                this.selectedSlideIndex = i;
                this.slideToAdd.SlideOrder = i;
            }
        }

        try {
            await this.wallboardsService.updateSlideOrder(this.editedWallboard.Slides);
        }
        catch (error) {
            console.log(error);
        }
    }

    /**
     * Opens modal to add a new slide.
     * */
    public openNewSlideModal(): void {
        this.slideoutSettingsLoaded = false;

        this.slideToAdd = {
            WallboardSlideID: 0,
            CompanyID: this.editedWallboard.CompanyID,
            SlideName: "",
            SlideDescription: "",
            WallboardID: this.editedWallboard.WallboardID,
            SlideInterval: 30,
            SlideOrder: this.editedWallboard.Slides.length,
            BackgroundImageID: 0,
            TransitionID: 0,
            CreatorID: this.editedWallboard.CreatorLoginID,
            HasBackdrop: true,
            HasTotalsRow: true,
            HasPagination: true,
            WallboardModuleDetails: [],
            Enabled: true,
            Active: true,

            TypeState: null
        };

        this.newSlideModalOpen = true;
    }

    /**
     * Creates a new slide of the type selected in the new slide modal.
     * */
    public async saveNewSlide(): Promise<void> {
        if (this.selectedSlideType < 0) {
            this.openErrorDialog(`Error_Slide_Type_Required`);
            return;
        }

        if (this.selectedSlideType == ModuleType.Scorecard) { // Scorecard type is not implemented yet
            this.openErrorDialog(`Error_Slide_Type_Unavailable`);
            return;
        }

        this.slideToAdd.SlideName = this.slideModules.find(o => o.WallboardModuleID == this.selectedSlideType).WallboardModuleName;

        if (this.selectedSlideType != ModuleType.Custom) {
            try {
                this.isDataLoading = true;

                this.slideToAdd.WallboardModuleDetails[0] = {
                    WallboardModuleDetailsID: 0,
                    CompanyID: this.slideToAdd.CompanyID,
                    WallboardID: this.slideToAdd.WallboardID,
                    WallboardSlideID: this.slideToAdd.WallboardSlideID,
                    PositionTop: 0,
                    PositionLeft: 0,
                    Height: 0,
                    Width: 0,
                    WallboardModuleID: this.selectedSlideType,
                    WallboardModuleKey: await this.wallboardsService.generateAccessGuid(),
                    Active: true,

                    x: 0,
                    y: 0,
                    rows: 0,
                    cols: 0,
                    minItemRows: 8,
                    minItemCols: 8,
                    placeholder: false,

                    State: null
                };
            }
            catch (error) {
                console.log(error);
                return;
            }
            finally {
                this.isDataLoading = false;
            }
        }

        // Based on type, make a new object details and a state object with a new GUID then open the settings
        switch (this.selectedSlideType) {
            case ModuleType.Custom:
                try {
                    this.isDataSaving = true;
                    this.slideToAdd = await this.wallboardsService.saveNewSlide(this.slideToAdd, this.selectedSlideType) as WallboardSlideGridster;
                    this.editedWallboard.Slides.push(angular.copy(this.slideToAdd));
                    this.editedWallboardOriginal.Slides.push(angular.copy(this.slideToAdd));

                    if (this.slideToAdd.SlideOrder == 0) { // If it's the first slide, then update the wallboard's first slide info
                        this.editedWallboard.FirstSlideBackgroundID = this.slideToAdd.BackgroundImageID;
                        this.editedWallboardOriginal.FirstSlideBackgroundID = this.slideToAdd.BackgroundImageID;

                        if (this.slideToAdd.WallboardModuleDetails.length == 0) {
                            this.editedWallboard.FirstSlideType = 0;
                            this.editedWallboardOriginal.FirstSlideType = 0;

                            this.editedWallboard.FirstSlideKey = "";
                            this.editedWallboardOriginal.FirstSlideKey = "";
                        }
                        else {
                            this.editedWallboard.FirstSlideType = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleID;
                            this.editedWallboardOriginal.FirstSlideType = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleID;

                            this.editedWallboard.FirstSlideKey = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey;
                            this.editedWallboardOriginal.FirstSlideKey = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey;
                        }
                    }

                    this.selectSlide(this.editedWallboard.Slides.length - 1);
                    this.openSlideSettings();

                    this.newSlideModalOpen = false;
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                }

                return;
            case ModuleType.Leaderboard:
                this.leaderboardSetupObj = {
                    LeaderboardTitle: "",
                    ImageDisplay: `User Preference`,
                    LeaderboardCount: 5,
                    InitialSettings: true
                };

                this.loadEditSlideControls(this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, 1);

                break;
            case ModuleType.Racing:
                this.racingSetupObj = {
                    BannerTitle: "",
                    Theme: `Random`,
                    ShowTop: 5,
                    Positioning: `Leader`,
                    StartingLine: 0,
                    FinishLine: null,
                    MetricDisplayName: "",
                    UseRankSort: false,
                    InitialSettings: true
                };

                this.loadEditSlideControls(this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, 1);

                break;
            case ModuleType.Summary:
                this.summarySetupObj = {
                    ShowSummaryTitle: false,
                    SummaryTitle: "",
                    ShowRank: false,
                    SumMetricDisplays: [],
                    InitialSettings: true
                };

                this.loadEditSlideControls(this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, 10);

                break;
            case ModuleType.IntervalChart:
                this.intervalChartSetupObj = {
                    IntervalChartTitle: "",
                    InitialSettings: true
                };

                this.loadEditSlideControls(this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, 10);
                break;
            case ModuleType.Image:
                this.imageSetupObj = {
                    UploadedImageID: 0,
                    UploadedImageString: "",
                    InitialCustomSettings: true
                };
                break;
            case ModuleType.Video:
                this.videoSetupObj = {
                    VideoURL: "",
                    HasSound: true,
                    OriginDomain: "",
                    ThumbImg: "",
                    InitialSettings: true
                } as VideoSettingsTransferObj;
                break;
            case ModuleType.Spotlight:
                this.spotlightSetupObj = {
                    UseLogin: true,
                    LoginID: null,
                    LoginName: "",
                    ImageDisplay: `Profile`,
                    ImageID: null,
                    UploadedImageString: "",
                    ShowBio: true,
                    UseProfileBio: true,
                    BioString: "",
                    ShowHobbies: true,
                    UseProfileHobbies: false,
                    HobbyList: [""],
                    ShowBadges: true,
                    ShowBadgeCount: 1,
                    InitialSettings: true
                };

                this.loadLoginList();

                break;
            case ModuleType.CurrentAgentStates:
            case ModuleType.ResponsiveCurrentAgentStates:
                this.currentAgentStatesSetupObj = {
                    SlideTitle: "",
                    InitialSettings: true
                };

                this.loadEditSlideControls(this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, 1);

                break;
            case ModuleType.Games:
                this.wallboardGameSetupObj = {
                    GameID: 0,
                    GameType: 0,
                    InitialSettings: true,
                    DisplayOption: 0
                };

                this.loadEditSlideControls(this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, 1);

                break;
            case ModuleType.Challenges:
                if (this.hasGamificationPackage) {
                    this.challengesSetupObj = {
                        SlideTitle: "",
                        TotChallenges: 0,
                        TotParticipants: 0,
                        InitialSettings: true
                    };

                    this.loadEditSlideControls(this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, 1, false);
                }
                break;
            case ModuleType.Marketplace:
                if (this.hasGamificationPackage) {
                    this.marketplaceSetupObj = {
                        DisplayOption: 1,
                        SlideTitle: "",
                        ProductList: [],
                        ProductTypes: [],
                        InitialSettings: true
                    };

                    this.loadEditSlideControls(this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, 1, false);
                }
                break;
            default:
                break;
        }

        this.intervalMin = `00`;
        this.intervalMin = `30`;

        this.initialCustomSettings = true;

        this.openSlideSettings(0, true);
        this.newSlideModalOpen = false;
    }

    /**
     * Group/metric/time selections are persisted live (on change), not on Save, so an edit abandoned by
     * reloading the page reappears the next time the slide settings are shown. On the first open/select of a
     * slide since the page loaded, revert to the saved baseline (*_Orig) - the same restore Cancel performs -
     * before the controls load. Limited to slide types whose save re-baselines *_Orig (Summary, Current and
     * Responsive Agent States); others are excluded so a SAVED selection is never wiped. Skipped for new
     * slides and for repeat opens of the same slide in the same page session.
     */
    private async revertUnsavedEditsOnFirstOpen(moduleType: number, moduleKey: string, isNew = false): Promise<void> {
        const revertableTypes: number[] = [ModuleType.Summary, ModuleType.CurrentAgentStates, ModuleType.ResponsiveCurrentAgentStates];
        if (isNew || !moduleKey || !revertableTypes.includes(moduleType) || this.slidesRevertedSinceLoad.has(moduleKey))
            return;
        this.slidesRevertedSinceLoad.add(moduleKey);
        await this.wallboardsService.revertControlStates(this.editedWallboard.CreatorLoginID, moduleKey);
    }

    /**
     * Changes the selected slide to the specified index.
     * @param slideIndex Index of slide to select
     */
    public async selectSlide(slideIndex): Promise<void> {
        if (this.selectedSlideIndex == slideIndex)
            return;

        this.selectedSlideIndex = slideIndex;
        // See comment under loadEditSlideControls() for why this is here
        this.controlsLoadId++;
        this.moduleSettingsLoadId++;
        this.loadedModuleStates = [];

        this.slideToAdd = angular.copy(this.editedWallboard.Slides[this.selectedSlideIndex]);

        // Loads the Aspx Controls with the propery Max Metrics based on type (Custom, Image and Video don't have controls; Summary has 5 metrics; all others have 1)
        // TODO: Made this match the one in openSlideSettings, as they should be the same, right?
        const firstModuleDetails = this.slideToAdd.WallboardModuleDetails[0];
        if (this.slideToAdd.WallboardModuleDetails.length > 0) {
            // Selecting a slide (including the auto-select on wallboard open / after a reload) loads its
            // controls here, bypassing openSlideSettings - so the same first-open revert must run here too.
            await this.revertUnsavedEditsOnFirstOpen(firstModuleDetails?.WallboardModuleID, firstModuleDetails?.WallboardModuleKey);
            switch (this.slideToAdd.WallboardModuleDetails[0].WallboardModuleID) {
                case ModuleType.Summary:
                case ModuleType.IntervalChart:
                    this.loadEditSlideControls(firstModuleDetails.WallboardModuleKey, 10);
                    break;
                case ModuleType.Challenges:
                    this.loadEditSlideControls(firstModuleDetails.WallboardModuleKey, 1, false);
                    break;
                case ModuleType.Custom:
                case ModuleType.Leaderboard:
                case ModuleType.Spotlight:
                case ModuleType.CurrentAgentStates:
                case ModuleType.ResponsiveCurrentAgentStates:
                case ModuleType.Games:
                case ModuleType.Marketplace:
                    this.loadEditSlideControls(firstModuleDetails.WallboardModuleKey, 1);
                    break;
                default:
                    break;
            }
        }

        // If not a custom slide, then load the state (custom does not have a state for itself)
        if (this.slideToAdd.WallboardModuleDetails.length > 0 && SlideModuleTypes.includes(firstModuleDetails.WallboardModuleID)) {
            this.selectedSlideType = firstModuleDetails.WallboardModuleID;
            this.loadTypeState();
        }
        else
            this.selectedSlideType = 0;

        // Selected slide type changed, tab integrity must be ensured
        this.handleTabSwitch();

        if (this.selectedSlideType == ModuleType.Custom) {
            // TODO: Are there circumstances in which this doesn't need to be done?
            const typeList = this.slideToAdd.WallboardModuleDetails.map((o) => o.WallboardModuleID);
            const keyList = this.slideToAdd.WallboardModuleDetails.map((o) => o.WallboardModuleKey);

            // This is to ensure that only the final request applies the values it retrieved. moduleSettingsLoadId is incremented on all successful slide selections.
            const requestId = this.moduleSettingsLoadId;

            this.areModuleStatesLoading = true;
            this.wallboardsService.loadModuleStates(typeList, keyList, this.editedWallboard.CreatorLoginID).then(moduleStates => {
                if (requestId == this.moduleSettingsLoadId) {
                    this.loadedModuleStates = moduleStates;

                    this.generateModulePreviews();
                }
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.areModuleStatesLoading = false;
            });
        }

        if (this.selectedSlideType == ModuleType.Spotlight)
            this.loadLoginList();

        // Check that the center box is the correct size based on screen in case of window resize
        this.resizeCenterBox();
    }

    /**
     * Performs necessary actions for module previews to display.
     * */
    public generateModulePreviews() {
        for (let i = 0; i < this.loadedModuleStates?.length; i++) {
            if (this.loadedModuleStates[i].counterObj) {
                if (this.loadedModuleStates[i].counterObj.chartOptions)
                    this.loadedModuleStates[i].counterObj.chartOptions.destroy();

                this.loadedModuleStates[i].counterObj.chartOptions = new Chart(document.getElementById(`chart${this.slideToAdd.WallboardModuleDetails[i].WallboardModuleKey}`) as any, {
                    type: `doughnut`,
                    data: {
                        datasets: [
                            {
                                data: [1, 1, 1, 1, 1],
                                backgroundColor: [
                                    `rgba(61, 150, 73, 1)`, // Available
                                    `rgba(124, 82, 191, 1)`, // Inbound
                                    `rgba(228, 179, 33, 1)`, // Outbound
                                    `rgba(241, 102, 34, 1)`, // ACW
                                    `rgba(189, 32, 38, 1)` // Unavailable
                                ],
                                borderColor: `transparent`,
                                borderWidth: 5
                            }
                        ],
                        labels: [
                            `Available`,
                            `Inbound`,
                            `Outbound`,
                            `ACW`,
                            `Unavailable`
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        animation: {
                            duration: 0
                        },
                        plugins: {
                            datalabels: {
                                anchor: (k) => `center`,
                                display: true,
                                backgroundColor: (context) => null,
                                borderRadius: (k) => 0,
                                borderWidth: (k) => 0,
                                color: 'white',
                                font: (context) => {
                                    const width = context.chart.width - 64;
                                    const height = context.chart.height - 64;

                                    let size;
                                    if (width > height)
                                        size = Math.round(height / 8);
                                    else
                                        size = Math.round(width / 8);

                                    const minSize = 14;

                                    return {
                                        size: size < minSize ? minSize : size,
                                        weight: `bold`
                                    };
                                },
                                formatter: (value, context) => value
                            },
                            legend: { display: false },
                            tooltip: { enabled: false },
                        },
                        layout: {
                            padding: {
                                left: 0,
                                right: 0,
                                top: 0,
                                bottom: 0
                            }
                        }
                    }
                });
            }
            else if (this.loadedModuleStates[i].textObj) {
                const textWithoutImage = TextSettingsTransferObj.getTextValueWithoutImage(this.loadedModuleStates[i].textObj.TextValue);
                this.loadedModuleStates[i].textObj.TextValueSanitized = this.sanitizer.bypassSecurityTrustHtml(textWithoutImage);
            }
        }
    }

    /**
     * Saves the specified slide's current enabled status.
     * @param slide Slide to update
     */
    public async toggleSlideEnabledStatus(slide: WallboardSlideGridster, slideIndex: number): Promise<void> {
        // Keep original in sync
        this.editedWallboardOriginal.Slides[slideIndex].Enabled = slide.Enabled;

        try {
            await this.wallboardsService.updateSlideEnabled(slide.WallboardSlideID, slide.Enabled);
        }
        catch (error) {
            console.log(error);
        }
    }

    /**
     * Loads type state for current slide type.
     * */
    public async loadTypeState(): Promise<void> {
        try {
            const typeState = await this.wallboardsService.loadTypeState(this.selectedSlideType, this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, this.editedWallboard.CreatorLoginID);

            switch (this.selectedSlideType) {
                case ModuleType.Leaderboard:
                    typeState.Leaderboard_Setup.InitialSettings = false;
                    this.leaderboardSetupObj = typeState.Leaderboard_Setup;
                    break;
                case ModuleType.Racing:
                    this.racingSetupObj = typeState.Racing_Setup;
                    break;
                case ModuleType.Summary:
                    typeState.Summary_Settings.InitialSettings = false;
                    this.summarySetupObj = typeState.Summary_Settings;
                    break;
                case ModuleType.IntervalChart:
                    typeState.Interval_Chart_Settings.InitialSettings = false;
                    this.intervalChartSetupObj = typeState.Interval_Chart_Settings;
                    break;
                case ModuleType.Image:
                    typeState.Image_Settings.InitialCustomSettings = false;
                    typeState.Image_Settings.UploadedImageString = null;
                    this.imageSetupObj = typeState.Image_Settings;

                    const imageAspect = await this.wallboardsService.getImageAspect(this.imageSetupObj.UploadedImageID);
                    this.fullImgWidthAuto = this.centerBoxWidth >= this.centerBoxHeight * imageAspect;
                    break;
                case ModuleType.Video:
                    typeState.Video_Settings.InitialSettings = false;
                    this.videoSetupObj = typeState.Video_Settings;
                    break;
                case ModuleType.Spotlight:
                    typeState.Spotlight_Setup.InitialSettings = false;
                    this.spotlightSetupObj = typeState.Spotlight_Setup;

                    if (this.spotlightSetupObj.UseLogin && this.spotlightSetupObj.LoginID > 0)
                        this.loadSpotlightLoginInfo();
                    break;
                case ModuleType.CurrentAgentStates:
                case ModuleType.ResponsiveCurrentAgentStates:
                    typeState.Current_Agent_States_Setting.InitialSettings = false;
                    this.currentAgentStatesSetupObj = typeState.Current_Agent_States_Setting;
                    break;
                case ModuleType.Games:
                    typeState.Wallboard_Game_Settings.InitialSettings = false;
                    this.wallboardGameSetupObj = typeState.Wallboard_Game_Settings;
                    break;
                case ModuleType.Challenges:
                    typeState.Challenges_Setup.InitialSettings = false;
                    this.challengesSetupObj = typeState.Challenges_Setup;
                    break;
                case ModuleType.Marketplace:
                    typeState.Marketplace_Setup.InitialSettings = false;
                    this.marketplaceSetupObj = typeState.Marketplace_Setup;
                    break;
                default:
                    break;
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    /**
     * Returns the name of the module type of the specified slide
     * @param slide Slide to get module name of
     */
    public getSlideModuleName(slide: WallboardSlideGridster): string {
        if (slide.WallboardModuleDetails.length > 0) {
            const module = this.slideModules.find(o => o.WallboardModuleID == slide.WallboardModuleDetails[0].WallboardModuleID);

            if (!module)
                return this.localization.get(`Custom`);
            return module.WallboardModuleName;
        }

        return this.localization.get(`Custom`);
    }

    /**
     * Returns the ID of the preview image of the specified slide type.
     * @param id WallboardModuleID of the slide type to get the preview image ID of
     */
    public slideTypePreviewImageId(wallboardModuleId: ModuleType): number {
        switch (wallboardModuleId) {
            case ModuleType.Custom:
                return -109;
            case ModuleType.Leaderboard:
                return -95;
            case ModuleType.Racing:
                return -54;
            case ModuleType.Summary:
                return -92;
            case ModuleType.IntervalChart:
                return -146;
            case ModuleType.Image:
                return -52;
            case ModuleType.Video:
                return -58;
            case ModuleType.Spotlight:
                return -56;
            case ModuleType.CurrentAgentStates:
                return -122;
            case ModuleType.Games:
                return -123;
            case ModuleType.Challenges:
                return -137;
            case ModuleType.Marketplace:
                return -145;
            case ModuleType.ResponsiveCurrentAgentStates:
                return -157;
            default:
                return 0;
        }
    }

    /**
     * Opens slide settings modal for current slide.
     * @param moduleIndex Optional, defaults to 0; index of the WallboardModuleDetails to use
     * */
    public async openSlideSettings(moduleIndex = 0, isNew = false): Promise<void> {
        if (moduleIndex != 0)
            this.initialCustomSettings = false;

        if (isNew) {
            this.initialCustomSettings = true;
        } else {
            this.initialCustomSettings = false;
        }

        this.selectedModuleIndex = moduleIndex;
        this.selectedMetricInfo = [];
        this.slideToAdd.WallboardModuleInfo = this.slideModules.find(o => o.WallboardModuleID == this.selectedSlideType);
        if (this.selectedSlideIndex >= 0 && !isNew)
            this.editedWallboard.Slides[this.selectedSlideIndex].WallboardModuleInfo = this.slideToAdd.WallboardModuleInfo;

        // See comment under loadEditSlideControls() for why this is here
        if (!this.isModuleWithSlideout(this.SettingsModuleType)) //skip for summary and interval as it is handled separately
            this.controlsLoadId++;

        const moduleDetails = this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex];
        if (this.slideToAdd.WallboardModuleDetails.length > 0) {
            // Discard live-persisted-but-unsaved edits the first time this slide is opened since the page
            // loaded (see revertUnsavedEditsOnFirstOpen). Must run before the controls load below.
            await this.revertUnsavedEditsOnFirstOpen(this.SettingsModuleType, moduleDetails?.WallboardModuleKey, isNew);
            switch (this.SettingsModuleType) {
                case ModuleType.Leaderboard:
                case ModuleType.Racing:
                case ModuleType.Games:
                case ModuleType.Marketplace:
                    this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 1);
                    break;
                case ModuleType.CurrentAgentStates:
                case ModuleType.ResponsiveCurrentAgentStates:
                    this.loadCurrentAgentStatesSlideSettings(moduleDetails, isNew);
                    break;
                case ModuleType.Summary:
                case ModuleType.IntervalChart:
                    this.loadIntervalChartSlideSettings(moduleDetails, isNew);
                    break;
                case ModuleType.Video:
                    // Get thumbnail for video
                    this.applyVideoUrl();
                    break;
                case ModuleType.Spotlight:
                    this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 1);
                    this.spotlightCroppedImage = null;
                    break;
                case ModuleType.Gauge:
                    this.loadGaugeSlideSettings(moduleDetails, moduleIndex);
                        break;
                case ModuleType.Thermometer:
                    this.thermometerSetupObj = angular.copy(this.loadedModuleStates[this.selectedModuleIndex].thermometerObj);
                    this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 1);
                    break;
                case ModuleType.SummaryModule:
                    this.summarySetupObj = angular.copy(this.loadedModuleStates[this.selectedModuleIndex].sumObj);
                    this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 3);
                    break;
                case ModuleType.Text:
                    const textSetupObjTemp = {
                        ...this.loadedModuleStates[this.selectedModuleIndex].textObj,
                        TextValue: TextSettingsTransferObj.getTextValueWithoutImage(this.loadedModuleStates[this.selectedModuleIndex].textObj.TextValue),
                    };
                    this.textSetupObj = angular.copy(textSetupObjTemp);
                    break;
                case ModuleType.ImageModule:
                    this.imageSetupObj = angular.copy(this.loadedModuleStates[this.selectedModuleIndex].imgObj);
                    break;
                case ModuleType.Top:
                    this.topSetupObj = angular.copy(this.loadedModuleStates[this.selectedModuleIndex].topObj);
                    this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 1);
                    break;
                case ModuleType.AgentCounter:
                    this.counterSetupObj = {
                        CounterTitle: this.loadedModuleStates[this.selectedModuleIndex].counterObj.CounterTitle,
                        ShowLabels: this.loadedModuleStates[this.selectedModuleIndex].counterObj.ShowLabels,
                        chartOptions: null
                    };
                    this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 0, true, true);
                    break;
                case ModuleType.Kpi:
                    this.kpiSetupObj = angular.copy(this.loadedModuleStates[this.selectedModuleIndex].kpiObj);
                    this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 1);
                    break;
                case ModuleType.Challenges:
                    this.loadChallengesSlideSettings(moduleDetails);
                    break;
                default:
                    break;
            }
        }
        // This handled separately for the slideout settings
        if (this.slideToAdd.SlideInterval < 15)
            this.slideToAdd.SlideInterval = 15;

        this.intervalSec = (this.slideToAdd.SlideInterval % 60).toString();
        this.intervalMin = ((this.slideToAdd.SlideInterval - parseInt(this.intervalSec, 10)) / 60).toString();

        if (parseInt(this.intervalSec, 10) < 10)
            this.intervalSec = `0${this.intervalSec}`;
        if (parseInt(this.intervalMin, 10) < 10)
            this.intervalMin = `0${this.intervalMin}`;

        if (this.SettingsModuleType == ModuleType.Games && this.gameFolders.length == 0 && !this.areGamesLoading) {
            this.areGamesLoading = true;

            try {
                const games = await this.wallboardsService.loadGames();
                this.gameFolders = games.GameFolders; // GamesFolderItemWsObj[]

                    for (const gameFolder of this.gameFolders) {
                        const gamesRunningList = gameFolder.Games.filter((game) => game.GameObject.isRunning);
                        gameFolder.Games = gamesRunningList;
                    }

                    this.gamesList = this.formatGamesList(angular.copy(this.gameFolders), this.selectedGame[0] ?? null);

                    if (this.wallboardGameSetupObj?.GameID)
                        this.selectedGame = this.gamesList.filter((game) => game.RuleID && game.RuleID === this.wallboardGameSetupObj.GameID) || [];
                    else
                        this.selectedGame = [];
            }
            catch(error) {
                console.log(error);
            } finally {
                this.areGamesLoading = false;
            }
        }

        if (this.slideToAdd.WallboardModuleDetails.length > 0 && SlideModuleTypes.includes(this.SettingsModuleType) && !this.initialCustomSettings)
            this.loadTypeState();

        if (!this.isModuleWithSlideout(this.SettingsModuleType)) {
        // The slideout settings should have been opened for the specific slide type (currently Summary and Interval Chart use it)
            this.slideSettingsModalOpen = true;
            this.slideSettingsModalSection = 1;
        }

        this.marketplaceSettingsSetup()   
    }

    public async loadChallengesSlideSettings(moduleDetails) {
        this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 1, false);
        this.areChallengesLoading = true;
        try {
        const runningChallanges = await this.wallboardsService.loadRunningChallenges()
            this.activeChallenges = angular.copy(runningChallanges.RunningChallenges).filter(isChallengeAllowedOnWallboard);

            // If only one challenge is returned, the data of invitees and participants is merged to be displayed on the slide
            if (this.activeChallenges.length == 1)
                this.activeChallenges[0].Rankings = runningChallanges.RunningChallenges[0].Rankings.concat(runningChallanges.RunningChallenges[0].NotRankings);
        }
        catch (error) {
            console.log(error);
        } finally {
            this.filterChallenges();
        }
    }

    public async loadCurrentAgentStatesSlideSettings(moduleDetails, isNew) {
        if (this.cvConfigurationService.isCxOne) {
            this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 1);
            return;
        }
        // PM standalone slide settings
        if (isNew) {
            this.editedWallboard.Slides.push(angular.copy(this.slideToAdd));
            this.selectedSlideIndex = this.editedWallboard.Slides.length - 1;
        }

        this.slideoutSettingsOpen = true;
        await this.loadSlideoutSettings();

        setTimeout(() => { this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettingsOpen = true; }, 0);
        if (!this.editedWallboard.Slides[this.selectedSlideIndex].FirstSettingOpen || isNew) {
            this.controlsLoadId++;
            this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 1);
        }
        this.editedWallboard.Slides[this.selectedSlideIndex].FirstSettingOpen = true;
    }

    public async loadIntervalChartSlideSettings(moduleDetails, isNew) {
        if (isNew) {
            this.editedWallboard.Slides.push(angular.copy(this.slideToAdd));
            this.selectedSlideIndex = this.editedWallboard.Slides.length - 1;
        }
        this.slideoutSettingsOpen = true;
        if (!this.editedWallboard.Slides[this.selectedSlideIndex].FirstSettingOpen || isNew) {
            await this.loadSlideoutSettings();
        }
        setTimeout(() => { this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettingsOpen = true; }, 0);
        if (!this.editedWallboard.Slides[this.selectedSlideIndex].FirstSettingOpen || isNew) {
            this.controlsLoadId++;
            this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 10);
        }
        this.editedWallboard.Slides[this.selectedSlideIndex].FirstSettingOpen = true;
    }

    public async loadGaugeSlideSettings(moduleDetails, moduleIndex) {
        this.gaugeSetupObj = angular.copy(this.loadedModuleStates[this.selectedModuleIndex].gaugeObj);
        try {
            await this.loadEditSlideControls(moduleDetails.WallboardModuleKey, 1);
            const modulePo = await this.wallboardsService.loadModulePerformanceObjectives(
                this.selectedMetricInfo[0].mID,
                this.editedWallboard.CreatorLoginID,
                moduleDetails.WallboardModuleKey
            );
            this.loadedModuleStates[moduleIndex].gaugeObj.curLowerBound = modulePo.Bound;
            this.loadedModuleStates[moduleIndex].gaugeObj.curAlert = modulePo.Alert_Threshold;
            this.loadedModuleStates[moduleIndex].gaugeObj.curValue = modulePo.Value;
        } catch (error) {
            console.log(error);
        }
    }

    public async marketplaceSettingsSetup() {
        if (this.SettingsModuleType != ModuleType.Marketplace) {
            return;
        }
        if (!this.marketplaceSetupObj.InitialSettings) {
            this.marketplaceTitle = this.marketplaceSetupObj.SlideTitle;
            this.marketplaceView = this.marketplaceSetupObj.DisplayOption;
            this.selectedProducts = this.marketplaceSetupObj.ProductList;
            this.marketplaceFilterSale = this.marketplaceSetupObj.ProductTypes[0];
            this.marketplaceFilterFeatured = this.marketplaceSetupObj.ProductTypes[1];
            this.marketplaceFilterBestSeller = this.marketplaceSetupObj.ProductTypes[2];
        }
        else {
            this.marketplaceTitle = `Marketplace`;
            this.marketplaceView = 1;
            this.selectedProducts = [];
            this.marketplaceFilterSale = false;
            this.marketplaceFilterFeatured = false;
            this.marketplaceFilterBestSeller = false;
        }

        this.marketplaceSearch = "";
        this.marketplaceFilterCategory = null;
        this.marketplaceFilterSubCategory = "";

        if (!this.areProductsLoading && !this.marketplaceProducts) {
            this.areProductsLoading = true;

            try {
                const productList = await this.wallboardsService.loadPointStoreProducts(this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, this.editedWallboard.CreatorLoginID);
                this.marketplaceProducts = productList;

                const currentDate = new Date();
                this.marketplaceProducts = this.marketplaceProducts.filter((product) =>
                    (product.Active && new Date(product.ProductStart).compareTo(currentDate) <= 0 && (!product.ProductEnd || new Date(product.ProductEnd).compareTo(currentDate) >= 0)));

                for (const product of this.marketplaceProducts) {
                    // Construct category list
                    const category = this.marketplaceCategories.find(o => o.CategoryName == product.Category);
                    if (category) {
                        if (!category.SubCategories.find(o => o == product.SubCategory))
                            category.SubCategories.push(product.SubCategory);
                    }
                    else
                        this.marketplaceCategories.push({
                            CategoryName: product.Category,
                            SubCategories: [product.SubCategory]
                        });

                    // If the sale period for the product hasn't started or has already ended, it is not considered as a product on sale
                    if ((!product.SaleStart || new Date(product.SaleStart).compareTo(currentDate) > 0) || (product.SaleEnd && new Date(product.SaleEnd).compareTo(currentDate) < 0))
                        product.Sale = 0;
                }

                this.setupMarketplaceAgGrid();
            } catch (error) {
                console.log(error);
            } finally {
                this.areProductsLoading = false;
            }
        }
        else {
            this.setupMarketplaceAgGrid();
        }
    }

    /**
     * Sets up the marketplace AG Grid.
     * */
    public setupMarketplaceAgGrid(): void {
        this.gridOptionsMarketplace = this.agGridHelperService.createGridOptions({
            columnDefs: [
                {
                    field: `Title`,
                    headerName: this.localizationMarketplace.get(`Title`),
                    filter: `agTextColumnFilter`,
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    checkboxSelection: true,
                    menuTabs: [],
                    width: 286
                },
                {
                    field: `Category`,
                    headerName: this.localizationMarketplace.get(`Category`),
                    filter: `agTextColumnFilter`,
                    menuTabs: [],
                    width: 90
                },
                {
                    field: 'SubCategory',
                    headerName: this.localizationMarketplace.get(`Sub_Category`),
                    filter: `agTextColumnFilter`,
                    menuTabs: [],
                    width: 103
                },
                {
                    field: `VariationsData`,
                    headerName: this.localizationMarketplace.get(`Variations`),
                    filter: `agTextColumnFilter`,
                    cellRenderer: (param) => (!param.value ? this.localizationMarketplace.get(`None`) : `${param.value.length} ${param.data.VariationName}`),
                    menuTabs: [],
                    width: 85
                },
                {
                    field: `Price`,
                    headerName: this.localizationMarketplace.get(`Price`),
                    cellRenderer: (params) => {
                        if (params.data.HasProductVariations && params.data.HasVariationPrices) {
                            let initialVariationPrice = 0;
                            const initialVariation = params.data.VariationsData.reduce((prev, curr) => {
                                let prevValue = prev.VariationPrice;
                                let currValue = curr.VariationPrice;
                                if (prev.VariationOnSale)
                                    prevValue = prev.VariationPrice - (prev.VariationPrice * (params.data.Sale / 100));
                                if (curr.VariationOnSale)
                                    currValue = curr.VariationPrice - (curr.VariationPrice * (params.data.Sale / 100));
                                return prevValue < currValue ? prev : curr;
                            });
                            initialVariationPrice = initialVariation.VariationOnSale ? Math.ceil(initialVariation.VariationPrice - ((params.data.Sale / 100.0) * initialVariation.VariationPrice)) : initialVariation.VariationPrice;

                            let lastVariationPrice = 0;
                            const lastVariation = params.data.VariationsData.reduce((prev, curr) => {
                                let prevValue = prev.VariationPrice;
                                let currValue = curr.VariationPrice;
                                if (prev.VariationOnSale)
                                    prevValue = prev.VariationPrice - (prev.VariationPrice * (params.data.Sale / 100));
                                if (curr.VariationOnSale)
                                    currValue = curr.VariationPrice - (curr.VariationPrice * (params.data.Sale / 100));
                                return prevValue > currValue ? prev : curr;
                            });
                            lastVariationPrice = lastVariation.VariationOnSale ? Math.ceil(lastVariation.VariationPrice - ((params.data.Sale / 100.0) * lastVariation.VariationPrice)) : lastVariation.VariationPrice;

                            return `<span>${initialVariationPrice} - ${lastVariationPrice}</span>`;
                        }
                        else
                            return `<span>${params.value}</span>`;
                    },
                    menuTabs: [],
                    width: 113
                },
                {
                    field: `Quantity`,
                    headerName: this.localizationMarketplace.get(`Quantity`),
                    cellRenderer: (params) => {
                        if (!params.data.HasProductVariations)
                            return `<span>${!params.data.Quantity ? this.localizationMarketplace.get("Unlimited") : params.data.Quantity}</span>`;
                        else {
                            let totalQty = 0;
                            let unlimitedVariationCount = 0;
                            params.data.VariationsData.forEach((variation, index) => {
                                if (variation.VariationQuantity != null)
                                    totalQty += variation.VariationQuantity;
                                else
                                    unlimitedVariationCount++;
                            });

                            return `<span>${unlimitedVariationCount == params.data.VariationsData.length ? this.localizationMarketplace.get("Unlimited") : totalQty}</span>`;
                        }
                    },
                    filter: `agTextColumnFilter`,
                    menuTabs: [],
                    width: 77
                },
                {
                    field: `QuantityOrdered`,
                    headerName: this.localizationMarketplace.get(`Ordered`),
                    menuTabs: [],
                    width: 76
                },
                {
                    field: `ProductStart_ForView`,
                    headerName: this.localizationMarketplace.get(`Start`),
                    filter: `agTextColumnFilter`,
                    menuTabs: [],
                    width: 97
                },
                {
                    field: `ProductEnd_ForView`,
                    headerName: this.localizationMarketplace.get(`End`),
                    filter: `agTextColumnFilter`,
                    menuTabs: [],
                    width: 97
                }
            ],
            onGridReady: params => {
                this.gridApiMarketplace = params.api;
                if (this.marketplaceProducts)
                    params.api.setGridOption('rowData', this.marketplaceProducts);
                params.api.sizeColumnsToFit();

                if (!this.marketplaceSetupObj.InitialSettings) {
                    this.gridApiMarketplace.forEachNode((node) => {
                        if (this.selectedProducts.includes(node.data.PointStoreProductID))
                            node.setSelected(true);
                    });
                }
            },
            getRowId: ({ data: rowData }) => rowData.PointStoreProductID,
            isExternalFilterPresent: () => !!this.marketplaceSearch || this.marketplaceFilterSale || this.marketplaceFilterFeatured || this.marketplaceFilterBestSeller || !!this.marketplaceFilterCategory || !!this.marketplaceFilterSubCategory,
            doesExternalFilterPass: (node: RowNode) => (!this.marketplaceFilterCategory || node.data.Category.toLowerCase().indexOf(this.marketplaceFilterCategory.CategoryName.toLowerCase()) > -1)
                    && (!this.marketplaceFilterSubCategory || node.data.SubCategory.toLowerCase().indexOf(this.marketplaceFilterSubCategory.toLowerCase()) > -1)
                    && this.agGridHelperService.doesExternalFilterPass(node, this.marketplaceSearch)
                    && (!this.marketplaceFilterSale || (this.marketplaceFilterSale && node.data.Sale > 0))
                    && (!this.marketplaceFilterFeatured || (this.marketplaceFilterFeatured && node.data.FeatureStart))
                    && (!this.marketplaceFilterBestSeller || (this.marketplaceFilterBestSeller && node.data.isBestSeller))
                    && !node.data.IsDeletedChecked,
            onGridSizeChanged: gridEvent => {
                if (gridEvent.clientWidth > 0)
                    gridEvent.api.sizeColumnsToFit();
            },
            onColumnVisible: event => event.api.sizeColumnsToFit(),
            suppressRowClickSelection: true,
            suppressCellFocus: true,
            suppressMovableColumns: true,
            overlayNoRowsTemplate: `<span class="px-5 color-valyrianSteel font-size-24">${this.localization.get("No_Results_Found")}</span>`,
            onSelectionChanged: () => {
                this.selectedProducts = this.gridApiMarketplace.getSelectedRows().map((prod) => prod.PointStoreProductID);
            },
            rowSelection: 'multiple',
            rowHeight: 42,
        });
    }

    /**
     * Returns the localized name of the current slide type.
     * */
    public slideTypeName(overrideType: ModuleType = ModuleType.Custom): string {
        let moduleType = this.SettingsModuleType;
        if (overrideType != ModuleType.Custom)
            moduleType = overrideType;

        switch (moduleType) {
            case ModuleType.SummaryModule:
                return this.localization.get(`Summary`);
            case ModuleType.IntervalChart:
                return this.localization.get(`Interval_Chart`);
            case ModuleType.ImageModule:
                return this.localization.get(`Image`);
            case ModuleType.Top:
                return this.localization.get(`Top_Module`);
            case ModuleType.AgentCounter:
                return this.localization.get(`Agent_Counter`);
            case ModuleType.CurrentAgentStates:
                return this.localization.get(`Current_Agent_States`);
            case ModuleType.ResponsiveCurrentAgentStates:
                return this.localization.get(`Responsive_Agent_States`);
            case ModuleType.Kpi:
                return this.localization.get(`Kpi_Module`);
            case ModuleType.Games:
                return this.localization.get(`Gamification`);
            default:
                return this.localization.get(ModuleType[moduleType]);
        }
    }

    /**
     * Loads the controls for Group-type settings for the slide settings modal.
     * @param counterControls
     * @param slideKey Key of the slide currently being edited
     * @param maxMetrics Maximum number of metrics allowed
     * @param hasToggle True if the settings should have a toggle, false if not
     */
    public async loadEditSlideControls(slideKey: string, maxMetrics: number, hasToggle = true, counterControls = false): Promise<void> {
        let requestId;
        try {
            // This is to ensure that only the final request applies the values it retrieved. controlsLoadId is incremented on all successful slide selections and settings modal openings.
            requestId = this.controlsLoadId;
            this.areControlsLoading = true;

            let slideControls;
            if (!counterControls)
                slideControls = await this.wallboardsService.loadSlideControls(slideKey, this.editedWallboard.CreatorLoginID, maxMetrics, hasToggle);
            else
                slideControls = await this.wallboardsService.loadCounterControls(slideKey, this.editedWallboard.CreatorLoginID);

            if (requestId < this.controlsLoadId)
                return;

            if (this.SettingsModuleType == ModuleType.Challenges && !counterControls) {
                // TODO: Getting some kind of error... trying to close the dropdown after selecting a group on the challenges selector will throw a
                // "Object reference not set to an instance of an object." error. Same error occurs on the other selectors, but seemingly only
                // if I click on the icons between each selector.
                $(`#challengesEmpFilter`).on(`DOMSubtreeModified`, () => {
                    this.zone.run(() => {
                        $(`#challengesEmpFilter > .groupSelectorContainer > .groupArea > .expColArea`).css(`width`, `0px`);
                        $(`#challengesEmpFilter > .groupSelectorContainer > .groupArea > .showGroups > .groupImgDropDown`).css(`right`, `12px`);
                        $(`#challengesEmpFilter > .groupSelectorContainer > .groupArea > .showGroups > .groupSelectorPipe`).css(`right`, `22px`);
                    });
                });
            }

            $(`.setupEmpSelectorContainer`).html(slideControls.Emp_Selector_Html);
            $(`.setupRecSelectorContainer`).html(slideControls.Rec_Selector_Html);

            if (!counterControls) {
                if (!this.cvConfigurationService.isCxOne) {
                    $(`.setupAttSelectorContainer`).html(slideControls.Attribute_Html);
                }

                $(`.setupDateRangeContainer`).html(slideControls.Date_Picker_Html);
                $(`.setupTimeRangeContainer`).html(slideControls.Time_Range_Html);

                this.selectedMetricInfo = slideControls.Selected_Metric_Info;
                this.$window.initSlider?.($(`.setupDateSelectorContainer`));
            }
        }
        catch (error) {
            console.log(error);
        }
        finally {
            if (requestId == this.controlsLoadId)
                this.areControlsLoading = false;
        }
    }

    /**
     * Moves to the specified section on a slide's settings modal.
     * @param destinationSection Section to move to
     */
    public async jumpToModalSection(destinationSection: number): Promise<void> {
        if (this.slideSettingsModalSection == destinationSection || (this.areControlsLoading && this.slideSettingsModalSection < destinationSection && (this.selectedModuleType != 0 || this.slideSettingsModalSection != 1)))
            return;

        if (this.SettingsModuleType == ModuleType.Spotlight && this.slideSettingsModalSection == 3 && this.spotlightCroppedImage && !this.spotlightSetupObj.UploadedImageString &&
            (!this.spotlightSetupObj.UseLogin || (this.spotlightSetupObj.ImageDisplay == `Other` && this.spotlightSetupObj.UseLogin)))
            this.spotlightSetupObj.UploadedImageString = this.spotlightCroppedImage;

        // Restrictions based on destination section
        switch (destinationSection) {
            case 3:
                switch (this.SettingsModuleType) {
                    case ModuleType.Spotlight:
                        if (this.spotlightSetupObj.UseLogin && !this.spotlightSetupObj.LoginID) {
                            this.openErrorDialog(`Error_Spotlight_Login`);
                            return;
                        }
                        else if (!this.spotlightSetupObj.UseLogin && !this.spotlightSetupObj.LoginName) {
                            this.openErrorDialog(`Error_Spotlight_Name`);
                            return;
                        }
                        break;
                    case ModuleType.Gauge:
                    case ModuleType.Thermometer:
                    case ModuleType.Kpi:
                        if (this.selectedMetricInfo.length < 1) {
                            // No metric added
                            this.openErrorDialog(`Error_Select_Metric`);
                            return;
                        }

                        if (!this.moduleValueBoundAlertValidation())
                            return;
                        break;
                    case ModuleType.SummaryModule:
                    case ModuleType.Top:
                        if (this.selectedMetricInfo.length < 1) {
                            // No metric added
                            this.openErrorDialog(`Error_Select_Metric`);
                            return;
                        }
                        break;
                    case ModuleType.Games:
                        if (this.selectedGame.length == 0) {
                            this.openErrorDialog(`Error_Select_Game`);
                            return;
                        }

                        if (this.wallboardGameSetupObj && this.wallboardGameSetupObj.GameType == 2)
                            this.wallboardGameSetupObj.DisplayOption = 1;
                        break;
                    case ModuleType.Marketplace:
                        if (this.selectedProducts.length == 0) {
                            this.openErrorDialog(`Error_No_Products_Selected`);
                            return;
                        }
                        break;
                    default:
                        break;
                }
                break;
            case 4:
                switch (this.SettingsModuleType) {
                    case ModuleType.Leaderboard:
                    case ModuleType.Summary:
                        if (this.areControlsLoading)
                            return;
                        else if (this.selectedMetricInfo.length < 1) {
                            // No metric added
                            this.openErrorDialog(`Error_Select_Metrics`);
                            return;
                        }
                        break;
                    case ModuleType.Racing:
                        if (this.areControlsLoading)
                            return;
                        else if (this.selectedMetricInfo.length < 1) {
                            this.openErrorDialog(`Error_Select_Metric`);
                            return;
                        }
                        else if (!this.selectedMetricInfo[0].DisplayName) {
                            this.openErrorDialog(`Error_Metric_Display`);
                            return;
                        }
                        break;
                    case ModuleType.Spotlight:
                        if (this.spotlightSetupObj.UseLogin && !this.spotlightSetupObj.LoginID) {
                            this.openErrorDialog(`Error_Spotlight_Login`);
                            return;
                        }
                        else if (!this.spotlightSetupObj.UseLogin && !this.spotlightSetupObj.LoginName) {
                            this.openErrorDialog(`Error_Spotlight_Name`);
                            return;
                        }
                        else if (this.spotlightSetupObj.ImageDisplay == `Other` && !this.spotlightSetupObj.UploadedImageString && !this.spotlightSetupObj.ImageID) {
                            this.openErrorDialog(`Error_Upload_Image`);
                            return;
                        }
                        break;
                    case ModuleType.Gauge:
                    case ModuleType.Thermometer:
                    case ModuleType.Kpi:
                        if (this.selectedMetricInfo.length < 1) {
                            // No metric added
                            this.openErrorDialog(`Error_Select_Metric`);
                            return;
                        }

                        if (!this.moduleValueBoundAlertValidation())
                            return;
                        break;
                    case ModuleType.SummaryModule:
                    case ModuleType.Top:
                        if (this.selectedMetricInfo.length < 1) {
                            // No metric added
                            this.openErrorDialog(`Error_Select_Metric`);
                            return;
                        }
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }

        // Restriction based on current section
        switch (this.slideSettingsModalSection) {
            case 1:
                if (this.selectedModuleType == 0) {
                    if (isNaN(parseInt(this.intervalMin, 10)) || isNaN(parseInt(this.intervalSec, 10))) {
                        this.openErrorDialog(`Error_Invalid_Interval_Time`);
                        return;
                    }

                    if (!this.slideToAdd.SlideName) {
                        this.openErrorDialog(`Error_Slide_Name`);
                        return;
                    }

                    if (this.SettingsModuleType == ModuleType.Games && !this.areGamesLoading) {
                        this.gamesList = this.formatGamesList(angular.copy(this.gameFolders), this.selectedGame[0] ?? null);

                        if (this.wallboardGameSetupObj.GameID)
                            this.selectedGame = this.gamesList.filter((game) => game.RuleID && game.RuleID === this.wallboardGameSetupObj.GameID) || [];
                        else
                            this.selectedGame = [];
                    }
                }
                else if (this.SettingsModuleType == ModuleType.AgentCounter) {
                    if (this.chartPreview)
                        this.chartPreview.destroy();

                    this.chartPreview = new Chart(document.getElementById(`chartPreview`) as any, {
                        type: `doughnut`,
                        data: {
                            datasets: [
                                {
                                    data: [1, 1, 1, 1, 1],
                                    backgroundColor: [
                                        `rgba(61, 150, 73, 1)`, // Available
                                        `rgba(124, 82, 191, 1)`, // Inbound
                                        `rgba(228, 179, 33, 1)`, // Outbound
                                        `rgba(241, 102, 34, 1)`, // ACW
                                        `rgba(189, 32, 38, 1)` // Unavailable
                                    ],
                                    borderColor: `transparent`,
                                    borderWidth: 5
                                }
                            ],
                            labels: [
                                `Available`,
                                `Inbound`,
                                `Outbound`,
                                `ACW`,
                                `Unavailable`
                            ]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            animation: {
                                duration: 0
                            },
                            plugins: {
                                datalabels: {
                                    anchor: (k) => `center`,
                                    display: true,
                                    backgroundColor: (context) => null,
                                    borderRadius: (k) => 0,
                                    borderWidth: (k) => 0,
                                    color: 'white',
                                    font: (context) => {
                                        const size = Math.round(context.chart.width / 20);
                                        const minSize = 12;

                                        return {
                                            size: size < minSize ? minSize : size,
                                            weight: `bold`
                                        };
                                    },
                                    formatter: (value, context) => value
                                },
                                legend: { display: false },
                                tooltip: { enabled: false },
                            },
                            layout: {
                                padding: {
                                    left: 0,
                                    right: 0,
                                    top: 0,
                                    bottom: 0
                                }
                            }
                        }
                    });
                }
                break;
            default:
                break;
        }

        this.slideSettingsModalSection = destinationSection;

        if (this.SettingsModuleType == ModuleType.Spotlight && (destinationSection == 3 || destinationSection == 4) && this.spotlightSetupObj.UseLogin && this.spotlightSetupObj.LoginID > 0) {
            this.loadSpotlightLoginInfo();

            if (this.editedWallboard.CreatorGamificationAccess) {
                if (this.spotlightBadges == null) {
                    try {
                        this.spotlightBadges = await this.wallboardsService.loadSpotlightBadges();
                    }
                    catch (error) {
                        console.log(error);
                    }
                }
            }
            else
                this.spotlightSetupObj.ShowBadges = false; // Will hide them on the view side
        }

        // Populate the metric values if a metric has been selected previously
        if (this.selectedMetricInfo.length > 0) {
            if (((this.SettingsModuleType == ModuleType.Gauge || this.SettingsModuleType == ModuleType.Thermometer || this.SettingsModuleType == ModuleType.SummaryModule || this.SettingsModuleType == ModuleType.Top
                || this.SettingsModuleType == ModuleType.Kpi) && (destinationSection == 2))
                || ((this.SettingsModuleType == ModuleType.Leaderboard || this.SettingsModuleType == ModuleType.Summary) && destinationSection == 3)) {
                this.lowerBoundFormatted = this.formatterMetricData(this.selectedMetricInfo[0]?.mCT, this.SelectedModuleSetupObj?.LowerBound);
                this.alertFormatted = this.formatterMetricData(this.selectedMetricInfo[0]?.mCT, this.SelectedModuleSetupObj?.Alert);
                this.valueFormatted = this.formatterMetricData(this.selectedMetricInfo[0]?.mCT, this.SelectedModuleSetupObj?.Value);
            }
            else if (this.SettingsModuleType == ModuleType.Racing && destinationSection == 4) {
                this.racingStartFormatted = this.formatterMetricData(this.selectedMetricInfo[0]?.mCT, this.racingSetupObj?.StartingLine);
                this.racingFinishFormatted = this.formatterMetricData(this.selectedMetricInfo[0]?.mCT, this.racingSetupObj?.FinishLine);
            }
        }
    }

    /**
     * Returns true if keypress event was for an approved key, false if otherwise.
     * @param event Keypress event
     * @param conversionType Type of format to validate against
     */
    public allowedKeysOnly(event, conversionType: string | number): boolean {
        let charCode = event.which ?? event.keyCode;
        let isNumberOrBasicAction = charCode <= 31 || (48 <= charCode && charCode <= 57);

        switch (parseInt(conversionType.toString())) {
            case 1: // Second
            case 2: // Minute
            case 3: // Hour
                // Numbers only
                return isNumberOrBasicAction;
            case 4: // Time
                // Numbers and colons only
                return isNumberOrBasicAction || charCode == 58;
            case 5: // Percent
                // Numbers and periods only
                return isNumberOrBasicAction || charCode == 46;
            default:
                // Numbers only
                return isNumberOrBasicAction;
        }
    }

    /**
     * Returns true if paste event only contained numbers, false if otherwise.
     * @param event Paste event
     * @param conversionType Type of format to validate against
     */
    public pasteAllowedCharactersOnly(event, conversionType: string | number): boolean {
        let pastedText = event.clipboardData.getData('text');

        if (pastedText.length > 9)
            return false;

        switch (parseInt(conversionType.toString())) {
            case 1: // Second
            case 2: // Minute
            case 3: // Hour
                // Integers only
                return !isNaN(Number(pastedText)) && !pastedText.match(/\./g);
            case 4: // Time
                // Numbers and colons only
                return !pastedText.match(/[^\d:]/g);
            case 5: // Percent
                // Numbers and periods only
                return !isNaN(Number(pastedText)) || pastedText == ".";
            default:
                // Integers only
                return !isNaN(Number(pastedText)) && !pastedText.match(/\./g);
        }
    }

    /**
     * Runs a sequence of validation checks meant for modules with the standard group and metric controls. Returns true if it passes, opens an error dialog and returns false if it doesn't.
     * */
    public moduleValueBoundAlertValidation(): boolean {
        if (this.SelectedModuleSetupObj.isOverride) {
            if (this.selectedMetricInfo[0].mDir == 1 && !this.SelectedModuleSetupObj.LowerBound)
                this.SelectedModuleSetupObj.LowerBound = 0;

            if ((!this.SelectedModuleSetupObj.LowerBound && this.SelectedModuleSetupObj.LowerBound !== 0) || (!this.SelectedModuleSetupObj.Alert && this.SelectedModuleSetupObj.Alert !== 0)
                || (!this.SelectedModuleSetupObj.Value && this.SelectedModuleSetupObj.Value !== 0)) {
                // Empty inputs
                this.openErrorDialog("Error_Value_Bound_Alert");
                return false;
            }

            if (isNaN(this.SelectedModuleSetupObj.LowerBound) || isNaN(this.SelectedModuleSetupObj.Alert) || isNaN(this.SelectedModuleSetupObj.Value)) {
                // Non-number inputs
                this.openErrorDialog(`Error_Value_Bound_Alert_Number`);
                return false;
            }

            this.SelectedModuleSetupObj.LowerBound = +this.SelectedModuleSetupObj.LowerBound;
            this.SelectedModuleSetupObj.Alert = +this.SelectedModuleSetupObj.Alert;
            this.SelectedModuleSetupObj.Value = +this.SelectedModuleSetupObj.Value;

            if (this.SelectedModuleSetupObj.Value > 2147483647 || this.SelectedModuleSetupObj.Alert > 2147483647 || this.SelectedModuleSetupObj.LowerBound > 2147483647
                || this.SelectedModuleSetupObj.Value < -2147483647 || this.SelectedModuleSetupObj.Alert < -2147483647 || this.SelectedModuleSetupObj.LowerBound < -2147483647) {
                // Inputs too high/low
                this.openErrorDialog(`Error_Value_Bound_Alert_Range`);
                return false;
            }

            if (this.selectedMetricInfo[0].mDir == 0) {
                if (this.SelectedModuleSetupObj.Value >= this.SelectedModuleSetupObj.Alert) {
                    // Inputs in nonsensical order
                    this.openErrorDialog("Error_Value_Less_Than_Alert");
                    return false;
                }

                if (this.SelectedModuleSetupObj.LowerBound <= this.SelectedModuleSetupObj.Alert) {
                    this.openErrorDialog("Error_Bound_Greater_Than_Alert");
                    return false;
                }
            }
            else {
                if (this.SelectedModuleSetupObj.Value <= this.SelectedModuleSetupObj.Alert) {
                    this.openErrorDialog("Error_Value_Greater_Than_Alert");
                    return false;
                }

                if (this.SelectedModuleSetupObj.LowerBound >= this.SelectedModuleSetupObj.Alert) {
                    this.openErrorDialog("Error_Bound_Less_Than_Alert");
                    return false;
                }
            }
        }

        return true;
    }

    /**
     * Returns true if the currently selected section of the slide modal is the last one, false if otherwise.
     * */
    public onLastModalSection(): boolean {
        switch (this.SettingsModuleType) {
            case ModuleType.Custom:
            case ModuleType.Text:
            case ModuleType.ImageModule:
                return true;
            case ModuleType.Image:
            case ModuleType.Video:
            case ModuleType.AgentCounter:
            case ModuleType.Challenges:
                return this.slideSettingsModalSection == 2;
            case ModuleType.Gauge:
            case ModuleType.Thermometer:
            case ModuleType.SummaryModule:
            case ModuleType.Top:
            case ModuleType.CurrentAgentStates:
            case ModuleType.ResponsiveCurrentAgentStates:
            case ModuleType.Kpi:
            case ModuleType.Games:
            case ModuleType.Marketplace:
                return this.slideSettingsModalSection == 3;
            case ModuleType.Leaderboard:
            case ModuleType.Racing:
            case ModuleType.Summary:
            case ModuleType.IntervalChart:
            case ModuleType.Spotlight:
                return this.slideSettingsModalSection == 4;
            default:
                return false;
        }
    }

    /**
     * Returns the proper class for the Groups tab on the modal. Useful for how complicated this tab's conditions are.
     * */
    public groupTabClass(): string {
        switch (this.SettingsModuleType) {
            case ModuleType.Leaderboard:
            case ModuleType.Racing:
            case ModuleType.Summary:
            case ModuleType.IntervalChart:
            case ModuleType.CurrentAgentStates:
            case ModuleType.ResponsiveCurrentAgentStates:
                if (this.slideSettingsModalSection == 2) {
                    if (!this.areControlsLoading)
                        return `d-flex`;
                    else
                        return "";
                }
                else
                    return `d-none`;
            case ModuleType.Gauge:
            case ModuleType.Thermometer:
            case ModuleType.SummaryModule:
            case ModuleType.Top:
            case ModuleType.AgentCounter:
            case ModuleType.Kpi:
                if (this.slideSettingsModalSection == 1) {
                    if (!this.areControlsLoading)
                        return `d-flex`;
                    else
                        return "";
                }
                else
                    return `d-none`;
            default:
                return `d-none`;
        }
    }

    /**
     * Returns the proper class for the Metrics tab on the modal. Useful for how complicated this tab's conditions are.
     * */
    public metricTabClass(): string {
        switch (this.SettingsModuleType) {
            case ModuleType.Leaderboard:
            case ModuleType.Racing:
            case ModuleType.Summary:
                if (this.slideSettingsModalSection == 3) {
                    if (!this.areControlsLoading)
                        return `d-flex`;
                    else
                        return "";
                }
                else
                    return `d-none`;
            case ModuleType.Gauge:
            case ModuleType.Thermometer:
            case ModuleType.SummaryModule:
            case ModuleType.Top:
            case ModuleType.Kpi:
                if (this.slideSettingsModalSection == 2) {
                    if (!this.areControlsLoading)
                        return `d-flex`;
                    else
                        return "";
                }
                else
                    return `d-none`;
            default:
                return `d-none`;
        }
    }

    /**
     * Returns the proper class for the Details tab on the modal. Useful for how complicated this tab's conditions are.
     * */
    public detailsTabClass(): string {
        switch (this.SettingsModuleType) {
            case ModuleType.AgentCounter:
                return this.slideSettingsModalSection == 2 ? `d-flex` : `d-none`;
            case ModuleType.Gauge:
            case ModuleType.Thermometer:
            case ModuleType.SummaryModule:
            case ModuleType.Top:
            case ModuleType.CurrentAgentStates:
            case ModuleType.ResponsiveCurrentAgentStates:
            case ModuleType.Kpi:
                return this.slideSettingsModalSection == 3 ? `d-flex` : `d-none`;
            case ModuleType.Leaderboard:
            case ModuleType.Summary:
            case ModuleType.IntervalChart:
                return this.slideSettingsModalSection == 4 ? `d-flex` : `d-none`;
            default:
                return `d-none`;
        }
    }

    /**
     * Updates slide interval value when the front-facing interface for it changes.
     * */
    public recalculateInterval(): void {
        this.slideToAdd.SlideInterval = (+this.intervalMin * 60) + +this.intervalSec;
        if (this.slideToAdd.SlideInterval < 15)
            this.slideToAdd.SlideInterval = 15;
    }

    /**
     * Opens file selector for the purpose of uploading a slide image.
     * */
    public uploadImage(): void {
        $('#imageUploadInput').trigger("click");
    }

    /**
     * Is run when a new slide image is uploaded.
     * */
    public handleImageUpload(event: Event): void {
        const target = event.currentTarget as HTMLInputElement;
        const file = target.files[0];

        const reader = new FileReader();
        reader.onload = (evt) => {
            this.imageSetupObj.UploadedImageID = 0;
            this.imageSetupObj.UploadedImageString = evt.target.result as string;
        };
        reader.readAsDataURL(file);
    }

    /**
     * Applies the selection of a URL for a video type slide.
     * */
    public applyVideoUrl(): void {
        const videoId = this.videoId;

        if (!videoId || videoId.length != 11) {
            this.videoInfo = null;
            this.videoSetupObj.ThumbImg = null;
        }
        else {
            this.isVideoInfoLoading = true;
            this.youTubeInfoService.getYouTubeInformation(videoId).then(videoInfo => {
                this.videoInfo = videoInfo.items[0].snippet;

                let biggestThumbnail = { height: 0, url: "" };
                angular.forEach(this.videoInfo.thumbnails, thumbnail => {
                    if (biggestThumbnail.height < thumbnail.height)
                        biggestThumbnail = thumbnail;
                });

                this.videoSetupObj.ThumbImg = biggestThumbnail.url;
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.isVideoInfoLoading = false;
            });
        }
    }

    /**
     * Applies properties for the different employee display modes for spotlight slides.
     * */
    public setLoginTypeState(): void {
        if (!this.spotlightSetupObj.UseLogin) {
            this.spotlightSetupObj.UseProfileBio = false;
            this.spotlightSetupObj.ShowBadges = false;
            this.spotlightSetupObj.ImageDisplay = `Other`;
        }
        else
            this.spotlightSetupObj.ImageDisplay = `Profile`;

        this.spotlightSetupObj.LoginID = null;
        this.spotlightSetupObj.LoginName = "";
        this.spotlightSetupObj.ImageID = null;
        this.spotlightSetupObj.UploadedImageString = null;

        this.spotlightSearch = "";
        this.spotlightCroppedImage = null;
    }

    /**
     * Sets the specified login as the one for the current slide.
     * @param login Login to select
     */
    public selectLogin(login: LoginListObj): void {
        this.spotlightSetupObj.LoginID = login.LoginID;
        this.spotlightSetupObj.LoginName = login.LoginName;
        this.spotlightSetupObj.ImageDisplay = `Profile`;
        this.spotlightSetupObj.ImageID = null;
        this.spotlightSetupObj.UploadedImageString = null;

        this.spotlightCroppedImage = null;
    }

    /**
     * Applies spotlight image uploaded through the cv-img-crop directive.
     * */
    public acceptSpotlightImageUpload(): void {
        this.spotlightSetupObj.UploadedImageString = this.spotlightCroppedImage;
        this.spotlightCroppedImage = null;
    }

    /**
     * Resets cv-img-crop directive.
     * */
    public cancelSpotlightImageUpload(): void {
        this.spotlightCroppedImage = null;

        this.spotlightCropReset = false;
        setTimeout(() => {
            this.spotlightCropReset = true;
        });
    }

    /**
     * Alters the view to allow the user to upload a new image for the spotlight slide.
     */
    public spotlightNewImage(): void {
        this.spotlightOriginalImageId = this.spotlightSetupObj.ImageID;
        this.spotlightSetupObj.ImageID = null;
        this.spotlightSetupObj.UploadedImageString = null;
    }

    /**
     * Reverts the spotlight slide back to using the already-uploaded image.
     */
    public spotlightOriginalImage(): void {
        this.spotlightSetupObj.ImageID = this.spotlightOriginalImageId;
        this.spotlightSetupObj.UploadedImageString = null;
        this.spotlightOriginalImageId = null;
        this.spotlightCroppedImage = null;
    }

    /**
     * Filters the list of game folders to only the ones that should be displayed.
     * */
    public filteredGameFolders(): any[] {
        if (!this.gameFolders)
            return;

        return this.gameFolders.filter((gameFolder) => gameFolder.Games && gameFolder.Games.length > 0 && this.filteredSortedGames(gameFolder.Games).length > 0);
    }

    /**
     * Filters and sorts the list of games in each folder to be displayed.
     * @param games List of games within a games folder
     */
    public filteredSortedGames(games: any[]): any[] {
        // Games and forlders with only Top Team, Raffle and Bracket tournament type games will not be displayed, remove once implemented
        return games.filter((game) => !this.notImplementedGames.includes(game.GameObject.underlyingRule.GameType) && (!this.gameSearch || game.GameObject.underlyingRule.RuleName.toLowerCase().includes(this.gameSearch.toLowerCase()))).sort((a, b) => {
            if (a.GameObject.underlyingRule.RuleName > b.GameObject.underlyingRule.RuleName)
                return 1;
            else if (a.GameObject.underlyingRule.RuleName < b.GameObject.underlyingRule.RuleName)
                return -1;
            else
                return 0;
        });
    }

    /**
     * Selects a game for the game slide settings.
     * @param game Game to select.
     */
    public selectGame(game): void {
        // Just to check if connect 3 will require a free space in the middle
        if ((game.GameObject.underlyingRule.GameType == 6 || game.GameObject.underlyingRule.GameType == 7) && game.GameObject.Connect3Positions.length == 8) {
            game.GameObject.Connect3Positions.splice(4, 0, { position: 4, metric: { abbrev: "Free Space", name: "Free Space", metricID: -1, target: null } });
        }

        this.selectedGame = [game.GameObject];
        this.wallboardGameSetupObj.GameID = game.GameObject.underlyingRule.RuleID;
        this.wallboardGameSetupObj.GameType = game.GameObject.underlyingRule.GameType;
    }

    /**
     * Formats the specified game folder list.
     * @param gamesFolderList List of game folders
     * @param selectedGame Currently selected game
     */
    public formatGamesList(gamesFolderList, selectedGame): any[] {
        const gamesListTemp = [];
        let isFirstElement = true;
        const tagsToReplace = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;'
        };

        for (const gameFolder of gamesFolderList) {
            if (gameFolder.Games.length > 0) {
                gamesListTemp.push({ RuleName: gameFolder.FolderData.FolderName, gameFolderGroup: true });

                for (const gameObject of gameFolder.Games) {
                    gameObject.GameObject.underlyingRule.icon = '<div class="glGame-list-icon ' + gameObject.GameObject.iconClass + '"></div>';
                    gameObject.GameObject.underlyingRule.RuleName = ((gameObject.GameObject.underlyingRule.RuleName).replace(/[&<>]/g, (tag) => tagsToReplace[tag] || tag)) + (gameObject.GameObject.isActive ? '' : '<span class="color-valyrianSteel"> - Inactive </span>');
                    //gameObject.GameObject.underlyingRule.RuleName = gameObject.GameObject.underlyingRule.RuleName.replace(/[&<>]/g, (tag) => tagsToReplace[tag] || tag) + (gameObject.GameObject.isActive ? '' : '<span class="color-valyrianSteel">' + ' - ' + gameObject.GameObject.isActiveText + '</span>');
                    gameObject.GameObject.underlyingRule.isSelected = selectedGame ? gameObject.GameObject.underlyingRule.RuleID == selectedGame.underlyingRule.RuleID : isFirstElement;
                    gamesListTemp.push(Object.assign({}, gameObject.GameObject, gameObject.GameObject.underlyingRule));
                    isFirstElement = false;

                    // Just to check if connect 3 will require a free space in the middle
                    if ((gameObject.GameObject.underlyingRule.GameType == 6 || gameObject.GameObject.underlyingRule.GameType == 7) && gameObject.GameObject.Connect3Positions.length == 8)
                        gameObject.GameObject.Connect3Positions.splice(4, 0, { position: 4, metric: { abbrev: "Free Space", name: "Free Space", metricID: -1, target: null } });

                    let isFirstInterval = true;
                    angular.forEach(gameObject.GameObject.Intervals, (interval, key) => {
                        interval.DisplayStringDate = formatDate(interval.StartDate, this.cvAngularDateFormat, this.locale) + ' - ' + formatDate(interval.EndDate, this.cvAngularDateFormat, this.locale);
                        if (gameObject.GameObject.underlyingRule.isSelected) {
                            interval.isSelected = isFirstInterval;
                            isFirstInterval = false;
                        }
                        else
                            interval.isSelected = false;

                        // Excluding Interval End Date when it is greater than Game's EndDate
                        if (gameObject.GameObject.underlyingRule.EndDate && ((gameObject.GameObject.Intervals.length - 1) == key)) {
                            const endDate = formatDate(gameObject.GameObject.underlyingRule.EndDate, this.cvAngularDateFormat, this.locale);
                            const intervalEndDate = formatDate(interval.EndDate, this.cvAngularDateFormat, this.locale);
                            if (intervalEndDate > endDate)
                                interval.DisplayStringDate = formatDate(interval.StartDate, this.cvAngularDateFormat, this.locale);
                        }
                    });
                }

                gamesListTemp.push({ gameFolderGroup: false });
            }
        }

        return gamesListTemp;
    }

    /**
     * Gets the correct classes for the ngClass directive for the Connect 3 and Blackout game previews.
     * @param metricPosition
     * @param gameType 6 for Connect3, 7 for Blackout
     */
    public getConnect3Class(metricPosition, gameType): any {
        const metricData = null;
        const classes = {} as any;

        if (metricPosition.metric.metricID == -1) {
            if (gameType == 6)
                classes.freeSpace = true;
            else
                classes.freeSpaceBlackout = true;
        }

        if (!metricPosition.metric)
            classes.simpleCard = true;

        if (metricPosition.metric && metricPosition.metric.metricID > -1) {
            if (gameType == 6) {
                if (metricData) {
                    // Verify if the target
                    if (metricPosition.targetObj.Direction == 0) {
                        // Less than
                        if (metricData.MyMetricValue <= metricPosition.targetObj.Target)
                            classes.cardCompleted = true;
                        else
                            classes.cardConfiguredConnect3 = true;
                    }
                    else {
                        // Greater than
                        if (metricData.MyMetricValue >= metricPosition.targetObj.Target)
                            classes.cardCompleted = true;
                        else
                            classes.cardConfiguredConnect3 = true;
                    }
                }
                else
                    classes.cardConfiguredConnect3 = true;
            }
            else {
                if (metricData) {
                    // Verify if the target
                    if (metricPosition.targetObj.Direction == 0) {
                        // Less than
                        if (metricData.MyMetricValue <= metricPosition.targetObj.Target)
                            classes.cardCompletedBlackout = true;
                        else
                            classes.cardConfiguredBlackout = true;
                    }
                    else {
                        // Greater than
                        if (metricData.MyMetricValue >= metricPosition.targetObj.Target)
                            classes.cardCompletedBlackout = true;
                        else
                            classes.cardConfiguredBlackout = true;
                    }
                }
                else
                    classes.cardConfiguredBlackout = true;
            }
        }

        return classes;
    }

    /**
     * Places metric values into their correct format.
     * @param conversionType Type of conversion the metric uses.
     * @param value Value of the metric.
     */
    public formatterMetricData(conversionType: string | number, value) {
        let formatted;

        // Return empty string for null/undefined values (no override set)
        if (value === null || value === undefined) {
            return "";
        }

        if (!value || isNaN(value)) {
            const test = value != null ? String(value).match(/^\d{2}:\d{2}:\d{2}$/g) : null;
            if (test && test.length > 0) {
                const array = [...value.matchAll(/\d{2}/g)];
                value = (parseInt(array[0], 10) * 3600) + (parseInt(array[1], 10) * 60) + parseInt(array[2], 10);
            }
            else
                value = 0;
        }

        if (!conversionType)
            conversionType = 0;

        switch (parseInt(conversionType.toString(), 10)) {
            case 1: // Second
                formatted = value;
                break;
            case 2: // Minute
                formatted = value / 60;
                break;
            case 3: // Hour
                formatted = Math.floor((value / 3600) * 100) / 100;
                break;
            case 4: // Time
                const hours = Math.floor(value / 3600);
                const minutes = Math.floor((value - (hours * 3600)) / 60);
                const seconds = value - (hours * 3600) - (minutes * 60);

                let hoursString = hours.toString();
                let minutesString = minutes.toString();
                let secondsString = seconds.toString();

                if (hours < 10)
                    hoursString = "0" + hours;
                if (minutes < 10)
                    minutesString = "0" + minutes;
                if (seconds < 10)
                    secondsString = "0" + seconds;
                formatted = `${hoursString}:${minutesString}:${secondsString}`;
                break;
            case 5: // Percent
                formatted = Math.round(value * 100);
                break;
            default:
                formatted = value;
                break;
        }

        setTimeout(() => {
            this.cdr.detectChanges();
        }, 1);

        return formatted;
    }

    /**
     * Converts metric values from their formatted form to the underlying value.
     * @param conversionType Type of conversion the metric uses.
     * @param value Formatted value of the metric.
     */
    public unformatterMetricData(conversionType: string | number, value) {
        let unformatted;

        let parsedValue = parseInt(value);
        if (parsedValue) {
            // Value is number
            value = parsedValue;
        }
        else {
            // Value is not a number, might be in 00:00:00 format
            let test = value?.match(/^\d{2}:\d{2}:\d{2}$/g);
            if (test && test.length > 0) {
                let array = [...value.matchAll(/\d{2}/g)];
                value = (parseInt(array[0]) * 3600) + (parseInt(array[1]) * 60) + parseInt(array[2]);
            }
            else
                value = 0;
        }

        switch (parseInt(conversionType.toString())) {
            case 1: // Second
            case 4: // Time
                unformatted = value;
                break;
            case 2: // Minute
                unformatted = value * 60;
                break;
            case 3: // Hour
                unformatted = value * 3600;
                break;
            case 5: // Percent
                unformatted = value / 100;
                break;
            default:
                unformatted = value;
                break;
        }

        setTimeout(() => {
            this.cdr.detectChanges();
        }, 1);

        return unformatted;
    }

    /**
     * Returns the URL of the badge for the given game at the given index.
     * @param game Game to get the badge of
     * @param index Index of the badge; 0 by default
     * @param size True for 30x30, false for 24x24; false by default
     */
    public getBadge(game, index = 0, size = false): string {
        if (!game || game.MultiplierMadnessRewards) // No badges for MM
            return null;

        let reward = null;

        if (game.TopDogRewards) // Get 1st place reward
            reward = (game.TopDogRewards.length != 0 && game.TopDogRewards[index].Badge) ? game.TopDogRewards[index].Badge.rewardValue : null;
        else if (game.BullseyeRewards && game.BullseyeRewards.length > 0)
            reward = (game.BullseyeRewards.length != 0 && game.BullseyeRewards[index].Badge) ? game.BullseyeRewards[index].Badge.rewardValue : null;
        else if (game.Connect3Rewards && game.underlyingRule.GameType == 6)
            reward = (game.Connect3Rewards.ThreeInRow.length != 0 && game.Connect3Rewards.ThreeInRow) ? game.Connect3Rewards.ThreeInRow.badge : null;
        else if (game.Connect3Rewards && game.underlyingRule.GameType == 7)
            reward = (game.Connect3Rewards.Blackout.length != 0 && game.Connect3Rewards.Blackout) ? game.Connect3Rewards.Blackout.badge : null;
        else if (game.MilestoneRewards && game.MilestoneRewards.length > 0)
            reward = (game.MilestoneRewards.length != 0 && game.MilestoneRewards[index].Badge) ? game.MilestoneRewards[index].Badge.rewardValue : null;

        if (!reward)
            return null;
        return `../Admin/ImageResizer.aspx?imgid=${reward}&w=${size ? '30' : '24'}&h=${size ? '30' : '24'}`;
    }

    /**
     * Applies the current settings of the group selector to the displayed list of challenges on the Challenges slide settings.
     * */
    public async filterChallenges() {
        try {
            if (this.activeChallenges.length > 0) {
                const groupList = await this.wallboardsService.loadChallengesLogins(this.slideToAdd.WallboardID, this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey);

                //Clear array so only challenges matching the groups are included in the list.
                this.activeChallengesFiltered = [];

                for (const activeChallenge of this.activeChallenges) {
                    for (const ranking of activeChallenge.Rankings) {
                        if (groupList.find((o) => o == ranking.GroupID) != undefined) {
                            this.activeChallengesFiltered.push(activeChallenge);
                            break;
                        }
                    }
                }
            }
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.areChallengesLoading = false;
        }
    }

    /**
     * Gets the URL for the checkmark icon for milestone game previews.
     * @param index Index of the checkmark to get
     */
    public getCheckmark(index: number): string {
        if (!this.selectedGame[0])
            return;

        let theme;
        switch (this.selectedGame[0].MilestoneDetails.MilestoneThemeSelected.themeID) {
            case 1:
                theme = `space`;
                break;
            case 2:
                theme = `pirate`;
                break;
            case 3:
                theme = `racing`;
                break;
            case 4:
                theme = `camping`;
                break;
            case 5:
                theme = `snow`;
                break;
            case 6:
                theme = `hiking`;
                break;
            default:
                theme = `snow`;
                break;
        }

        return `url(../App_Themes/Standard/Images/CoreTheme/Gamification/Games/MilestoneThemes/${theme}/checkmark${index + 1}.svg) center center / 40px no-repeat`;
    }

    /**
     *  Opens the Angular Metric Selector.
     */
    public openMetricSelector() {
        const wallboardKey = this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleKey;

        // Using editedWallboard.CreatorLoginID rather than slideToAdd.CreatorID in case the CreatorIDs are not the same, as the loadSlideControl uses the wallboard creator
        const metricSelector = this.metricSelectorService.openModalForWallboard(MetricSelectorComponent, wallboardKey, this.selectedSlideType, this.selectedMetricInfo, this.editedWallboard.CreatorLoginID);
        const newSelectedMetrics = [];

        metricSelector.result.then((metricSelectorResult) => {
            if (metricSelectorResult) {
                metricSelectorResult?.forEach(m => {
                    newSelectedMetrics.push({
                        mID: m.MetricID,
                        mAbr: m.Abbreviation,
                        mName: m.MetricName,
                        mDir: m.DefaultDirection,
                        DisplayName: m?.MetricCustomName ?? m.MetricName,
                        mCT: m.ConversionType,
                    });
                });

                this.selectedMetricInfo = newSelectedMetrics;
            }
        });
    }

    /**
     * Saves the settings for the current slide and closes the slide settings modal.
     * */
    public async saveSlideSettings(): Promise<void> {
        if (this.isDataSaving)
            return;

        switch (this.SettingsModuleType) {
            case ModuleType.Custom:
                try {
                    this.isDataSaving = true;

                    await this.wallboardsService.updateSlide(this.slideToAdd);
                    this.afterSlideSettingsSave(null);
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Leaderboard:
                if (this.selectedMetricInfo.length == 0) {
                    // No metric added
                    this.openErrorDialog(`Error_Select_Metric`);
                    return;
                }

                let leaderboardDisplayName = "";
                if (this.selectedMetricInfo[0].DisplayName != this.selectedMetricInfo[0].mAbr)
                    leaderboardDisplayName = this.selectedMetricInfo[0].DisplayName;

                try {
                    this.isDataSaving = true;

                    if (this.leaderboardSetupObj.InitialSettings) {
                        const returnedSlide = await this.wallboardsService.saveLeaderboardDetails(this.slideToAdd, this.leaderboardSetupObj, this.editedWallboard.CreatorLoginID,
                            leaderboardDisplayName) as WallboardSlideGridster;

                        this.afterSlideSettingsSave(returnedSlide);
                    }
                    else {
                        await this.wallboardsService.saveLeaderboardState(this.slideToAdd, this.leaderboardSetupObj, this.editedWallboard.CreatorLoginID, leaderboardDisplayName);
                        this.afterSlideSettingsUpdate();
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Racing:
                if (this.selectedMetricInfo.length < 1) {
                    // No metric added
                    this.openErrorDialog(`Error_Select_Metric`);
                    return;
                }

                if (!this.racingSetupObj.BannerTitle) {
                    this.openErrorDialog(`Error_Banner_Title`);
                    return;
                }

                if (!this.racingSetupObj.StartingLine) {
                    this.openErrorDialog(`Error_Value_Starting_Line`);
                    return;
                }

                if (this.racingSetupObj.Positioning == `Target` && !this.racingSetupObj.FinishLine) {
                    this.openErrorDialog(`Error_Value_Finish_Line`);
                    return;
                }

                if (this.selectedMetricInfo.length == 0) {
                    this.openErrorDialog(`Error_Select_Metric`);
                    return;
                }

                if (this.selectedMetricInfo.length > 0 && !this.selectedMetricInfo[0].DisplayName) {
                    this.openErrorDialog(`Error_Metric_Display`);
                    return;
                }

                if (this.racingSetupObj.StartingLine > 2147483647) {
                    this.openErrorDialog(`Error_Starting_Line_Allowed_Range`);
                    return;
                }

                if (this.racingSetupObj.Positioning == `Target` && this.racingSetupObj.FinishLine > 2147483647) {
                    this.openErrorDialog(`Error_Finish_Line_Allowed_Range`);
                    return;
                }

                if (this.selectedMetricInfo.length > 0 && this.racingSetupObj.Positioning == `Target`) {
                    if (this.selectedMetricInfo[0].mDir == 0 && this.racingSetupObj.StartingLine < this.racingSetupObj.FinishLine) {
                        this.openErrorDialog(`Error_Start_Line_Smaller_Than_Finish_Line`);
                        return;
                    }

                    if (this.selectedMetricInfo[0].mDir == 1 && this.racingSetupObj.StartingLine > this.racingSetupObj.FinishLine) {
                        this.openErrorDialog(`Error_Start_Line_Larger_Than_Finish_Line`);
                        return;
                    }
                }

                let racingDisplayName = "";
                if (this.selectedMetricInfo[0].DisplayName != this.selectedMetricInfo[0].mAbr)
                    racingDisplayName = this.selectedMetricInfo[0].DisplayName;

                try {
                    this.isDataSaving = true;

                    const returnedSlide = await this.wallboardsService.saveRacingDetails(this.slideToAdd, this.racingSetupObj, this.editedWallboard.CreatorLoginID, racingDisplayName) as WallboardSlideGridster;
                    this.afterSlideSettingsSave(returnedSlide);
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Summary:
                if (this.selectedMetricInfo.length < 1) {
                    // No metric added
                    this.openErrorDialog(`Error_Select_Metrics`);
                    return;
                }

                const summaryDisplayNames = [];
                for (const selectedMetricInfoItem of this.selectedMetricInfo) {
                    summaryDisplayNames.push(
                        {
                            DisplayName: selectedMetricInfoItem.DisplayName != selectedMetricInfoItem.mAbr ? selectedMetricInfoItem.DisplayName : "",
                            MetricID: selectedMetricInfoItem.mID
                        }
                    );
                }

                try {
                    this.isDataSaving = true;

                    if (this.summarySetupObj.InitialSettings) {
                        const returnedSlide = await this.wallboardsService.saveFullSummaryDetails(this.slideToAdd, this.summarySetupObj, this.editedWallboard.CreatorLoginID, summaryDisplayNames) as WallboardSlideGridster;
                        this.afterSlideSettingsSave(returnedSlide);
                    }
                    else {
                        await this.wallboardsService.saveFullSummaryState(this.slideToAdd, this.summarySetupObj, this.editedWallboard.CreatorLoginID, summaryDisplayNames);
                        this.afterSlideSettingsUpdate();
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.IntervalChart:
                setTimeout(() => { this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettingsOpen = false; }, 0);
                this.slideoutSettingsOpen = false;
                break;
            case ModuleType.Image:
                if (!this.imageSetupObj.UploadedImageString && this.imageSetupObj.UploadedImageID != 0) { // The image was not changed so don't need to save again
                    try {
                        this.isDataSaving = true;

                        await this.wallboardsService.updateSlide(this.slideToAdd);
                        this.afterSlideSettingsUpdate();
                    }
                    catch (error) {
                        console.log(error);
                    }
                    finally {
                        this.isDataSaving = false;
                        this.closeCurrentModal(true);
                    }

                    return;
                }

                if (!this.imageSetupObj.UploadedImageString) {
                    this.openErrorDialog(`Error_Upload_Image`);
                    return;
                }

                try {
                    this.isDataSaving = true;
                    let newImageId;

                    if (this.imageSetupObj.InitialCustomSettings) {
                        const response = await this.wallboardsService.saveFullImageDetails(this.slideToAdd, this.imageSetupObj.UploadedImageString, this.editedWallboard.CreatorLoginID);
                        this.afterSlideSettingsSave(response.New_Slide as WallboardSlideGridster);
                        newImageId = response.New_Image_Id;
                    }
                    else {
                        newImageId = await this.wallboardsService.saveFullImageState(this.slideToAdd, this.imageSetupObj.UploadedImageString, this.editedWallboard.CreatorLoginID);
                        this.afterSlideSettingsUpdate();
                    }

                    this.imageSetupObj.UploadedImageID = newImageId;
                    this.imageSetupObj.UploadedImageString = null;
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Video:
                this.videoSetupObj.OriginDomain = document.domain;

                $(`#hiddenYtPlayerHolder`).append(`<div id="hiddenYtPlayer"></div>`);
                this.player = new (window as any).YT.Player(`hiddenYtPlayer`, {
                    height: `0%`,
                    width: `0%`,
                    videoId: this.videoId,
                    events: {
                        onReady: async (event) => {
                            this.slideToAdd.SlideInterval = this.player.getDuration() + 1;
                            $(`#hiddenYtPlayer`).remove();
                            this.videoInfo = null;

                            try {
                                this.isDataSaving = true;

                                if (this.videoSetupObj.InitialSettings) {
                                    const returnedSlide = await this.wallboardsService.saveFullVideoDetails(this.slideToAdd, this.videoSetupObj, this.editedWallboard.CreatorLoginID) as WallboardSlideGridster;
                                    this.afterSlideSettingsSave(returnedSlide);
                                }
                                else {
                                    await this.wallboardsService.saveFullVideoState(this.slideToAdd, this.videoSetupObj, this.editedWallboard.CreatorLoginID);
                                    this.afterSlideSettingsUpdate();
                                }
                            }
                            catch (error) {
                                console.log(error);
                            }
                            finally {
                                this.isDataSaving = false;
                                this.closeCurrentModal(true);
                            }
                        }
                    },
                    playerVars: {
                        host: `https://${this.videoSetupObj.OriginDomain}`
                    }
                });
                break;
            case ModuleType.Spotlight:
                if (this.spotlightSetupObj.UseLogin && !this.spotlightSetupObj.LoginID) {
                    this.openErrorDialog(`Error_Spotlight_Login`);
                    return;
                }

                if (!this.spotlightSetupObj.UseLogin && !this.spotlightSetupObj.LoginName) {
                    this.openErrorDialog(`Error_Spotlight_Name`);
                    return;
                }

                if (this.spotlightSetupObj.ImageDisplay == `Other` && !this.spotlightSetupObj.ImageID && !this.spotlightSetupObj.UploadedImageString) {
                    this.openErrorDialog(`Error_Upload_Image`);
                    return;
                }

                for (let i = 0; i < this.spotlightSetupObj.HobbyList.length; i++) {
                    if (this.spotlightSetupObj.ShowHobbies && !this.spotlightSetupObj.HobbyList[i]) {
                        this.openErrorDialog(`Error_Spotlight_Hobby`, (i + 1).toString());
                        return;
                    }
                }

                this.spotlightSearch = "";

                if (this.spotlightSetupObj.ImageDisplay != `Other`)
                    this.spotlightSetupObj.UploadedImageString = null;

                if (this.spotlightSetupObj.UseProfileBio)
                    this.spotlightSetupObj.BioString = "";

                try {
                    this.isDataSaving = true;

                    if (this.spotlightSetupObj.InitialSettings) {
                        const returnedSlide = await this.wallboardsService.saveSpotlightDetails(this.slideToAdd, this.spotlightSetupObj, this.editedWallboard.CreatorLoginID) as WallboardSlideGridster;
                        this.afterSlideSettingsSave(returnedSlide);
                    }
                    else {
                        await this.wallboardsService.saveSpotlightState(this.slideToAdd, this.spotlightSetupObj, this.editedWallboard.CreatorLoginID);
                        this.afterSlideSettingsUpdate();
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Gauge:
                if (this.selectedMetricInfo.length < 1) {
                    // No metric added
                    this.openErrorDialog(`Error_Select_Metric`);
                    return;
                }

                if (!this.moduleValueBoundAlertValidation())
                    return;

                try {
                    this.isDataSaving = true;

                    if (this.initialCustomSettings) {
                        const returnedDetails = await this.wallboardsService.saveGaugeDetails(this.gaugeSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex], this.editedWallboard.CreatorLoginID,
                            this.selectedMetricInfo[0].DisplayName) as WallboardModuleDetailsGridster;

                        this.afterModuleSettingsSave(returnedDetails, this.selectedMetricInfo[0].DisplayName);
                    }
                    else {
                        await this.wallboardsService.saveGaugeState(this.gaugeSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleKey, this.editedWallboard.CreatorLoginID,
                            this.selectedMetricInfo[0].DisplayName);

                        this.loadedModuleStates[this.selectedModuleIndex].gaugeObj = this.gaugeSetupObj;
                        this.loadedModuleStates[this.selectedModuleIndex].gaugeObj.GaugeMetricDisplay = this.selectedMetricInfo[0].DisplayName;
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Thermometer:
                if (this.selectedMetricInfo.length < 1) {
                    // No metric added
                    this.openErrorDialog(`Error_Select_Metric`);
                    return;
                }

                if (!this.moduleValueBoundAlertValidation())
                    return;

                try {
                    this.isDataSaving = true;

                    if (this.initialCustomSettings) {
                        const returnedDetails = await this.wallboardsService.saveThermometerDetails(this.thermometerSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex],
                            this.editedWallboard.CreatorLoginID, this.selectedMetricInfo[0].DisplayName) as WallboardModuleDetailsGridster;

                        this.afterModuleSettingsSave(returnedDetails, this.selectedMetricInfo[0].DisplayName);
                    }
                    else {
                        await this.wallboardsService.saveThermometerState(this.thermometerSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleKey,
                            this.editedWallboard.CreatorLoginID, this.selectedMetricInfo[0].DisplayName);

                        this.loadedModuleStates[this.selectedModuleIndex].thermometerObj = this.thermometerSetupObj;
                        this.loadedModuleStates[this.selectedModuleIndex].thermometerObj.ThermometerMetricDisplay = this.selectedMetricInfo[0].DisplayName;
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.SummaryModule:
                if (this.selectedMetricInfo.length < 1) {
                    // No metric added
                    this.openErrorDialog(`Error_Select_Metric`);
                    return;
                }

                const summaryModuleDisplayNames = [];
                for (const selectedMetricInfoItem of this.selectedMetricInfo) {
                    summaryModuleDisplayNames.push(
                        {
                            DisplayName: selectedMetricInfoItem.DisplayName != selectedMetricInfoItem.mAbr ? selectedMetricInfoItem.DisplayName : "",
                            MetricID: selectedMetricInfoItem.mID
                        }
                    );
                }

                try {
                    this.isDataSaving = true;

                    if (this.initialCustomSettings) {
                        const returnedDetails = await this.wallboardsService.saveSummaryDetails(this.summarySetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex], this.editedWallboard.CreatorLoginID,
                            summaryModuleDisplayNames) as WallboardModuleDetailsGridster;

                        this.afterModuleSettingsSave(returnedDetails);
                    }
                    else {
                        await this.wallboardsService.saveSummaryState(this.summarySetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleKey, this.editedWallboard.CreatorLoginID,
                            summaryModuleDisplayNames);

                        this.loadedModuleStates[this.selectedModuleIndex].sumObj = this.summarySetupObj;

                        this.loadedModuleStates[this.selectedModuleIndex].sumObj.SumMetricDisplays = [];
                        for (const selectedMetricInfoItem of this.selectedMetricInfo) {
                            this.loadedModuleStates[this.loadedModuleStates.length - 1].sumObj.SumMetricDisplays.push(
                                selectedMetricInfoItem.DisplayName != selectedMetricInfoItem.mAbr
                                    ? selectedMetricInfoItem.DisplayName
                                    : selectedMetricInfoItem.mAbr
                            );
                        }
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }

                break;
            case ModuleType.Text:
                try {
                    this.isDataSaving = true;

                    if (this.initialCustomSettings) {
                        const returnedDetails = await this.wallboardsService.saveTextDetails(this.textSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex],
                            this.editedWallboard.CreatorLoginID) as WallboardModuleDetailsGridster;

                        this.afterModuleSettingsSave(returnedDetails);
                    }
                    else {
                        await this.wallboardsService.saveTextState(this.textSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleKey, this.editedWallboard.CreatorLoginID);

                        this.loadedModuleStates[this.selectedModuleIndex].textObj = this.textSetupObj;

                        // TODO: Needed?
                        //WallboardFactory.SizeTextValue(this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleKey);
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.ImageModule:
                if (!this.imageSetupObj.UploadedImageString && this.imageSetupObj.UploadedImageID != 0) { // The image was not changed so don't need to save again
                    this.closeCurrentModal(true);
                    return;
                }

                if (!this.imageSetupObj.UploadedImageString) {
                    this.openErrorDialog(`Error_Upload_Image`);
                    return;
                }

                try {
                    this.isDataSaving = true;

                    if (this.initialCustomSettings) {
                        const returnObj = await this.wallboardsService.saveImageDetails(this.imageSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex], this.editedWallboard.CreatorLoginID);

                        this.imageSetupObj.UploadedImageID = returnObj.Image_Id;
                        this.afterModuleSettingsSave(returnObj.Wallboard_Module_Details);
                    }
                    else {
                        const imageId = await this.wallboardsService.saveImageState(this.imageSetupObj.UploadedImageString, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleKey,
                            this.editedWallboard.CreatorLoginID);

                        this.imageSetupObj.UploadedImageID = imageId;
                        this.loadedModuleStates[this.selectedModuleIndex].imgObj = this.imageSetupObj;
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Top:
                if (this.selectedMetricInfo.length < 1) {
                    // No metric added
                    this.openErrorDialog(`Error_Select_Metric`);
                    return;
                }

                try {
                    this.isDataSaving = true;

                    if (this.initialCustomSettings) {
                        const returnedDetails = await this.wallboardsService.saveTopDetails(this.topSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex], this.editedWallboard.CreatorLoginID,
                            this.selectedMetricInfo[0].DisplayName) as WallboardModuleDetailsGridster;

                        this.afterModuleSettingsSave(returnedDetails);
                    }
                    else {
                        await this.wallboardsService.saveTopState(this.topSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleKey, this.editedWallboard.CreatorLoginID,
                            this.selectedMetricInfo[0].DisplayName);

                        this.loadedModuleStates[this.selectedModuleIndex].topObj = this.topSetupObj;
                        this.loadedModuleStates[this.selectedModuleIndex].topObj.TopMetricDisplay = this.selectedMetricInfo[0].DisplayName;
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.AgentCounter:
                try {
                    this.isDataSaving = true;

                    if (this.initialCustomSettings) {
                        const returnedDetails = await this.wallboardsService.saveCounterDetails(this.counterSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex],
                            this.editedWallboard.CreatorLoginID) as WallboardModuleDetailsGridster;

                        this.afterModuleSettingsSave(returnedDetails);
                    }
                    else {
                        await this.wallboardsService.saveCounterState(this.counterSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleKey, this.editedWallboard.CreatorLoginID);

                        this.loadedModuleStates[this.selectedModuleIndex].counterObj = this.counterSetupObj;
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.CurrentAgentStates:
                try {
                    this.isDataSaving = true;

                    if (this.currentAgentStatesSetupObj.InitialSettings) {
                        const returnedSlide = await this.wallboardsService.saveCurrentAgentStatesDetails(this.slideToAdd, this.currentAgentStatesSetupObj, this.editedWallboard.CreatorLoginID) as WallboardSlideGridster;
                        this.afterSlideSettingsSave(returnedSlide);
                    }
                    else {
                        await this.wallboardsService.saveCurrentAgentStatesState(this.slideToAdd, this.currentAgentStatesSetupObj, this.editedWallboard.CreatorLoginID);
                        this.afterSlideSettingsUpdate(angular.copy(this.slideToAdd));
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.ResponsiveCurrentAgentStates:
                try {
                    this.isDataSaving = true;

                    if (this.currentAgentStatesSetupObj.InitialSettings) {
                        const returnedSlide = await this.wallboardsService.saveResponsiveCurrentAgentStatesDetails(this.slideToAdd, this.currentAgentStatesSetupObj,
                            this.editedWallboard.CreatorLoginID) as WallboardSlideGridster;

                        this.afterSlideSettingsSave(returnedSlide);
                    }
                    else {
                        await this.wallboardsService.saveCurrentAgentStatesState(this.slideToAdd, this.currentAgentStatesSetupObj, this.editedWallboard.CreatorLoginID);
                        this.afterSlideSettingsUpdate(angular.copy(this.slideToAdd));
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Kpi:
                if (this.selectedMetricInfo.length < 1) {
                    // No metric added
                    this.openErrorDialog(`Error_Select_Metric`);
                    return;
                }

                if (!this.moduleValueBoundAlertValidation())
                    return;

                try {
                    this.isDataSaving = true;

                    if (this.initialCustomSettings) {
                        const returnedDetails = await this.wallboardsService.saveKpiDetails(this.kpiSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex], this.editedWallboard.CreatorLoginID,
                            this.selectedMetricInfo[0].DisplayName) as WallboardModuleDetailsGridster;

                        this.afterModuleSettingsSave(returnedDetails, this.selectedMetricInfo[0].DisplayName);
                    }
                    else {
                        await this.wallboardsService.saveKpiState(this.kpiSetupObj, this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleKey, this.editedWallboard.CreatorLoginID,
                            this.selectedMetricInfo[0].DisplayName);

                        this.loadedModuleStates[this.selectedModuleIndex].kpiObj = this.kpiSetupObj;
                        this.loadedModuleStates[this.selectedModuleIndex].kpiObj.KpiMetricDisplay = this.selectedMetricInfo[0].DisplayName;
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Games:
                if (this.selectedGame.length == 0) {
                    this.openErrorDialog(`Error_Select_Game`);
                    return;
                }

                try {
                    this.isDataSaving = true;

                    if (this.wallboardGameSetupObj.InitialSettings) {
                        const returnedSlide = await this.wallboardsService.saveWallboardGameDetails(this.slideToAdd, this.wallboardGameSetupObj, this.editedWallboard.CreatorLoginID) as WallboardSlideGridster;
                        this.afterSlideSettingsSave(returnedSlide);
                    }
                    else {
                        await this.wallboardsService.saveWallboardGameState(this.slideToAdd, this.wallboardGameSetupObj, this.editedWallboard.CreatorLoginID);
                        this.afterSlideSettingsUpdate();
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Challenges:
                if (this.activeChallenges.length == 0) {
                    this.challengesSetupObj.TotChallenges = 0;
                    this.challengesSetupObj.TotParticipants = 0;
                }
                else {
                    this.challengesSetupObj.TotChallenges = this.activeChallenges.length;
                    this.challengesSetupObj.TotParticipants = (this.activeChallenges[0].Rankings.length + this.activeChallenges[0].NotRankings.length);
                }

                try {
                    this.isDataSaving = true;

                    if (this.challengesSetupObj.InitialSettings) {
                        const returnedSlide = await this.wallboardsService.saveChallengesDetails(this.slideToAdd, this.challengesSetupObj, this.editedWallboard.CreatorLoginID) as WallboardSlideGridster;
                        this.afterSlideSettingsSave(returnedSlide);
                    }
                    else {
                        await this.wallboardsService.saveChallengesState(this.slideToAdd, this.challengesSetupObj, this.editedWallboard.CreatorLoginID);
                        this.afterSlideSettingsUpdate();
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            case ModuleType.Marketplace:
                if (this.marketplaceTitle.length <= 0) {
                    this.openErrorDialog(`Error_Title_Required`);
                    return;
                }

                this.marketplaceSetupObj.SlideTitle = this.marketplaceTitle;
                this.marketplaceSetupObj.DisplayOption = this.marketplaceView;
                this.marketplaceSetupObj.ProductList = this.selectedProducts;
                this.marketplaceSetupObj.ProductTypes = [
                    this.marketplaceFilterSale,
                    this.marketplaceFilterFeatured,
                    this.marketplaceFilterBestSeller
                ];

                try {
                    this.isDataSaving = true;

                    if (this.marketplaceSetupObj.InitialSettings) {
                        const returnedSlide = await this.wallboardsService.saveMarketplaceDetails(this.slideToAdd, this.marketplaceSetupObj, this.editedWallboard.CreatorLoginID) as WallboardSlideGridster;
                        this.afterSlideSettingsSave(returnedSlide);
                    }
                    else {
                        await this.wallboardsService.saveMarketplaceState(this.slideToAdd, this.marketplaceSetupObj, this.editedWallboard.CreatorLoginID);
                        this.afterSlideSettingsUpdate();
                    }
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    this.isDataSaving = false;
                    this.closeCurrentModal(true);
                }
                break;
            default:
                break;
        }
    }

    /**
     * Handles essential actions following the initial save of a slide's settings.
     * @param returnedSlide Slide object returned by the save function
     */
    public afterSlideSettingsSave(returnedSlide: WallboardSlideGridster): void {
        if (this.selectedSlideType == ModuleType.Custom || (this.selectedSlideType == ModuleType.Racing && this.slideToAdd.WallboardSlideID != 0)) {
            let slide = this.editedWallboard.Slides.filter(o => o.WallboardSlideID == this.slideToAdd.WallboardSlideID)[0];

            slide.SlideDescription = this.slideToAdd.SlideDescription;
            slide.SlideName = this.slideToAdd.SlideName;
            slide.SlideInterval = this.slideToAdd.SlideInterval;
            slide.HasBackdrop = this.slideToAdd.HasBackdrop;

            slide = this.editedWallboardOriginal.Slides.filter(o => o.WallboardSlideID == this.slideToAdd.WallboardSlideID)[0];

            slide.SlideDescription = this.slideToAdd.SlideDescription;
            slide.SlideName = this.slideToAdd.SlideName;
            slide.SlideInterval = this.slideToAdd.SlideInterval;
            slide.HasBackdrop = this.slideToAdd.HasBackdrop;
        }
        else {
            //slideout settings will temporarily add the slide to the wallboard, and we'll replace it here 
            const slideIndex = this.editedWallboard.Slides.findIndex(slide => slide.WallboardSlideID === 0);
            if (slideIndex !== -1)
              this.editedWallboard.Slides.splice(slideIndex, 1);

            this.editedWallboard.Slides.push(angular.copy(returnedSlide));
            this.editedWallboardOriginal.Slides.push(angular.copy(returnedSlide));

            this.selectedSlideIndex = this.editedWallboard.Slides.length - 1;
            this.slideToAdd = angular.copy(this.editedWallboard.Slides[this.selectedSlideIndex]);

            this.handleTabSwitch();

            switch (this.selectedSlideType) {
                case ModuleType.Leaderboard:
                    this.leaderboardSetupObj.InitialSettings = false;
                    break;
                case ModuleType.Racing:
                    this.racingSetupObj.InitialSettings = false;
                    break;
                case ModuleType.Summary:
                    this.summarySetupObj.InitialSettings = false;
                    break;
                case ModuleType.IntervalChart:
                    this.intervalChartSetupObj.InitialSettings = false;
                    break;
                case ModuleType.Image:
                    this.imageSetupObj.InitialCustomSettings = false;
                    break;
                case ModuleType.Video:
                    this.videoSetupObj.InitialSettings = false;
                    break;
                case ModuleType.Spotlight:
                    this.spotlightSetupObj.InitialSettings = false;
                    break;
                case ModuleType.CurrentAgentStates:
                case ModuleType.ResponsiveCurrentAgentStates:
                    this.currentAgentStatesSetupObj.InitialSettings = false;
                    break;
                case ModuleType.Challenges:
                    this.challengesSetupObj.InitialSettings = false;
                    break;
                case ModuleType.Marketplace:
                    this.marketplaceSetupObj.InitialSettings = false;
                    break;
                default:
                    break;
            }
        }

        if (this.slideToAdd.SlideOrder == 0 && this.selectedSlideType != ModuleType.Custom) { // If it's the first slide, then update the wallboard's first slide info
            if (this.selectedSlideType == ModuleType.Racing) {
                this.slideToAdd.BackgroundImageID = this.racingThemePreviewImageId(this.racingSetupObj.Theme);
                this.editedWallboard.FirstSlideBackgroundID = this.slideToAdd.BackgroundImageID;
            }

            this.editedWallboardOriginal.FirstSlideBackgroundID = this.slideToAdd.BackgroundImageID;

            if (this.slideToAdd.WallboardModuleDetails.length == 0) {
                this.editedWallboardOriginal.FirstSlideType = 0;
                this.editedWallboardOriginal.FirstSlideKey = "";
            }
            else {
                this.editedWallboardOriginal.FirstSlideType = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleID;
                this.editedWallboardOriginal.FirstSlideKey = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey;

                if (this.selectedSlideType == ModuleType.Racing) {
                    this.editedWallboard.FirstSlideType = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleID;
                    this.editedWallboard.FirstSlideKey = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey;
                }
            }
        }
    }

    /**
     * Handles essential actions following an update of a slide's settings.
     * */
    public afterSlideSettingsUpdate(copySlide?: WallboardSlideGridster): void {
        const slide = copySlide ? copySlide : this.slideToAdd;
        for (let i = 0; i < this.editedWallboard.Slides.length; i++) {
            if (this.editedWallboard.Slides[i].WallboardSlideID == slide.WallboardSlideID) {
                this.editedWallboard.Slides[i] = angular.copy(slide);
                break;
            }
        }

        for (let i = 0; i < this.editedWallboardOriginal.Slides.length; i++) {
            if (this.editedWallboardOriginal.Slides[i].WallboardSlideID == this.slideToAdd.WallboardSlideID) {
                this.editedWallboardOriginal.Slides[i] = angular.copy(slide);
                break;
            }
        }
    }

    /**
     * Handles essential actions following the initial save of a module's settings.
     * @param customDetails Details object returned by the save function
     * @param displayName Module display name; not all modules need this value
     */
    public afterModuleSettingsSave(returnedDetails: WallboardModuleDetailsGridster, displayName?: string) {
        // Gridster issues can easily happen if this object is replaced wholesale, so only the values that are expected to change during the save are set here
        this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].CompanyID = returnedDetails.CompanyID;
        this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex].WallboardModuleDetailsID = returnedDetails.WallboardModuleDetailsID;

        this.editedWallboard.Slides.find(o => o.WallboardSlideID == returnedDetails.WallboardSlideID).WallboardModuleDetails.push(angular.copy(this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex]));
        this.editedWallboardOriginal.Slides.find(o => o.WallboardSlideID == returnedDetails.WallboardSlideID).WallboardModuleDetails.push(angular.copy(this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex]));

        switch (this.SettingsModuleType) {
            case ModuleType.Gauge:
                this.loadedModuleStates.push({ gaugeObj: angular.copy(this.SelectedModuleSetupObj) } as any);
                this.loadedModuleStates[this.loadedModuleStates.length - 1].gaugeObj.GaugeMetricDisplay = displayName != "" ? displayName : this.selectedMetricInfo[0].mAbr;
                break;
            case ModuleType.Thermometer:
                this.loadedModuleStates.push({ thermometerObj: angular.copy(this.SelectedModuleSetupObj) } as any);
                this.loadedModuleStates[this.loadedModuleStates.length - 1].thermometerObj.ThermometerMetricDisplay = displayName != "" ? displayName : this.selectedMetricInfo[0].mAbr;
                break;
            case ModuleType.SummaryModule:
                this.loadedModuleStates.push({ sumObj: angular.copy(this.SelectedModuleSetupObj) } as any);

                this.loadedModuleStates[this.loadedModuleStates.length - 1].sumObj.SumMetricDisplays = [];
                for (const selectedMetricInfoItem of this.selectedMetricInfo) {
                    this.loadedModuleStates[this.loadedModuleStates.length - 1].sumObj.SumMetricDisplays.push(
                        selectedMetricInfoItem.DisplayName != selectedMetricInfoItem.mAbr
                            ? selectedMetricInfoItem.DisplayName
                            : selectedMetricInfoItem.mAbr
                    );
                }
                break;
            case ModuleType.Text:
                this.loadedModuleStates.push({ textObj: angular.copy(this.SelectedModuleSetupObj) } as any);
                break;
            case ModuleType.ImageModule:
                this.loadedModuleStates.push({ imgObj: angular.copy(this.SelectedModuleSetupObj) } as any);
                break;
            case ModuleType.Top:
                this.loadedModuleStates.push({ topObj: angular.copy(this.SelectedModuleSetupObj) } as any);
                this.loadedModuleStates[this.loadedModuleStates.length - 1].topObj.TopMetricDisplay = displayName != "" ? displayName : this.selectedMetricInfo[0].mAbr;
                break;
            case ModuleType.AgentCounter:
                // This passes along the original chartOptions object to the new transfer object
                const counterObj = {
                    CounterTitle: this.SelectedModuleSetupObj.CounterTitle,
                    ShowLabels: this.SelectedModuleSetupObj.ShowLabels,
                    chartOptions: this.SelectedModuleSetupObj.chartOptions
                };
                this.loadedModuleStates.push({ counterObj } as any);
                break;
            case ModuleType.Kpi:
                this.loadedModuleStates.push({ kpiObj: angular.copy(this.SelectedModuleSetupObj) } as any);
                this.loadedModuleStates[this.loadedModuleStates.length - 1].kpiObj.KpiMetricDisplay = displayName != "" ? displayName : this.selectedMetricInfo[0].mAbr;
                break;
            default:
                break;
        }

        this.initialCustomSettings = false;
    }

    /**
     * Copies the specified slide.
     * @param slide Slide to copy
     */
    public async copySlide(slide: WallboardSlideGridster): Promise<void> {
        let newSlide: WallboardSlideGridster = {
            WallboardSlideID: 0,
            CompanyID: 0,
            SlideName: `${slide.SlideName} (${this.localization.get("Copy_Button")})`,
            SlideDescription: slide.SlideDescription,
            WallboardID: slide.WallboardID,
            SlideInterval: slide.SlideInterval,
            SlideOrder: slide.SlideOrder + 1,
            BackgroundImageID: slide.BackgroundImageID,
            TransitionID: slide.TransitionID,
            CreatorID: this.editedWallboard.CreatorLoginID,
            HasBackdrop: slide.HasBackdrop,
            HasTotalsRow: slide.HasTotalsRow,
            HasPagination: slide.HasPagination,
            WallboardModuleDetails: [],
            Enabled: slide.Enabled,
            Active: true,

            TypeState: null
        };
        const detailsList = [];

        for (const moduleDetail of slide.WallboardModuleDetails) {
            const newDetailObj: WallboardModuleDetailsGridster = {
                WallboardSlideID: 0, // Fill this in the webservice after the new slide is saved
                WallboardModuleDetailsID: 0,
                CompanyID: moduleDetail.CompanyID,
                WallboardID: moduleDetail.WallboardID,
                PositionTop: moduleDetail.PositionTop,
                PositionLeft: moduleDetail.PositionLeft,
                Height: moduleDetail.Height,
                Width: moduleDetail.Width,
                WallboardModuleID: moduleDetail.WallboardModuleID,
                WallboardModuleKey: moduleDetail.WallboardModuleKey, // Generate new key in the webservice
                Active: true,
                x: moduleDetail.PositionLeft,
                y: moduleDetail.PositionTop,
                rows: moduleDetail.Height,
                cols: moduleDetail.Width,
                minItemRows: moduleDetail.minItemRows,
                minItemCols: moduleDetail.minItemCols,
                placeholder: false,

                State: null
            };

            detailsList.push(newDetailObj);
        }

        try {
            this.isDataSaving = true;
            newSlide = await this.wallboardsService.saveSlideCopy(newSlide, detailsList, this.editedWallboard.CreatorLoginID) as WallboardSlideGridster;

            // Gridster-related values are easily messed up going through REST, so ensuring that they are correct after the copy prevents many issues
            for (let i = 0; i < newSlide.WallboardModuleDetails.length; i++) {
                newSlide.WallboardModuleDetails[i].PositionTop = detailsList[i].PositionTop;
                newSlide.WallboardModuleDetails[i].PositionLeft = detailsList[i].PositionLeft;
                newSlide.WallboardModuleDetails[i].Height = detailsList[i].Height;
                newSlide.WallboardModuleDetails[i].Width = detailsList[i].Width;

                newSlide.WallboardModuleDetails[i].x = detailsList[i].x;
                newSlide.WallboardModuleDetails[i].y = detailsList[i].y;
                newSlide.WallboardModuleDetails[i].rows = detailsList[i].rows;
                newSlide.WallboardModuleDetails[i].cols = detailsList[i].cols;
                newSlide.WallboardModuleDetails[i].minItemRows = detailsList[i].minItemRows;
                newSlide.WallboardModuleDetails[i].minItemCols = detailsList[i].minItemCols;
            }

            this.editedWallboard.Slides.splice(newSlide.SlideOrder, 0, angular.copy(newSlide));
            this.editedWallboardOriginal.Slides.splice(newSlide.SlideOrder, 0, angular.copy(newSlide));

            // Update slide's FirstSlideType
            if (this.editedWallboard.Slides[0].WallboardModuleDetails.length > 0 && SlideModuleTypes.includes(this.editedWallboard.Slides[0].WallboardModuleDetails[0].WallboardModuleID))
                this.editedWallboard.FirstSlideType = this.editedWallboard.Slides[0].WallboardModuleDetails[0].WallboardModuleID;
            else
                this.editedWallboard.FirstSlideType = 0;

            if (this.editedWallboardOriginal.Slides[0].WallboardModuleDetails.length > 0 && SlideModuleTypes.includes(this.editedWallboardOriginal.Slides[0].WallboardModuleDetails[0].WallboardModuleID))
                this.editedWallboardOriginal.FirstSlideType = this.editedWallboardOriginal.Slides[0].WallboardModuleDetails[0].WallboardModuleID;
            else
                this.editedWallboardOriginal.FirstSlideType = 0;

            if (this.editedWallboard.FirstSlideType == ModuleType.Racing) {
                const racingBackgroundId = await this.wallboardsService.loadRacingBackgroundId(this.editedWallboard.Slides[0].WallboardModuleDetails[0].WallboardModuleKey, this.editedWallboard.CreatorLoginID);
                this.editedWallboard.FirstSlideBackgroundID = racingBackgroundId;
                this.editedWallboardOriginal.FirstSlideBackgroundID = racingBackgroundId;
            }

            // Recalculate slide order and select newly-duplicated slide
            for (let i = 0; i < this.editedWallboard.Slides.length; i++) {
                this.editedWallboard.Slides[i].SlideOrder = i;
                this.editedWallboardOriginal.Slides[i].SlideOrder = i;

                if (this.slideToAdd.WallboardSlideID == this.editedWallboard.Slides[i].WallboardSlideID)
                    this.selectedSlideIndex = i;
            }

            await this.wallboardsService.updateSlideOrder(this.editedWallboard.Slides);
            this.selectSlide(newSlide.SlideOrder);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.isDataSaving = false;
        }
    }

    /**
     * Removes the currently selected slide from the wallboard.
     */
    public async removeSlide(): Promise<void> {
        const slide = this.editedWallboard.Slides[this.selectedSlideIndex];

        try {
            this.isDataSaving = true;

            await this.wallboardsService.removeSlide(slide);

            if (slide.SlideOrder == 0 && this.editedWallboard.Slides.length > 1) { // If it's the first slide, then update the wallboard's first slide info
                this.editedWallboardOriginal.FirstSlideBackgroundID = this.editedWallboard.Slides[1].BackgroundImageID;

                if (this.editedWallboard.Slides[1].WallboardModuleDetails.length == 0) {
                    this.editedWallboardOriginal.FirstSlideType = 0;
                    this.editedWallboardOriginal.FirstSlideKey = "";
                }
                else {
                    this.editedWallboardOriginal.FirstSlideType = this.editedWallboard.Slides[1].WallboardModuleDetails[0].WallboardModuleID;
                    this.editedWallboardOriginal.FirstSlideKey = this.editedWallboard.Slides[1].WallboardModuleDetails[0].WallboardModuleKey;
                }
            }
            else if (slide.SlideOrder === 0 && this.editedWallboard.Slides.length === 1) {
                // Removed slide was the only one, so after the removal there will be no slides left
                this.editedWallboardOriginal.FirstSlideBackgroundID = -1;
                this.editedWallboardOriginal.FirstSlideType = -1;
                this.editedWallboardOriginal.FirstSlideKey = "";
            }

            this.editedWallboard.Slides.splice(this.selectedSlideIndex, 1);
            this.editedWallboardOriginal.Slides.splice(this.selectedSlideIndex, 1);

          // Update the SlideOrder property for each slide the new position is remembered
            this.editedWallboard.Slides.forEach((slide, index) => {
                slide.SlideOrder = index;
                this.editedWallboardOriginal.Slides[index].SlideOrder = index;
            });

            await this.wallboardsService.updateSlideOrder(this.editedWallboard.Slides);   
            
            this.selectedSlideIndex = -1;
            this.selectedSlideType = -1;
            if (this.editedWallboard.Slides.length == 0)
                // Slide type changed, tab integrity must be ensured
                this.handleTabSwitch();
            else
                // Potential improvement here: select the next (or prev) slide after what was deleted.
                this.selectSlide(0);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.confirmationDialogOpen = 0;
            this.isDataSaving = false;
        }
    }


    public getEnabledSlideIndex(wallboardSlideID: number): number {
        let enabledSlides = this.editedWallboard.Slides.filter(function (f) { return f.Enabled == true });
        return enabledSlides.findIndex(slide => slide.WallboardSlideID === wallboardSlideID);
    }

    /**
     * Opens the specified slide in a new tab for viewing.
     * @param wallboard Slide to preview
     */
    public previewSlide(wallboard): void {
        window.open(`WallboardView.aspx?wid=${this.editedWallboard.WallboardID}&sidx=${this.getEnabledSlideIndex(wallboard.WallboardSlideID)}`, `_blank`);
    }

    /**
     * Returns the correct value for the background field for the main section of the currently selected slide.
     * */
    public mainSectionBackground(): string {
        let result = `url(`;
        switch (this.selectedSlideType) {
            case ModuleType.Custom:
            case ModuleType.Leaderboard:
            case ModuleType.Summary:
            case ModuleType.IntervalChart:
            case ModuleType.Spotlight:
            case ModuleType.CurrentAgentStates:
            case ModuleType.ResponsiveCurrentAgentStates:
            case ModuleType.Games:
            case ModuleType.Challenges:
            case ModuleType.Marketplace:
                if (!this.centerBoxWidth || !this.centerBoxHeight)
                    return "";
                result += `../Admin/ImageResizer.aspx?imgid=${this.slideToAdd.BackgroundImageID}&w=${this.centerBoxWidth}&h=${this.centerBoxHeight}`;
                break;
            case ModuleType.Racing:
                result += `../App_Themes/Standard/Images/Wallboards/${this.wallboardsService.racingThemePreviewImageFilename(this.racingSetupObj?.Theme)}`;
                break;
            case ModuleType.Image:
                if (this.fullImgWidthAuto)
                    result = `#000000 url(../Admin/ImageResizer.aspx?imgid=${this.imageSetupObj?.UploadedImageID}&w=auto&h=${this.centerBoxHeight}`;
                else
                    result = `#000000 url(../Admin/ImageResizer.aspx?imgid=${this.imageSetupObj?.UploadedImageID}&w=${this.centerBoxWidth}&h=auto`;
                break;
            case ModuleType.Video:
                if (!this.videoSetupObj)
                    return "";

                if (!this.videoSetupObj.ThumbImg)
                    result += `https://i3.ytimg.com/vi/${this.videoId}/maxresdefault.jpg`;

                result += `${this.videoSetupObj.ThumbImg}`;
                break;
            default:
                return "";
        }

        return `${result}) center center / ${this.selectedSlideType == ModuleType.Image ? 'contain' : 'cover'} no-repeat`;
    }

    /**
     * Returns the correct value for the animation field for the main section of the currently selected slide.
     * */
    public mainSectionAnimation(): string {
        if (this.transitionPreview) {
            if (this.transitionType == 5)
                return `flip 1s`;
            else if (this.transitionType == 6)
                return `pinhole 1s`;
        }
        return "";
    }

    /**
     * Returns the correct value for either the top or left fields for the main section of the currently selected slide.
     * @param getTop Will return the value for top if true, the value for left if false
     */
    public mainSectionTopLeft(getTop: boolean): string {
        if (this.transitionPreview) {
            if (getTop) {
                if (this.transitionType == 11)
                    return `100vh`;
                else if (this.transitionType == 8)
                    return `-100vh`;
            }
            else {
                if (this.transitionType == 9)
                    return `100vw`;
                else if (this.transitionType == 10)
                    return `-100vw`;
            }
        }
        return `0`;
    }

    /**
     * Returns the text for the bio for the spotlight slide preview.
     * @param isBio
     */
    public getBioText(isBio: boolean): string {
        if (!this.spotlightSetupObj)
            return;

        // Caps the profile Bio and the manual bio at 500 characters then appends ... if there is anything cut off.
        if (isBio) {
            if (this.spotlightLoadedProfile != null && this.spotlightLoadedLoginId == this.spotlightSetupObj.LoginID) {
                if (this.spotlightLoadedProfile.Bio.length > 499)
                    return this.spotlightLoadedProfile.Bio.substring(0, 496) + "...";
                else
                    return this.spotlightLoadedProfile.Bio;
            }
            else
                return "";
        }
        else if (this.spotlightSetupObj.BioString.length > 499)
            return this.spotlightSetupObj.BioString.substring(0, 496) + "...";
        else
            return this.spotlightSetupObj.BioString;
    }

    /**
     * Deletes the custom module for the current slide at the index this.pendingModuleDeleteIndex
     * */
    public async removeCustomModule(): Promise<void> {
        const moduleDetail = this.slideToAdd.WallboardModuleDetails[this.pendingModuleDeleteIndex];

        if (!moduleDetail) {
            this.openErrorDialog(`Error_Remove_Custom_Module`);
            this.pendingModuleDeleteIndex = -1;
            return;
        }

        try {
            this.isDataSaving = true;

            await this.wallboardsService.removeModule(moduleDetail);

            this.slideToAdd.WallboardModuleDetails.splice(this.pendingModuleDeleteIndex, 1);
            this.editedWallboard.Slides[this.selectedSlideIndex].WallboardModuleDetails.splice(this.pendingModuleDeleteIndex, 1);
            this.editedWallboardOriginal.Slides[this.selectedSlideIndex].WallboardModuleDetails.splice(this.pendingModuleDeleteIndex, 1);
            this.loadedModuleStates.splice(this.pendingModuleDeleteIndex, 1);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.isDataSaving = false;
            this.pendingModuleDeleteIndex = -1;
            this.confirmationDialogOpen = 0;
        }
    }

    /**
     * Triggers as something is dragged within the Gridster. Updates the positioning of the placeholder module.
     * @param event
     */
    public addCustomModule(moduleType: ModuleType) {
        if (this.selectedSlideType != ModuleType.Custom)
            return;

        const moduleToAdd = this.addModuleObjectToGrid(moduleType);
        if (!moduleToAdd) {
            this.openErrorDialog(`Error_Not_Enough_Space`);
            return;
        }
        this.selectedModuleIndex = this.slideToAdd.WallboardModuleDetails.length - 1;

        this.openNewModuleSettings(moduleToAdd);
    }

    /**
     * Adds a new module object to the grid (and returns that object). Will do nothing (and returns null) if there's no room for the module.
     * @param moduleType Type of the new module
     * @param placeholder True if the module is a placeholder for drag-and-drop, false if otherwise
     */
    public addModuleObjectToGrid(moduleType: ModuleType, placeholder = false): WallboardModuleDetailsGridster {
        const moduleToAdd: WallboardModuleDetailsGridster = {
            WallboardModuleDetailsID: 0,
            CompanyID: 0,
            WallboardID: this.editedWallboard.WallboardID,
            WallboardSlideID: this.slideToAdd.WallboardSlideID,
            PositionTop: 0,
            PositionLeft: 0,
            Height: 8,
            Width: 8,
            WallboardModuleID: moduleType,
            WallboardModuleKey: "",
            Active: true,

            x: 0,
            y: 0,
            rows: 8,
            cols: 8,
            minItemRows: 8,
            minItemCols: 8,
            placeholder,

            State: null
        };

        switch (moduleType) {
            case ModuleType.Gauge:
            case ModuleType.ImageModule:
                moduleToAdd.Height = 15;
                moduleToAdd.Width = 10;
                moduleToAdd.rows = 15;
                moduleToAdd.cols = 10;
                moduleToAdd.minItemRows = 15;
                moduleToAdd.minItemCols = 10;
                break;
            case ModuleType.Thermometer:
                moduleToAdd.Height = 30;
                moduleToAdd.Width = 10;
                moduleToAdd.rows = 30;
                moduleToAdd.cols = 10;
                moduleToAdd.minItemRows = 30;
                moduleToAdd.minItemCols = 10;
                break;
            case ModuleType.SummaryModule:
                moduleToAdd.Height = 15;
                moduleToAdd.Width = 30;
                moduleToAdd.rows = 15;
                moduleToAdd.cols = 30;
                moduleToAdd.minItemRows = 15;
                moduleToAdd.minItemCols = 30;
                break;
            case ModuleType.Text:
                moduleToAdd.Height = 10;
                moduleToAdd.Width = 10;
                moduleToAdd.rows = 10;
                moduleToAdd.cols = 10;
                moduleToAdd.minItemRows = 10;
                moduleToAdd.minItemCols = 10;
                break;
            case ModuleType.Top:
                moduleToAdd.Height = 15;
                moduleToAdd.Width = 20;
                moduleToAdd.rows = 15;
                moduleToAdd.cols = 20;
                moduleToAdd.minItemRows = 15;
                moduleToAdd.minItemCols = 20;
                break;
            case ModuleType.AgentCounter:
                moduleToAdd.Height = 15;
                moduleToAdd.Width = 15;
                moduleToAdd.rows = 15;
                moduleToAdd.cols = 15;
                moduleToAdd.minItemRows = 15;
                moduleToAdd.minItemCols = 15;
                break;
            // KPI is the smallest and uses the default values set above
            default:
                break;
        }

        // Validate if there's enough room
        if (!this.gridsterOptions.api.getNextPossiblePosition(moduleToAdd))
            return null;

        this.gridsterOptions.api.getFirstPossiblePosition(moduleToAdd);
        moduleToAdd.PositionLeft = moduleToAdd.x;
        moduleToAdd.PositionTop = moduleToAdd.y;
        this.slideToAdd.WallboardModuleDetails.push(moduleToAdd);

        if (placeholder)
            this.placeholderModule = moduleToAdd;

        return moduleToAdd;
    }

    /**
     * Opens the module settings for the specified module for the purpose of initial module setup.
     * @param moduleToAdd Module object that has not yet been saved to the database
     */
    public openNewModuleSettings(moduleToAdd: WallboardModuleDetailsGridster) {
        let maxMetrics = 0;
        switch (moduleToAdd.WallboardModuleID) {
            case ModuleType.Gauge:
                this.gaugeSetupObj = {
                    isOverride: false,
                    LowerBound: null,
                    Alert: null,
                    Value: null,
                    GaugeTitle: "",
                    Theme: `Modern`,
                    GaugeMetricDisplay: "",

                    curLowerBound: null,
                    curAlert: null,
                    curValue: null
                } as GuageSettingsTransferObj;
                maxMetrics = 1;
                break;
            case ModuleType.Thermometer:
                this.thermometerSetupObj = {
                    isOverride: false,
                    LowerBound: null,
                    Alert: null,
                    Value: null,
                    ThermometerTitle: "",
                    Theme: `Modern`,
                    ThermometerMetricDisplay: "",

                    curLowerBound: null,
                    curAlert: null,
                    curValue: null
                } as ThermometerSettingsTransferObj;
                maxMetrics = 1;
                break;
            case ModuleType.SummaryModule:
                this.summarySetupObj = {
                    SummaryTitle: "",
                    ShowRank: false,
                    SumMetricDisplays: [],

                    InitialSettings: true
                } as SummarySettingsTransferObj;
                maxMetrics = 3;
                break;
            case ModuleType.Text:
                this.textSetupObj = {
                    TextValue: "",

                    TextValueSanitized: null
                } as TextSettingsTransferObj;
                break;
            case ModuleType.ImageModule:
                this.imageSetupObj = {
                    UploadedImageID: 0,

                    UploadedImageString: "",
                    InitialCustomSettings: true
                } as ImageSettingsTransferObj;
                break;
            case ModuleType.Top:
                this.topSetupObj = {
                    TopTitle: "",
                    TopDisplay: `Profile`,
                    TopMetricDisplay: ""
                } as TopSettingsTransferObj;
                maxMetrics = 1;
                break;
            case ModuleType.AgentCounter:
                this.counterSetupObj = {
                    CounterTitle: "",
                    ShowLabels: false,

                    chartOptions: null
                } as CounterSettingsTransferObj;
                // This is to ensure that the counter settings are loaded below
                maxMetrics = 1;
                break;
            case ModuleType.Kpi:
                this.kpiSetupObj = {
                    KpiTitle: "",
                    KpiMetricDisplay: "",
                    isOverride: false,
                    LowerBound: null,
                    Alert: null,
                    Value: null,
                    mCT: 0,

                    curLowerBound: null,
                    curAlert: null,
                    curValue: null
                } as KpiSettingsTransferObj;
                maxMetrics = 1;
                break;
            default:
                break;
        }

        // Reset formatted override values to ensure they are blank for new modules
        this.lowerBoundFormatted = "";
        this.alertFormatted = "";
        this.valueFormatted = "";

        this.wallboardsService.generateAccessGuid().then(newKey => {
            if (moduleToAdd) {
                moduleToAdd.placeholder = false;
                moduleToAdd.WallboardModuleKey = newKey;

                this.initialCustomSettings = true;
                this.selectedModuleType = moduleToAdd.WallboardModuleID;
                this.draggingModuleType = ModuleType.Custom;

                if (maxMetrics != 0) {
                    // See comment under loadEditSlideControls() for why this is here
                    this.controlsLoadId++;

                    this.loadEditSlideControls(newKey, maxMetrics, true, this.selectedModuleType == ModuleType.AgentCounter);
                }

                // openSlideSettings() assumes an edit and is generally not suited for use when creating a new module, so we just do it directly here
                this.slideSettingsModalOpen = true;
                this.slideSettingsModalSection = 1;
            }
        }).catch(error => {
            console.log(error);
        });
    }

    /**
     * Triggers when something is dragged over the Gridster. Creates a placeholder module.
     * */
    public dragEnter(): void {
        this.dragEnterCount++;
        if (this.selectedSlideType != ModuleType.Custom || this.dragEnterCount > 1 || this.draggingModuleType <= 0)
            return;

        this.addModuleObjectToGrid(this.draggingModuleType, true);
    }

    /**
     * Triggers when something is dragged out of the Gridster. Destroys any placeholder modules.
     * */
    public dragLeave(): void {
        this.dragEnterCount--;
        if (this.selectedSlideType != ModuleType.Custom || this.dragEnterCount > 0)
            return;

        this.slideToAdd.WallboardModuleDetails = this.slideToAdd.WallboardModuleDetails.filter(o => !o.placeholder);

        this.placeholderModule = null;
        this.placeholderComponent = null;
    }

    /**
     * Triggers as something is dragged within the Gridster. Updates the positioning of the placeholder module.
     * @param event
     */
    public dragOver(event: DragEvent): void {
        if (this.selectedSlideType != ModuleType.Custom)
            return;

        if (this.placeholderModule) {
            // grab component if we don't have it for the current placeholder
            if (!this.placeholderComponent || this.placeholderComponent.item !== this.placeholderModule)
                this.placeholderComponent = this.gridster.findItemWithItem(this.placeholderModule) as GridsterItemComponent;

            if (this.placeholderComponent) {
                // get mouse position within the grid
                const boundingRect = this.gridsterElement.nativeElement.getBoundingClientRect();
                let pixelX = event.pageX - boundingRect.left - (this.gridsterOptions.margin * 2);
                let pixelY = event.pageY - boundingRect.top - (this.gridsterOptions.margin * 2);

                // clamp the pixel values to the gridster's dimensions, taking into account the placeholderModule size
                pixelX = Math.max(0, Math.min(pixelX, boundingRect.width - this.gridster.positionXToPixels(this.placeholderModule.cols)));
                pixelY = Math.max(0, Math.min(pixelY, boundingRect.height - this.gridster.positionYToPixels(this.placeholderModule.rows)));

                // get gridster positions from the pixel values
                const x = this.gridster.pixelsToPositionX(pixelX, Math.floor);
                const y = this.gridster.pixelsToPositionY(pixelY, Math.floor);

                // update item position and apply gridster rules
                this.placeholderComponent.$item.x = x;
                this.placeholderComponent.$item.y = y;
                this.placeholderComponent.checkItemChanges(this.placeholderComponent.$item, this.placeholderComponent.item);
            }
        }
        event.preventDefault();
    }

    /**
     * Triggers when something is dropped within the Gridster. Turns the placeholder module into a normal one and begins the process of setting it up.
     * */
    public async onDrop(): Promise<void> {
        if (this.selectedSlideType != ModuleType.Custom)
            return;

        this.selectedModuleIndex = this.slideToAdd.WallboardModuleDetails.map(o => o.placeholder).indexOf(true);
        if (this.selectedModuleIndex == -1) {
            this.dragLeave();
            this.openErrorDialog(`Error_Not_Enough_Space`);
            return;
        }
        const moduleToAdd = this.slideToAdd.WallboardModuleDetails[this.selectedModuleIndex];

        this.placeholderModule = null;
        this.placeholderComponent = null;
        moduleToAdd.PositionLeft = moduleToAdd.x;
        moduleToAdd.PositionTop = moduleToAdd.y;
        moduleToAdd.Height = moduleToAdd.rows;
        moduleToAdd.Width = moduleToAdd.cols;

        // Check to ensure that the module isn't attempting to overflow the boundaries of the grid; discard if so
        if (moduleToAdd.PositionLeft + moduleToAdd.Width > 40 || moduleToAdd.PositionTop + moduleToAdd.Height > 40) {
            this.selectedModuleIndex = -1;
            this.dragLeave();
            this.openErrorDialog(`Error_Not_Enough_Space`);
            return;
        }

        this.dragEnterCount = 0;
        this.openNewModuleSettings(moduleToAdd);
    }

    /**
     * Jumps to an appropriate right-side tab if the current tab is incompatible with the current slide type.
     * */
    public handleTabSwitch(): void {
        switch (this.selectedSlideType) {
            case ModuleType.Custom:
                if (this.desiredTab != 2)
                    this.tab = this.desiredTab;
                else if (this.tab < 0 || this.tab == 2)
                    this.tab = 0;
                break;
            case ModuleType.Leaderboard:
            case ModuleType.Summary:
            case ModuleType.IntervalChart:
            case ModuleType.Spotlight:
            case ModuleType.CurrentAgentStates:
            case ModuleType.ResponsiveCurrentAgentStates:
            case ModuleType.Games:
            case ModuleType.Challenges:
            case ModuleType.Marketplace:
                if (this.desiredTab == 1 || this.desiredTab == 3)
                    this.tab = this.desiredTab;
                if (this.tab <= 0 || this.tab == 2)
                    this.tab = 1;
                break;
            case ModuleType.Racing:
                if (this.desiredTab > 1)
                    this.tab = this.desiredTab;
                if (this.tab < 2)
                    this.tab = 2;
                break;
            /*case ModuleType.Scorecard:
                this.tab = -1;
                break;*/
            case ModuleType.Image:
            case ModuleType.Video:
                this.tab = 3;
                break;
            default:
                this.tab = -1;
                break;
        }
    }

    /**
     * Returns the filename (without extention) of the preset background image corresponding to the provided ID.
     * @param backgroundId ID of the preset background to get the filename of (range from -67 to -91)
     */
    public presetBackgroundImageName(backgroundId: number): string {
        switch (backgroundId) {
            case -91:
                return `brick1`;
            case -67:
                return `buildings1`;
            case -68:
                return `buildings2`;
            case -69:
                return `gears1`;
            case -70:
                return `light1`;
            case -71:
                return `light2`;
            case -72:
                return `light3`;
            case -73:
                return `light4`;
            case -74:
                return `mountains1`;
            case -75:
                return `mountains2`;
            case -76:
                return `mountains3`;
            case -77:
                return `rocks1`;
            case -78:
                return `stars1`;
            case -79:
                return `stars2`;
            case -80:
                return `sunset1`;
            case -81:
                return `sunset2`;
            case -82:
                return `texture1`;
            case -83:
                return `trees1`;
            case -84:
                return `tunnel1`;
            case -85:
                return `water1`;
            case -86:
                return `water2`;
            case -87:
                return `water3`;
            case -88:
                return `wood1`;
            case -89:
                return `wood2`;
            case -90:
                return `wood3`;
            default:
                return "";
        }
    }

    /**
     * Changes the current slide's background to that of backgroundId and saves it to the database, unless the inputted ID is the same as the old one, in which case this will do nothing.
     * @param backgroundId ID of the background to set the current slide to
     */
    public async setSlideBackground(backgroundId: number): Promise<void> {
        if (this.slideToAdd.BackgroundImageID == backgroundId)
            return;

        this.slideToAdd.BackgroundImageID = backgroundId;

        try {
            await this.wallboardsService.updateSlide(this.slideToAdd);
            this.editedWallboard.Slides[this.selectedSlideIndex].BackgroundImageID = this.slideToAdd.BackgroundImageID;
            this.editedWallboardOriginal.Slides[this.selectedSlideIndex].BackgroundImageID = this.slideToAdd.BackgroundImageID;

            if(!this.centerBoxWidth || !this.centerBoxHeight)
                this.resizeCenterBox();
        }
        catch (error) {
            console.log(error);
        }
    }

    /**
     * Opens file selector for the purpose of uploading a background image.
     * */
    public uploadBackgroundImage(): void {
        $('#backgroundUploadInput').trigger("click");
    }

    /**
     * Is run when a new background image is uploaded.
     * */
    public handleBackgroundUpload(event: Event): void {
        const target = event.currentTarget as HTMLInputElement;
        const file = target.files[0];

        const reader = new FileReader();
        reader.onload = (evt) => {
            this.uploadedBackground = evt.target.result as string;
        };
        reader.readAsDataURL(file);
    }

    /**
     * Saves the uploaded background to the database, then sets and saves the current slide's background to it.
     * */
    public async saveUploadedBackground(): Promise<void> {
        try {
            this.isDataSaving = true;
            const newBackgroundId = await this.wallboardsService.saveUploadedBackground(this.uploadedBackground);
            this.uploadedBackgroundIds.unshift(newBackgroundId);
            this.setSlideBackground(newBackgroundId);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.uploadBackgroundModalOpen = false;
            this.isDataSaving = false;
        }
    }

    /**
     * Removes the background whose ID is stored as confirmDeactivateBackground from the list permanently.
     */
    public async deactivateSlideBackground(): Promise<void> {
        try {
            this.isDataSaving = true;
            await this.wallboardsService.deactivateSlideBackground(this.confirmDeactivateBackground);

            const backgroundIndex = this.uploadedBackgroundIds.indexOf(this.confirmDeactivateBackground);
            if (backgroundIndex > -1)
                this.uploadedBackgroundIds.splice(backgroundIndex, 1);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.confirmationDialogOpen = 0;
            this.isDataSaving = false;
        }
    }

    /**
     * Changes the current slide's racing theme to that of themeName and saves it to the database, unless the inputted theme is the same as the old one, in which case this will do nothing.
     * @param themeName Name of the racing theme to set the current slide to
     */
    public async setSlideTheme(themeName: string): Promise<void> {
        if (this.racingSetupObj.Theme == themeName)
            return;

        this.isDataSaving = true;
        
        this.racingSetupObj.Theme = themeName;

        try {
            await this.wallboardsService.updateSlideTheme(this.racingSetupObj, this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, this.editedWallboard.CreatorLoginID);

            // I'm not sure this actually does anything, as the BackgroundImageID field of racing slides is never saved or used
            this.slideToAdd.BackgroundImageID = this.racingThemePreviewImageId(this.racingSetupObj?.Theme);
            this.editedWallboard.Slides[this.selectedSlideIndex].BackgroundImageID =  this.slideToAdd.BackgroundImageID
            this.editedWallboardOriginal.Slides[this.selectedSlideIndex].BackgroundImageID = this.slideToAdd.BackgroundImageID;


            if (this.slideToAdd.SlideOrder == 0) {
                this.editedWallboardOriginal.FirstSlideBackgroundID = this.slideToAdd.BackgroundImageID;
                this.editedWallboardOriginal.FirstSlideType = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleID;
                this.editedWallboardOriginal.FirstSlideKey = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey;

                this.editedWallboard.FirstSlideBackgroundID = this.slideToAdd.BackgroundImageID;
                this.editedWallboard.FirstSlideType = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleID;
                this.editedWallboard.FirstSlideKey = this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey;
            }
        }
        catch (error) {
            console.log(error);
        } finally {
            this.isDataSaving = false;
        }
    }

    /**
     * Returns the ID of the racing theme image corresponding to the provided name.
     * @param themeName Name of the racing theme to get the background image ID of
     * */
    public racingThemePreviewImageId(themeName: string): number {
        switch (themeName) {
            case `Random`:
                return -124;
            case `Horse Derby`:
                return -60;
            case `Motocross`:
                return -61;
            case `Rocket Race`:
                return -62;
            case `Swim Meet`:
                return -63;
            case `ATV Racing`:
                return -96;
            case `Boat Racing`:
                return -97;
            case `Drag Racing`:
                return -98;
            case `Formula One Racing`:
                return -99;
            case `Jet Racing`:
                return -100;
            case `Truck Racing`:
                return -101;
            case `Raptor Racing`:
                return -102;
            case `Snail Racing`:
                return -103;
            case `Snowmobile Racing`:
                return -104;
            case `Street Racing`:
                return -105;
            case `Tortoise And Hare Racing`:
                return -106;
            case `UFO Racing`:
                return -107;
            case `Train Racing`:
                return -110;
            case `Christmas Tree Racing`:
                return -111;
            case `Cupid Racing`:
                return -112;
            case `Easter Bunny Racing`:
                return -113;
            case `Elderly Racing`:
                return -114;
            case `Fish Racing`:
                return -115;
            case `Robot Racing`:
                return -116;
            case `Sleigh Ride Racing`:
                return -117;
            case `St Patricks Day Racing`:
                return -118;
            case `Super Racing`:
                return -119;
            case `Turkey Racing`:
                return -120;
            case `Zombie Racing`:
                return -121;
            case `St Patricks Day Racing 2`:
                return -125;
            case `Thanksgiving Racing 1`:
                return -126;
            case `Thanksgiving Racing 2`:
                return -127;
            case `Easter Racing 2`:
                return -128;
            case `Valentine Racing 1`:
                return -129;
            case `Candy Land Racing`:
                return -130;
            case `Christmas Carol Racing`:
                return -131;
            case `Halloween Racing 1`:
                return -132;
            case `Jungle Racing 1`:
                return -133;
            case `Jungle Racing 2`:
                return -134;
            case `Mask Racing`:
                return -135;
            case `Plant Racing`:
                return -136;
            default:
                return -54;
        }
    }

    /**
     * Returns the localized name of the inputted racing theme.
     * @param themeName Name of the racing theme to get the localized name of
     * */
    public racingThemeName(themeName: string): string {
        if (themeName == `Random`)
            return this.localization.get(`Random_Racing`);

        return this.localization.get(themeName.replace(/ /g, `_`));
    }

    /**
     * Returns the filename (without extention) of the transition image corresponding to the provided ID.
     * @param transitionId ID of the transition to get the filename of
     */
    public transitionImageName(transitionId: number, capitalized: boolean): string {
        switch (transitionId) {
            case 0:
                return capitalized ? `None` : `none`;
            case 4:
                return capitalized ? `Fade` : `fade`;
            case 5:
                return capitalized ? `Flip` : `flip`;
            case 6:
                return capitalized ? `Pin_Hole` : `pin_hole`;
            case 8:
                return capitalized ? `Slide_Bottom` : `slide_bottom`;
            case 9:
                return capitalized ? `Slide_Left` : `slide_left`;
            case 10:
                return capitalized ? `Slide_Right` : `slide_right`;
            case 11:
                return capitalized ? `Slide_Top` : `slide_top`;
            default:
                return "";
        }
    }

    /**
     * Changes the current slide's transition to that of transitionId and saves it to the database, unless the inputted ID is the same as the old one, in which case this will do nothing.
     * @param transitionId ID of the transition to set the current slide to
     */
    public async setSlideTransition(transitionId: number): Promise<void> {
        this.runTransitionPreview(transitionId);
        if (this.slideToAdd.TransitionID == transitionId)
            return;

        this.slideToAdd.TransitionID = transitionId;

        try {
            await this.wallboardsService.updateSlide(this.slideToAdd);
            this.editedWallboard.Slides[this.selectedSlideIndex].TransitionID = this.slideToAdd.TransitionID;
            this.editedWallboardOriginal.Slides[this.selectedSlideIndex].TransitionID = this.slideToAdd.TransitionID;
        }
        catch (error) {
            console.log(error);
        }
    }

    /**
     * Causes the main box to perform a preview of the specified transition type.
     * @param transitionId ID of the transition to preview
     */
    public runTransitionPreview(transitionId: number): void {
        if (this.transitionEvent) {
            this.transitionPreview = false;
            clearTimeout(this.transitionEvent);
            this.transitionEvent = null;

            setTimeout(() => {
                this.runTransitionPreview(transitionId);
            });
        }
        else {
            const slideContainer = $('#mainSectionBox').children();

            this.transitionPreview = true;
            this.transitionType = transitionId;

            if (this.transitionType == 4) {
                slideContainer.fadeOut(1000);
                this.transitionEvent = setTimeout(() => {
                    slideContainer.css('display', ''); // fadeOut sets dispaly:none, so this clears it to make the element visible again after the preview ends
                }, 1100); // setTimeout here takes a parameter of 1100 ms, or 1.1 sec (1 sec for the preview to run, then wait .1 and make it visible again)
            }

            this.transitionEvent = setTimeout(() => {
                this.transitionPreview = false;
                this.transitionEvent = null;
            }, 1000);
        }
    }

    /**
     * Opens the error dialog and sets the title and body text for it.
     * @param key Localization key for the body; the title's key is the same as the body, but with "_Title" appended to the end; all are in the Wallboard_Management_Messages section
     * @param replacement Optional; text that will replace "{0}" in the localized body string
     */
    public openErrorDialog(key: string, replacement?: string): void {
        this.errorDialogOpen = true;
        this.errorDialogBody = "";
        this.errorDialogKey = key;
        if (replacement)
            this.errorDialogBody = this.localizationMessages.get(key).replace(`{0}`, replacement);
    }

    /**
     * Loads list of logins.
     * */
    public async loadLoginList(): Promise<void> {
        if (this.loginListCreatorId != this.editedWallboard.CreatorLoginID) {
            try {
                this.loginListCreatorId = this.editedWallboard.CreatorLoginID;
                this.loginList = await this.wallboardsService.loadLoginList(this.loginListCreatorId);
            }
            catch (error) {
                console.log(error);
            }
        }
    }

    /**
     * Loads the login info for the Spotlight slide type.
     * */
    public async loadSpotlightLoginInfo(): Promise<void> {
        if (this.spotlightSetupObj.LoginID != this.spotlightLoadedLoginId) {
            try {
                const userProfile = await this.wallboardsService.loadSpotlightLoginInfo(this.spotlightSetupObj.LoginID);
                this.spotlightLoadedLoginId = this.spotlightSetupObj.LoginID;
                this.spotlightLoadedProfile = userProfile;
            }
            catch (error) {
                console.log(error);
            }
        }
    }

    /**
     * Gets whether the gamification package is active for the current user.
     * @param companyId CompanyID for current user
     */
    public async getGamificationPackageStatus(companyId: number): Promise<void> {
        try {
            const cvPackages = await this.wallboardsService.loadSalesPackagesByCompanyId(companyId);
            const gamificationPackage = cvPackages.filter((cvPackage) => cvPackage.PackageID == 3)[0];

            this.hasGamificationPackage = !!gamificationPackage && (gamificationPackage.Activated && gamificationPackage.AllUserAccess);
        }
        catch (error) {
            console.log(error);
        }
    }

    /**
     * Closes currently opened modal.
     * @param save Optional, is false by default; false is a cancel action, true is a save action
     * */
    public async closeCurrentModal(save = false): Promise<void> {
        const modulesRequiringMetrics = [
            ModuleType.Gauge,
            ModuleType.Thermometer,
            ModuleType.SummaryModule,
            ModuleType.Top,
            ModuleType.Kpi,
        ];

        let isNew = false;

        if (this.errorDialogOpen) {
            this.errorDialogOpen = false;
            return;
        }

        if (this.slideSettingsModalOpen || this.slideoutSettingsOpen) {
            const moduleIndex = this.selectedModuleIndex == -1 ? 0 : this.selectedModuleIndex;
            this.selectedModuleIndex = -1;
            let moduleKey;
            if (!save) {
                moduleKey = this.slideToAdd.WallboardModuleDetails[moduleIndex]?.WallboardModuleKey;
                this.slideToAdd = angular.copy(this.editedWallboard.Slides[this.selectedSlideIndex]);

                // If a new slide is canceled before saving, the selectedSlideType will be set back to the previously selected slide type
                if (this.slideToAdd) {
                    let firstModuleDetails = this.slideToAdd.WallboardModuleDetails[0];

                    if (this.slideToAdd.WallboardModuleDetails.length > 0 && SlideModuleTypes.includes(firstModuleDetails.WallboardModuleID))
                        this.selectedSlideType = firstModuleDetails.WallboardModuleID;
                    else
                        this.selectedSlideType = 0;
                }
            }

            setTimeout(() => { this.generateModulePreviews(); }, 10);

            switch (this.SettingsModuleType) {
                case ModuleType.Summary:
                    if (!save) {
                        const index = this.editedWallboard.Slides.findIndex(slide => slide.WallboardSlideID === 0);
                        if (index !== -1) {
                            this.editedWallboard.Slides.splice(index, 1);
                            this.selectedSlideIndex = this.editedWallboard.Slides.length > 0 ? 0 : -1;
                            this.slideoutSettingsOpen = false;
                            this.slideToAdd = this.selectedSlideIndex >= 0 ? angular.copy(this.editedWallboard.Slides[this.selectedSlideIndex]) : null;
                            isNew = true;
                        }
                        else {
                            this.summarySetupObj.ShowRank = this.originalSlideSettings.GeneralWallboardSettings.ShowRanking;
                            this.summarySetupObj.SummaryTitle = this.originalSlideSettings.GeneralWallboardSettings.ShowTitle ? this.originalSlideSettings.GeneralWallboardSettings.SlideName : "";
                            
                            setTimeout(() => { this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettingsOpen = false; }, 0);
                            this.slideoutSettingsOpen = false;

                            await this.wallboardsService.revertControlStates(this.editedWallboard.CreatorLoginID, moduleKey);
                            await this.loadSlideoutSettings();
                            this.controlsLoadId++;
                            await this.loadEditSlideControls(moduleKey, 10);
                        }
                    }
                    else {
                        this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettingsOpen = false;
                        this.slideoutSettingsOpen = false;
                    }
                    break;
                case ModuleType.IntervalChart:
                    setTimeout(() => { this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettingsOpen = false; }, 0);
                    this.slideoutSettingsOpen = false;
                    break;
                case ModuleType.CurrentAgentStates:
                case ModuleType.ResponsiveCurrentAgentStates:
                    if (this.cvConfigurationService.isCxOne) {
                        if (!save)
                            this.wallboardsService.revertControlStates(this.editedWallboard.CreatorLoginID, moduleKey);
                        break;
                    }
                    if (!save) {
                        const index = this.editedWallboard.Slides.findIndex(slide => slide.WallboardSlideID === 0);
                        if (index !== -1) {
                            this.editedWallboard.Slides.splice(index, 1);
                            this.selectedSlideIndex = this.editedWallboard.Slides.length > 0 ? 0 : -1;
                            this.slideoutSettingsOpen = false;
                            this.slideToAdd = this.selectedSlideIndex >= 0 ? angular.copy(this.editedWallboard.Slides[this.selectedSlideIndex]) : null;
                            isNew = true;
                        }
                        else {
                            this.currentAgentStatesSetupObj.SlideTitle = this.originalSlideSettings.GeneralWallboardSettings.ShowTitle ? this.originalSlideSettings.GeneralWallboardSettings.SlideName : "";
                            
                            setTimeout(() => { this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettingsOpen = false; }, 0);
                            this.slideoutSettingsOpen = false;

                            await this.wallboardsService.revertControlStates(this.editedWallboard.CreatorLoginID, moduleKey);
                            await this.loadSlideoutSettings();
                            this.controlsLoadId++;
                            await this.loadEditSlideControls(moduleKey, 10);
                        }
                    }
                    else {
                        this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettingsOpen = false;
                        this.slideoutSettingsOpen = false;
                    }
                    break;
                case ModuleType.Leaderboard:
                case ModuleType.Racing:
                case ModuleType.Gauge:
                case ModuleType.Thermometer:
                case ModuleType.SummaryModule:
                case ModuleType.Top:
                case ModuleType.AgentCounter:
                case ModuleType.Kpi:
                case ModuleType.Games:
                case ModuleType.Challenges:
                case ModuleType.Marketplace:
                    if (!save)
                        this.wallboardsService.revertControlStates(this.editedWallboard.CreatorLoginID, moduleKey);
                    break;
                case ModuleType.Image:
                case ModuleType.ImageModule:
                    this.imageSetupObj.UploadedImageString = null;
                    break;
                case ModuleType.Video:
                    this.videoInfo = null;
                    break;
                case ModuleType.Spotlight:
                    this.spotlightSearch = "";
                    this.spotlightSetupObj.UploadedImageString = null;
                    this.spotlightCroppedImage = null;
                    break;
                default:
                    break;
            }

            this.selectedModuleType = ModuleType.Custom;
            this.slideSettingsModalOpen = false;
            // if we are editing a new slide, then we don't need to set the first slide
            if (!save && isNew && this.isModuleWithSlideout(this.SettingsModuleType)) {
                // set first slide if user cancel the slideout
                const firstSlide = this.editedWallboard.Slides[0];
                this.slideToAdd = angular.copy(this.editedWallboard.Slides[0]);
                if (firstSlide.WallboardModuleDetails.length > 0 && SlideModuleTypes.includes(firstSlide.WallboardModuleDetails[0].WallboardModuleID))
                    this.selectedSlideType = firstSlide.WallboardModuleDetails[0].WallboardModuleID;
                else
                    this.selectedSlideType = 0;
            }
            return;
        }

        if (this.newSlideModalOpen) {
            this.selectedSlideType = -1;
            const slideIndex = this.selectedSlideIndex;
            this.selectedSlideIndex = -1;

            this.selectSlide(slideIndex);

            this.newSlideModalOpen = false;
            return;
        }

        this.confirmationDialogOpen = 0;
        this.settingsModalOpen = false;
        this.slideSettingsModalOpen = false;
        this.uploadBackgroundModalOpen = false;
    }

    /**
     * Addresses a problem with binding ngModel within an ngFor.
     */
    public trackByIndex(index: number, obj: any) {
        return index;
    }

    /**
     * Applies filter to the main AG Grid.
     * */
    public applyFilter() {
        if (this.gridApi)
            this.gridApi.onFilterChanged();
    }

    /**
     * Applies filter to the marketplace AG Grid.
     * */
    public applyMarketplaceFilter() {
        if (this.gridApiMarketplace)
            this.gridApiMarketplace.onFilterChanged();
    }

    async loadSlideoutSettings() {
        this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettingsLoaded = false;
        const key = this.slideToAdd?.WallboardModuleDetails[0]?.WallboardModuleKey;
        this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettings = null;

        const isCurrentAgentState = this.SettingsModuleType === ModuleType.CurrentAgentStates || this.SettingsModuleType === ModuleType.ResponsiveCurrentAgentStates;
        const ShowTitle = isCurrentAgentState;
        const UsePagination = !isCurrentAgentState;
        const UseTotalsRow = !isCurrentAgentState;

        if(!this.dateRangeLoaded || !this.availableDateRanges)
            await this.loadDateRanges(this.slideToAdd.WallboardID, key);

        if (this.slideToAdd.WallboardSlideID === 0) {
            //this is a new slide so we're setting defaults
            this.slideSettings = new WallboardSlideSettings();
            this.slideSettings.AvailableDateRanges = this.availableDateRanges;
            this.slideSettings.DateRange = ModuleManagerDateRangeInfo.fromObject(
                { name: "Today", displayName: "Today", utcOffset: 0 });
            this.slideSettings.DaysOfWeek = 127 as DOW;
            this.slideSettings.EmpSelectorDTO = {
                ApplicationID: 0,
                PageName: "",
                SelectedGroupLevel: 1,
                SelectedGroupType: BaseGroupType.Employee,
                SelectedMinLevel: 1,
                SelectedMaxLevel: 3,
                _SelectedGroup1IDList: [0],
                _SelectedGroup2IDList: [0],
                _SelectedGroup3IDList: [0],
                _SelectedGroup4IDList: [0],
                _SelectedGroup5IDList: [0],
                ModuleRender: false,
                ShiftRender: false,
                AllSelected: false,
                toggleGroupData: false
            };
            this.slideSettings.RecSelectorDTO = {
                ApplicationID: 0,
                PageName: "",
                SelectedGroupLevel: 1,
                SelectedGroupType: BaseGroupType.Recording,
                SelectedMinLevel: 1,
                SelectedMaxLevel: 4,
                _SelectedGroup1IDList: [0],
                _SelectedGroup2IDList: [0],
                _SelectedGroup3IDList: [0],
                _SelectedGroup4IDList: [0],
                _SelectedGroup5IDList: [0],
                ModuleRender: false,
                ShiftRender: false,
                AllSelected: false,
                toggleGroupData: false
            };
            this.slideSettings.SelectedMetrics = [];
            const timeSelector = {
                IsTimeSelectorEnabled: false,
                InvertTimeSelector: false,
                MinTime: 0,
                MaxTime: 0
            };
            this.slideSettings.TimeSelector = timeSelector;
            const generalWallboardSettings = {
                SlideName: this.slideToAdd.SlideName,
                SlideDuration: null,
                UseBackdrop: true,
                UsePagination,
                UseTotalsRow,
                ShowRanking: false,
                ShowTitle
            };
            this.slideSettings.GeneralWallboardSettings = generalWallboardSettings;
            this.slideSettings.SelectedLevelName = "";
            this.slideSettings.SelectedToggle = BaseGroupType.Employee;
            this.slideSettings.DataAttributesModel = {
                GroupedCategoryID: 0,
                SelectedCategories: [],
                Type: AttributeType.Data
            };
            this.slideSettings.ColumnSortSettings = { ColumnToSort: 0, SortAscending: true}
        }
        else {
            try {
                //loading existing slide settings for slideout
                const settings = await this.wallboardsService.loadSlideoutSettings(this.slideToAdd.WallboardID, key, this.slideToAdd.WallboardSlideID);
                this.slideSettings = settings;
                this.slideSettings.AvailableDateRanges = this.availableDateRanges;
                this.slideSettings.DateRange = ModuleManagerDateRangeInfo.fromObject({ name: settings.DateRange, displayName: settings.DateRange, utcOffset: 0 });
            }
            catch{ }  
        }
        this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettings = angular.copy(this.slideSettings);
        this.originalSlideSettings = angular.copy(this.slideSettings);
        this.editedWallboard.Slides[this.selectedSlideIndex].SlideoutSettingsLoaded = true;
    }

    /**
     * Loads Available Date Ranges for settings slideout.
     * */
    async loadDateRanges(wallboardId: number, moduleKey: string) {
        try {
            const data = await this.wallboardsService.loadAvailableDateRanges(wallboardId, moduleKey);
            this.availableDateRanges = data.AvailableDateRanges?.map(d => ModuleManagerDateRangeInfo.fromObject(d));
            this.dateRangeLoaded = true;
        }
        catch{
            this.dateRangeLoaded = false;
        } 
    }

    changeSlideoutTitle(event){
        const { title = '', ShowTitle = false }: { title: string, ShowTitle: boolean } = event;
        if (this.SettingsModuleType === ModuleType.CurrentAgentStates || this.SettingsModuleType === ModuleType.ResponsiveCurrentAgentStates) {
            this.currentAgentStatesSetupObj.SlideTitle = ShowTitle ? title : '';
        }
    }

    async saveSlideoutSettings(event) {
        const key = this.slideToAdd?.WallboardModuleDetails[0].WallboardModuleKey;
        const settings = event.settingsManager as SlideoutSettingsManager;
        const metricEventObjs: MetricEventObj[] = [];
        const selectedMetrics: number[] = [];

        for (const metricInfo of settings.selectedMetrics) {
            const metricEventObj: MetricEventObj = {
                mID: metricInfo.Id,
                mName: metricInfo.Name,
                DisplayName: metricInfo?.CustomName ? metricInfo?.CustomName + "*" : metricInfo.Name,
                mAbr: metricInfo.Abbreviation,
                mCT: metricInfo.ConversionType,
                mDir: metricInfo.Direction
            };
            metricEventObjs.push(metricEventObj);
            selectedMetrics.push(metricInfo.Id);
        }

        if ((this.SettingsModuleType === ModuleType.CurrentAgentStates || this.SettingsModuleType === ModuleType.ResponsiveCurrentAgentStates) && !settings.generalWallboardSettings.SlideDuration) {
            settings.generalWallboardSettings.SlideDuration = WallboardsService.CAS_SLIDE_DURATION; // 30 seconds by default
        }
        this.selectedMetricInfo = metricEventObjs;
        this.slideToAdd.SlideName = settings.generalWallboardSettings.SlideName;
        this.slideToAdd.SlideInterval = settings.generalWallboardSettings.SlideDuration;

        await this.saveSlideSettings();

        if (this.selectedMetricInfo.length > 0) {
            //update selected metric info and get selected metric ids
            const settingsToSave = {
                DateRange: settings.selectedDateRange.name,
                ModuleKey: key,
                DaysOfWeek: settings.selectedDaysOfWeek,
                TimeSelector: {
                    TimeSelectorEnabled: settings.isTimeSelectorEnabled,
                    InvertTimeSelector: settings.invertTimeSelector,
                    MinTime: settings.minTime,
                    MaxTime: settings.maxTime
                },
                GeneralWallboardSettings: settings.generalWallboardSettings,
                SelectedMetricIds: selectedMetrics,
                ColumnSortSettings: settings.wallboardColumnSortSettings,
            }
            this.slideToAdd.SlideInterval = settings.generalWallboardSettings.SlideDuration;
            this.slideToAdd.HasBackdrop = settings.generalWallboardSettings.UseBackdrop;
            this.slideToAdd.HasTotalsRow = settings.generalWallboardSettings.UseTotalsRow;
            this.slideToAdd.HasPagination = settings.generalWallboardSettings.UsePagination;

            if (this.selectedSlideType === ModuleType.Summary) {
                this.summarySetupObj.ShowRank = settings.generalWallboardSettings.ShowRanking;
                this.summarySetupObj.SummaryTitle = settings.generalWallboardSettings.SlideName ?? "";
            }
            await this.wallboardsService.saveSlideoutSettings(this.slideToAdd.WallboardID, key, this.slideToAdd.WallboardSlideID, settingsToSave);
            this.closeCurrentModal(true);
            await this.loadSlideoutSettings();
            this.controlsLoadId++;
            await this.loadEditSlideControls(this.slideToAdd.WallboardModuleDetails[0].WallboardModuleKey, 10);
        }
    }

    syncSlideSettings(event) {
        /*this allows the slideout settings to share what currently selected slide settings are,
        so this can match the behavior of the old modal settings where the slide preview reflects some changes
        like the totals row or backdrop being hidden/shown as the user selects them in the settings*/
        this.slideToAdd.HasBackdrop = event.UseBackdrop;
        this.slideToAdd.HasTotalsRow = event.UseTotalsRow;
        this.slideToAdd.HasPagination = event.UsePagination;

        if(this.summarySetupObj){
            this.summarySetupObj.ShowRank = event.ShowRanking;
            this.summarySetupObj.SummaryTitle = event.ShowTitle ? this.slideSettings.GeneralWallboardSettings.SlideName : "";
        }
    }

}
